function __classPrivateFieldGet(t,e,o,i){if("a"===o&&!i)throw new TypeError("Private accessor was defined without a getter");if("function"==typeof e?t!==e||!i:!e.has(t))throw new TypeError("Cannot read private member from an object whose class did not declare it");return"m"===o?i:"a"===o?i.call(t):i?i.value:e.get(t)}function __classPrivateFieldSet(t,e,o,i,r){if("m"===i)throw new TypeError("Private method is not writable");if("a"===i&&!r)throw new TypeError("Private accessor was defined without a setter");if("function"==typeof e?t!==e||!r:!e.has(t))throw new TypeError("Cannot write private member to an object whose class did not declare it");return"a"===i?r.call(t,o):r?r.value=o:e.set(t,o),o}"function"==typeof SuppressedError&&SuppressedError;
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$7=window,e$b=t$7.ShadowRoot&&(void 0===t$7.ShadyCSS||t$7.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$a=Symbol(),n$b=new WeakMap;let o$a=class{constructor(t,e,o){if(this._$cssResult$=!0,o!==s$a)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e}get styleSheet(){let t=this.o;const e=this.t;if(e$b&&void 0===t){const o=void 0!==e&&1===e.length;o&&(t=n$b.get(e)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),o&&n$b.set(e,t))}return t}toString(){return this.cssText}};const r$7=t=>new o$a("string"==typeof t?t:t+"",void 0,s$a),S$2=(t,e)=>{e$b?t.adoptedStyleSheets=e.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):e.forEach((e=>{const o=document.createElement("style"),i=t$7.litNonce;void 0!==i&&o.setAttribute("nonce",i),o.textContent=e.cssText,t.appendChild(o)}))},c$2=e$b?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const o of t.cssRules)e+=o.cssText;return r$7(e)})(t):t
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */;var s$9;const e$a=window,r$6=e$a.trustedTypes,h$3=r$6?r$6.emptyScript:"",o$9=e$a.reactiveElementPolyfillSupport,n$a={toAttribute(t,e){switch(e){case Boolean:t=t?h$3:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t)}return t},fromAttribute(t,e){let o=t;switch(e){case Boolean:o=null!==t;break;case Number:o=null===t?null:Number(t);break;case Object:case Array:try{o=JSON.parse(t)}catch(t){o=null}}return o}},a$4=(t,e)=>e!==t&&(e==e||t==t),l$6={attribute:!0,type:String,converter:n$a,reflect:!1,hasChanged:a$4},d$2="finalized";let u$2=class extends HTMLElement{constructor(){super(),this._$Ei=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$El=null,this._$Eu()}static addInitializer(t){var e;this.finalize(),(null!==(e=this.h)&&void 0!==e?e:this.h=[]).push(t)}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((e,o)=>{const i=this._$Ep(o,e);void 0!==i&&(this._$Ev.set(i,o),t.push(i))})),t}static createProperty(t,e=l$6){if(e.state&&(e.attribute=!1),this.finalize(),this.elementProperties.set(t,e),!e.noAccessor&&!this.prototype.hasOwnProperty(t)){const o="symbol"==typeof t?Symbol():"__"+t,i=this.getPropertyDescriptor(t,o,e);void 0!==i&&Object.defineProperty(this.prototype,t,i)}}static getPropertyDescriptor(t,e,o){return{get(){return this[e]},set(i){const r=this[t];this[e]=i,this.requestUpdate(t,r,o)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l$6}static finalize(){if(this.hasOwnProperty(d$2))return!1;this[d$2]=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),void 0!==t.h&&(this.h=[...t.h]),this.elementProperties=new Map(t.elementProperties),this._$Ev=new Map,this.hasOwnProperty("properties")){const t=this.properties,e=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const o of e)this.createProperty(o,t[o])}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(t){const e=[];if(Array.isArray(t)){const o=new Set(t.flat(1/0).reverse());for(const t of o)e.unshift(c$2(t))}else void 0!==t&&e.push(c$2(t));return e}static _$Ep(t,e){const o=e.attribute;return!1===o?void 0:"string"==typeof o?o:"string"==typeof t?t.toLowerCase():void 0}_$Eu(){var t;this._$E_=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Eg(),this.requestUpdate(),null===(t=this.constructor.h)||void 0===t||t.forEach((t=>t(this)))}addController(t){var e,o;(null!==(e=this._$ES)&&void 0!==e?e:this._$ES=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(o=t.hostConnected)||void 0===o||o.call(t))}removeController(t){var e;null===(e=this._$ES)||void 0===e||e.splice(this._$ES.indexOf(t)>>>0,1)}_$Eg(){this.constructor.elementProperties.forEach(((t,e)=>{this.hasOwnProperty(e)&&(this._$Ei.set(e,this[e]),delete this[e])}))}createRenderRoot(){var t;const e=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return S$2(e,this.constructor.elementStyles),e}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var e;return null===(e=t.hostConnected)||void 0===e?void 0:e.call(t)}))}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$ES)||void 0===t||t.forEach((t=>{var e;return null===(e=t.hostDisconnected)||void 0===e?void 0:e.call(t)}))}attributeChangedCallback(t,e,o){this._$AK(t,o)}_$EO(t,e,o=l$6){var i;const r=this.constructor._$Ep(t,o);if(void 0!==r&&!0===o.reflect){const n=(void 0!==(null===(i=o.converter)||void 0===i?void 0:i.toAttribute)?o.converter:n$a).toAttribute(e,o.type);this._$El=t,null==n?this.removeAttribute(r):this.setAttribute(r,n),this._$El=null}}_$AK(t,e){var o;const i=this.constructor,r=i._$Ev.get(t);if(void 0!==r&&this._$El!==r){const t=i.getPropertyOptions(r),n="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==(null===(o=t.converter)||void 0===o?void 0:o.fromAttribute)?t.converter:n$a;this._$El=r,this[r]=n.fromAttribute(e,t.type),this._$El=null}}requestUpdate(t,e,o){let i=!0;void 0!==t&&(((o=o||this.constructor.getPropertyOptions(t)).hasChanged||a$4)(this[t],e)?(this._$AL.has(t)||this._$AL.set(t,e),!0===o.reflect&&this._$El!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,o))):i=!1),!this.isUpdatePending&&i&&(this._$E_=this._$Ej())}async _$Ej(){this.isUpdatePending=!0;try{await this._$E_}catch(t){Promise.reject(t)}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Ei&&(this._$Ei.forEach(((t,e)=>this[e]=t)),this._$Ei=void 0);let e=!1;const o=this._$AL;try{e=this.shouldUpdate(o),e?(this.willUpdate(o),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var e;return null===(e=t.hostUpdate)||void 0===e?void 0:e.call(t)})),this.update(o)):this._$Ek()}catch(t){throw e=!1,this._$Ek(),t}e&&this._$AE(o)}willUpdate(t){}_$AE(t){var e;null===(e=this._$ES)||void 0===e||e.forEach((t=>{var e;return null===(e=t.hostUpdated)||void 0===e?void 0:e.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$Ek(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$E_}shouldUpdate(t){return!0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,e)=>this._$EO(e,this[e],t))),this._$EC=void 0),this._$Ek()}updated(t){}firstUpdated(t){}};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t$6;u$2[d$2]=!0,u$2.elementProperties=new Map,u$2.elementStyles=[],u$2.shadowRootOptions={mode:"open"},null==o$9||o$9({ReactiveElement:u$2}),(null!==(s$9=e$a.reactiveElementVersions)&&void 0!==s$9?s$9:e$a.reactiveElementVersions=[]).push("1.6.3");const i$5=window,s$8=i$5.trustedTypes,e$9=s$8?s$8.createPolicy("lit-html",{createHTML:t=>t}):void 0,o$8="$lit$",n$9=`lit$${(Math.random()+"").slice(9)}$`,l$5="?"+n$9,h$2=`<${l$5}>`,r$5=document,u$1=()=>r$5.createComment(""),d$1=t=>null===t||"object"!=typeof t&&"function"!=typeof t,c$1=Array.isArray,v=t=>c$1(t)||"function"==typeof(null==t?void 0:t[Symbol.iterator]),a$3="[ \t\n\f\r]",f=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,_$1=/-->/g,m$2=/>/g,p$1=RegExp(`>|${a$3}(?:([^\\s"'>=/]+)(${a$3}*=${a$3}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`,"g"),g=/'/g,$=/"/g,y=/^(?:script|style|textarea|title)$/i,w=t=>(e,...o)=>({_$litType$:t,strings:e,values:o}),x=w(1),b=w(2),T=Symbol.for("lit-noChange"),A=Symbol.for("lit-nothing"),E=new WeakMap,C=r$5.createTreeWalker(r$5,129,null,!1);function P(t,e){if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return void 0!==e$9?e$9.createHTML(e):e}const V=(t,e)=>{const o=t.length-1,i=[];let r,n=2===e?"<svg>":"",s=f;for(let e=0;e<o;e++){const o=t[e];let a,l,c=-1,d=0;for(;d<o.length&&(s.lastIndex=d,l=s.exec(o),null!==l);)d=s.lastIndex,s===f?"!--"===l[1]?s=_$1:void 0!==l[1]?s=m$2:void 0!==l[2]?(y.test(l[2])&&(r=RegExp("</"+l[2],"g")),s=p$1):void 0!==l[3]&&(s=p$1):s===p$1?">"===l[0]?(s=null!=r?r:f,c=-1):void 0===l[1]?c=-2:(c=s.lastIndex-l[2].length,a=l[1],s=void 0===l[3]?p$1:'"'===l[3]?$:g):s===$||s===g?s=p$1:s===_$1||s===m$2?s=f:(s=p$1,r=void 0);const h=s===p$1&&t[e+1].startsWith("/>")?" ":"";n+=s===f?o+h$2:c>=0?(i.push(a),o.slice(0,c)+o$8+o.slice(c)+n$9+h):o+n$9+(-2===c?(i.push(void 0),e):h)}return[P(t,n+(t[o]||"<?>")+(2===e?"</svg>":"")),i]};class N{constructor({strings:t,_$litType$:e},o){let i;this.parts=[];let r=0,n=0;const s=t.length-1,a=this.parts,[l,c]=V(t,e);if(this.el=N.createElement(l,o),C.currentNode=this.el.content,2===e){const t=this.el.content,e=t.firstChild;e.remove(),t.append(...e.childNodes)}for(;null!==(i=C.nextNode())&&a.length<s;){if(1===i.nodeType){if(i.hasAttributes()){const t=[];for(const e of i.getAttributeNames())if(e.endsWith(o$8)||e.startsWith(n$9)){const o=c[n++];if(t.push(e),void 0!==o){const t=i.getAttribute(o.toLowerCase()+o$8).split(n$9),e=/([.?@])?(.*)/.exec(o);a.push({type:1,index:r,name:e[2],strings:t,ctor:"."===e[1]?H:"?"===e[1]?L:"@"===e[1]?z:k})}else a.push({type:6,index:r})}for(const e of t)i.removeAttribute(e)}if(y.test(i.tagName)){const t=i.textContent.split(n$9),e=t.length-1;if(e>0){i.textContent=s$8?s$8.emptyScript:"";for(let o=0;o<e;o++)i.append(t[o],u$1()),C.nextNode(),a.push({type:2,index:++r});i.append(t[e],u$1())}}}else if(8===i.nodeType)if(i.data===l$5)a.push({type:2,index:r});else{let t=-1;for(;-1!==(t=i.data.indexOf(n$9,t+1));)a.push({type:7,index:r}),t+=n$9.length-1}r++}}static createElement(t,e){const o=r$5.createElement("template");return o.innerHTML=t,o}}function S$1(t,e,o=t,i){var r,n,s,a;if(e===T)return e;let l=void 0!==i?null===(r=o._$Co)||void 0===r?void 0:r[i]:o._$Cl;const c=d$1(e)?void 0:e._$litDirective$;return(null==l?void 0:l.constructor)!==c&&(null===(n=null==l?void 0:l._$AO)||void 0===n||n.call(l,!1),void 0===c?l=void 0:(l=new c(t),l._$AT(t,o,i)),void 0!==i?(null!==(s=(a=o)._$Co)&&void 0!==s?s:a._$Co=[])[i]=l:o._$Cl=l),void 0!==l&&(e=S$1(t,l._$AS(t,e.values),l,i)),e}class M{constructor(t,e){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=e}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){var e;const{el:{content:o},parts:i}=this._$AD,r=(null!==(e=null==t?void 0:t.creationScope)&&void 0!==e?e:r$5).importNode(o,!0);C.currentNode=r;let n=C.nextNode(),s=0,a=0,l=i[0];for(;void 0!==l;){if(s===l.index){let e;2===l.type?e=new R(n,n.nextSibling,this,t):1===l.type?e=new l.ctor(n,l.name,l.strings,this,t):6===l.type&&(e=new Z(n,this,t)),this._$AV.push(e),l=i[++a]}s!==(null==l?void 0:l.index)&&(n=C.nextNode(),s++)}return C.currentNode=r$5,r}v(t){let e=0;for(const o of this._$AV)void 0!==o&&(void 0!==o.strings?(o._$AI(t,o,e),e+=o.strings.length-2):o._$AI(t[e])),e++}}class R{constructor(t,e,o,i){var r;this.type=2,this._$AH=A,this._$AN=void 0,this._$AA=t,this._$AB=e,this._$AM=o,this.options=i,this._$Cp=null===(r=null==i?void 0:i.isConnected)||void 0===r||r}get _$AU(){var t,e;return null!==(e=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==e?e:this._$Cp}get parentNode(){let t=this._$AA.parentNode;const e=this._$AM;return void 0!==e&&11===(null==t?void 0:t.nodeType)&&(t=e.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,e=this){t=S$1(this,t,e),d$1(t)?t===A||null==t||""===t?(this._$AH!==A&&this._$AR(),this._$AH=A):t!==this._$AH&&t!==T&&this._(t):void 0!==t._$litType$?this.g(t):void 0!==t.nodeType?this.$(t):v(t)?this.T(t):this._(t)}k(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}$(t){this._$AH!==t&&(this._$AR(),this._$AH=this.k(t))}_(t){this._$AH!==A&&d$1(this._$AH)?this._$AA.nextSibling.data=t:this.$(r$5.createTextNode(t)),this._$AH=t}g(t){var e;const{values:o,_$litType$:i}=t,r="number"==typeof i?this._$AC(t):(void 0===i.el&&(i.el=N.createElement(P(i.h,i.h[0]),this.options)),i);if((null===(e=this._$AH)||void 0===e?void 0:e._$AD)===r)this._$AH.v(o);else{const t=new M(r,this),e=t.u(this.options);t.v(o),this.$(e),this._$AH=t}}_$AC(t){let e=E.get(t.strings);return void 0===e&&E.set(t.strings,e=new N(t)),e}T(t){c$1(this._$AH)||(this._$AH=[],this._$AR());const e=this._$AH;let o,i=0;for(const r of t)i===e.length?e.push(o=new R(this.k(u$1()),this.k(u$1()),this,this.options)):o=e[i],o._$AI(r),i++;i<e.length&&(this._$AR(o&&o._$AB.nextSibling,i),e.length=i)}_$AR(t=this._$AA.nextSibling,e){var o;for(null===(o=this._$AP)||void 0===o||o.call(this,!1,!0,e);t&&t!==this._$AB;){const e=t.nextSibling;t.remove(),t=e}}setConnected(t){var e;void 0===this._$AM&&(this._$Cp=t,null===(e=this._$AP)||void 0===e||e.call(this,t))}}class k{constructor(t,e,o,i,r){this.type=1,this._$AH=A,this._$AN=void 0,this.element=t,this.name=e,this._$AM=i,this.options=r,o.length>2||""!==o[0]||""!==o[1]?(this._$AH=Array(o.length-1).fill(new String),this.strings=o):this._$AH=A}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,e=this,o,i){const r=this.strings;let n=!1;if(void 0===r)t=S$1(this,t,e,0),n=!d$1(t)||t!==this._$AH&&t!==T,n&&(this._$AH=t);else{const i=t;let s,a;for(t=r[0],s=0;s<r.length-1;s++)a=S$1(this,i[o+s],e,s),a===T&&(a=this._$AH[s]),n||(n=!d$1(a)||a!==this._$AH[s]),a===A?t=A:t!==A&&(t+=(null!=a?a:"")+r[s+1]),this._$AH[s]=a}n&&!i&&this.j(t)}j(t){t===A?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"")}}class H extends k{constructor(){super(...arguments),this.type=3}j(t){this.element[this.name]=t===A?void 0:t}}const I=s$8?s$8.emptyScript:"";class L extends k{constructor(){super(...arguments),this.type=4}j(t){t&&t!==A?this.element.setAttribute(this.name,I):this.element.removeAttribute(this.name)}}class z extends k{constructor(t,e,o,i,r){super(t,e,o,i,r),this.type=5}_$AI(t,e=this){var o;if((t=null!==(o=S$1(this,t,e,0))&&void 0!==o?o:A)===T)return;const i=this._$AH,r=t===A&&i!==A||t.capture!==i.capture||t.once!==i.once||t.passive!==i.passive,n=t!==A&&(i===A||r);r&&this.element.removeEventListener(this.name,this,i),n&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){var e,o;"function"==typeof this._$AH?this._$AH.call(null!==(o=null===(e=this.options)||void 0===e?void 0:e.host)&&void 0!==o?o:this.element,t):this._$AH.handleEvent(t)}}class Z{constructor(t,e,o){this.element=t,this.type=6,this._$AN=void 0,this._$AM=e,this.options=o}get _$AU(){return this._$AM._$AU}_$AI(t){S$1(this,t)}}const B=i$5.litHtmlPolyfillSupport;null==B||B(N,R),(null!==(t$6=i$5.litHtmlVersions)&&void 0!==t$6?t$6:i$5.litHtmlVersions=[]).push("2.8.0");const D=(t,e,o)=>{var i,r;const n=null!==(i=null==o?void 0:o.renderBefore)&&void 0!==i?i:e;let s=n._$litPart$;if(void 0===s){const t=null!==(r=null==o?void 0:o.renderBefore)&&void 0!==r?r:null;n._$litPart$=s=new R(e.insertBefore(u$1(),t),t,void 0,null!=o?o:{})}return s._$AI(t),s
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */},t$5=window,e$8=t$5.ShadowRoot&&(void 0===t$5.ShadyCSS||t$5.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,s$7=Symbol(),n$8=new WeakMap;let o$7=class{constructor(t,e,o){if(this._$cssResult$=!0,o!==s$7)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=e}get styleSheet(){let t=this.o;const e=this.t;if(e$8&&void 0===t){const o=void 0!==e&&1===e.length;o&&(t=n$8.get(e)),void 0===t&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),o&&n$8.set(e,t))}return t}toString(){return this.cssText}};const r$4=t=>new o$7("string"==typeof t?t:t+"",void 0,s$7),i$4=(t,...e)=>{const o=1===t.length?t[0]:e.reduce(((e,o,i)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(o)+t[i+1]),t[0]);return new o$7(o,t,s$7)},S=(t,e)=>{e$8?t.adoptedStyleSheets=e.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):e.forEach((e=>{const o=document.createElement("style"),i=t$5.litNonce;void 0!==i&&o.setAttribute("nonce",i),o.textContent=e.cssText,t.appendChild(o)}))},c=e$8?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const o of t.cssRules)e+=o.cssText;return r$4(e)})(t):t
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */;var s$6;const e$7=window,r$3=e$7.trustedTypes,h$1=r$3?r$3.emptyScript:"",o$6=e$7.reactiveElementPolyfillSupport,n$7={toAttribute(t,e){switch(e){case Boolean:t=t?h$1:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t)}return t},fromAttribute(t,e){let o=t;switch(e){case Boolean:o=null!==t;break;case Number:o=null===t?null:Number(t);break;case Object:case Array:try{o=JSON.parse(t)}catch(t){o=null}}return o}},a$2=(t,e)=>e!==t&&(e==e||t==t),l$4={attribute:!0,type:String,converter:n$7,reflect:!1,hasChanged:a$2},d="finalized";class u extends HTMLElement{constructor(){super(),this._$Ei=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$El=null,this._$Eu()}static addInitializer(t){var e;this.finalize(),(null!==(e=this.h)&&void 0!==e?e:this.h=[]).push(t)}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((e,o)=>{const i=this._$Ep(o,e);void 0!==i&&(this._$Ev.set(i,o),t.push(i))})),t}static createProperty(t,e=l$4){if(e.state&&(e.attribute=!1),this.finalize(),this.elementProperties.set(t,e),!e.noAccessor&&!this.prototype.hasOwnProperty(t)){const o="symbol"==typeof t?Symbol():"__"+t,i=this.getPropertyDescriptor(t,o,e);void 0!==i&&Object.defineProperty(this.prototype,t,i)}}static getPropertyDescriptor(t,e,o){return{get(){return this[e]},set(i){const r=this[t];this[e]=i,this.requestUpdate(t,r,o)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l$4}static finalize(){if(this.hasOwnProperty(d))return!1;this[d]=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),void 0!==t.h&&(this.h=[...t.h]),this.elementProperties=new Map(t.elementProperties),this._$Ev=new Map,this.hasOwnProperty("properties")){const t=this.properties,e=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const o of e)this.createProperty(o,t[o])}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(t){const e=[];if(Array.isArray(t)){const o=new Set(t.flat(1/0).reverse());for(const t of o)e.unshift(c(t))}else void 0!==t&&e.push(c(t));return e}static _$Ep(t,e){const o=e.attribute;return!1===o?void 0:"string"==typeof o?o:"string"==typeof t?t.toLowerCase():void 0}_$Eu(){var t;this._$E_=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Eg(),this.requestUpdate(),null===(t=this.constructor.h)||void 0===t||t.forEach((t=>t(this)))}addController(t){var e,o;(null!==(e=this._$ES)&&void 0!==e?e:this._$ES=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(o=t.hostConnected)||void 0===o||o.call(t))}removeController(t){var e;null===(e=this._$ES)||void 0===e||e.splice(this._$ES.indexOf(t)>>>0,1)}_$Eg(){this.constructor.elementProperties.forEach(((t,e)=>{this.hasOwnProperty(e)&&(this._$Ei.set(e,this[e]),delete this[e])}))}createRenderRoot(){var t;const e=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return S(e,this.constructor.elementStyles),e}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var e;return null===(e=t.hostConnected)||void 0===e?void 0:e.call(t)}))}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$ES)||void 0===t||t.forEach((t=>{var e;return null===(e=t.hostDisconnected)||void 0===e?void 0:e.call(t)}))}attributeChangedCallback(t,e,o){this._$AK(t,o)}_$EO(t,e,o=l$4){var i;const r=this.constructor._$Ep(t,o);if(void 0!==r&&!0===o.reflect){const n=(void 0!==(null===(i=o.converter)||void 0===i?void 0:i.toAttribute)?o.converter:n$7).toAttribute(e,o.type);this._$El=t,null==n?this.removeAttribute(r):this.setAttribute(r,n),this._$El=null}}_$AK(t,e){var o;const i=this.constructor,r=i._$Ev.get(t);if(void 0!==r&&this._$El!==r){const t=i.getPropertyOptions(r),n="function"==typeof t.converter?{fromAttribute:t.converter}:void 0!==(null===(o=t.converter)||void 0===o?void 0:o.fromAttribute)?t.converter:n$7;this._$El=r,this[r]=n.fromAttribute(e,t.type),this._$El=null}}requestUpdate(t,e,o){let i=!0;void 0!==t&&(((o=o||this.constructor.getPropertyOptions(t)).hasChanged||a$2)(this[t],e)?(this._$AL.has(t)||this._$AL.set(t,e),!0===o.reflect&&this._$El!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,o))):i=!1),!this.isUpdatePending&&i&&(this._$E_=this._$Ej())}async _$Ej(){this.isUpdatePending=!0;try{await this._$E_}catch(t){Promise.reject(t)}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Ei&&(this._$Ei.forEach(((t,e)=>this[e]=t)),this._$Ei=void 0);let e=!1;const o=this._$AL;try{e=this.shouldUpdate(o),e?(this.willUpdate(o),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var e;return null===(e=t.hostUpdate)||void 0===e?void 0:e.call(t)})),this.update(o)):this._$Ek()}catch(t){throw e=!1,this._$Ek(),t}e&&this._$AE(o)}willUpdate(t){}_$AE(t){var e;null===(e=this._$ES)||void 0===e||e.forEach((t=>{var e;return null===(e=t.hostUpdated)||void 0===e?void 0:e.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$Ek(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$E_}shouldUpdate(t){return!0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,e)=>this._$EO(e,this[e],t))),this._$EC=void 0),this._$Ek()}updated(t){}firstUpdated(t){}}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var l$3,o$5;u[d]=!0,u.elementProperties=new Map,u.elementStyles=[],u.shadowRootOptions={mode:"open"},null==o$6||o$6({ReactiveElement:u}),(null!==(s$6=e$7.reactiveElementVersions)&&void 0!==s$6?s$6:e$7.reactiveElementVersions=[]).push("1.6.3");let s$5=class extends u{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0}createRenderRoot(){var t,e;const o=super.createRenderRoot();return null!==(t=(e=this.renderOptions).renderBefore)&&void 0!==t||(e.renderBefore=o.firstChild),o}update(t){const e=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=D(e,this.renderRoot,this.renderOptions)}connectedCallback(){var t;super.connectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!0)}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!1)}render(){return T}};s$5.finalized=!0,s$5._$litElement$=!0,null===(l$3=globalThis.litElementHydrateSupport)||void 0===l$3||l$3.call(globalThis,{LitElement:s$5});const n$6=globalThis.litElementPolyfillSupport;function redispatchEvent(t,e){!e.bubbles||t.shadowRoot&&!e.composed||e.stopPropagation();const o=Reflect.construct(e.constructor,[e.type,e]),i=t.dispatchEvent(o);return i||e.preventDefault(),i}function isInsideElement(t,e){return e.shadowRoot?t.composedPath().includes(e):null!=t.target&&e.contains(t.target)}null==n$6||n$6({LitElement:s$5}),(null!==(o$5=globalThis.litElementVersions)&&void 0!==o$5?o$5:globalThis.litElementVersions=[]).push("3.3.3");class Component extends s$5{constructor(){super(...arguments),this.emit=(t,e)=>{const o=new CustomEvent(t,{bubbles:!0,cancelable:!0,composed:!0,...e});this.dispatchEvent(o)},this.reemit=t=>{redispatchEvent(this,t)}}}function getDefaultExportFromCjs(t){return t&&t.i&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}var toSpacingCSSValue,toCSSValue,getToken$1,themes={};themes.LoadsmartTheme={"brand-color-brand":"20, 214, 77","brand-color-brand-accent-1":"0, 215, 215","brand-color-brand-accent-2":"132, 241, 30","border-radius-none":"0px","border-radius-s":"4px","border-radius-m":"8px","border-radius-l":"16px","border-radius-circle":"50%","border-none":0,"border-thin":"1px","border-medium":"2px","border-thick":"4px","color-background-primary":"252, 252, 255","color-background-secondary":"248, 249, 251","color-background-tertiary":"230, 237, 242","color-background-highlight":"202, 219, 221","color-background-inverted":"32, 41, 49","color-background-secondary-inverted":"61, 74, 85","color-border":"193, 206, 217","color-divider":"230, 237, 242","color-brand":"20, 214, 77","color-brand-accent-1":"0, 215, 215","color-brand-accent-2":"132, 241, 30","color-primary-20":"202, 219, 221","color-primary-60":"0, 84, 84","color-primary-100":"0, 51, 51","color-accent-20":"229, 245, 255","color-accent-60":"0, 98, 159","color-accent-100":"15, 66, 97","color-neutral-0":"252, 252, 255","color-neutral-10":"248, 249, 251","color-neutral-20":"230, 237, 242","color-neutral-40":"193, 206, 217","color-neutral-60":"94, 118, 138","color-neutral-80":"92, 106, 118","color-neutral-90":"61, 74, 85","color-neutral-100":"32, 41, 49","color-success-20":"227, 247, 239","color-success-60":"3, 124, 94","color-success-100":"0, 94, 71","color-danger-20":"255, 233, 230","color-danger-60":"186, 27, 27","color-danger-100":"104, 0, 3","color-warning-20":"255, 243, 214","color-warning-60":"248, 182, 14","color-warning-100":"102, 63, 25","color-text-primary":"32, 41, 49","color-text-secondary":"61, 74, 85","color-text-tertiary":"92, 106, 118","color-text-placeholder":"94, 118, 138","color-text-disabled":"193, 206, 217","color-text-inverted":"252, 252, 255","color-text-secondary-inverted":"193, 206, 217","color-text-error":"186, 27, 27","color-text-highlight":"0, 98, 159","color-text-link":"0, 84, 84","font-family-default":"'Manrope', sans-serif","font-family-title":"'PlusJakartaSans', 'Manrope', sans-serif","font-size-1":"0.625rem","font-size-2":"0.75rem","font-size-3":"0.875rem","font-size-4":"1rem","font-size-5":"1.25rem","font-size-6":"1.625rem","font-size-7":"2.375rem","font-size-8":"3rem","font-size-9":"3.625rem","font-weight-regular":500,"font-weight-medium":600,"font-weight-bold":700,"line-height-1":"100%","line-height-2":"125%","line-height-3":"130%","line-height-4":"140%","line-height-5":"150%","line-height-6":"180%","media-screen-desktop":"1025px","media-screen-tablet":"481px","opacity-0":"0%","opacity-20":"20%","opacity-40":"40%","opacity-60":"60%","opacity-100":"100%","elevation-1":"0px 0px 2px rgba(94, 118, 138, 0.1), 0px 1px 6px 2px rgba(61, 74, 85, 0.15)","elevation-2":"0px 1px 3px rgba(94, 118, 138, 0.2), 0px 4px 8px 3px rgba(61, 74, 85, 0.15)","elevation-3":"0px 0px 4px rgba(94, 118, 138, 0.2), 0px 6px 12px 6px rgba(61, 74, 85, 0.15)","elevation-4":"0px 5px 6px 4px rgba(94, 118, 138, 0.2), 0px 8px 10px rgba(61, 74, 85, 0.1)","glow-primary":"0.0px 0.0px 4.0px 0px rgb(3, 124, 94, .5)","glow-warning":"0.0px 0.0px 4.0px 0px rgba(255, 206, 79, 1.0)","spacing-1":"4px","spacing-2":"8px","spacing-3":"12px","spacing-4":"16px","spacing-5":"20px","spacing-6":"24px","spacing-8":"32px","spacing-10":"40px","spacing-12":"48px","spacing-14":"56px","spacing-16":"64px","spacing-20":"80px","spacing-30":"120px","spacing-0-5":"2px","global-height-small":"1.75rem","global-height-default":"2.5rem","global-height-large":"3rem","platform-font-default":"'Manrope', sans-serif","platform-font-title":"'PlusJakartaSans', 'Manrope', sans-serif"};var r$2=themes;function t$4(t,e,o){if(o||2===arguments.length)for(var i,r=0,n=e.length;r<n;r++)!i&&r in e||(i||(i=Array.prototype.slice.call(e,0,r)),i[r]=e[r]);return t.concat(i||Array.prototype.slice.call(e))}function e$6(t,e){return t.filter((function(t){return t.startsWith(e)}))}function o$4(t,e){return t.filter((function(t){return!t.startsWith(e)}))}"function"==typeof SuppressedError&&SuppressedError;var n$5=Object.keys(r$2.LoadsmartTheme),a$1=t$4([],o$4(o$4(n$5,"brand-"),"platform-"),!0).sort((function(t,e){return t.localeCompare(e,void 0,{numeric:!0,sensitivity:"base"})}));e$6(a$1,"color-background-"),e$6(a$1,"border-radius-"),e$6(a$1,"border-"),e$6(a$1,"color-"),e$6(a$1,"elevation-"),e$6(a$1,"font-family-"),e$6(a$1,"font-size-"),e$6(a$1,"font-weight-"),e$6(a$1,"global-"),e$6(a$1,"glow-"),e$6(a$1,"line-height-"),e$6(a$1,"opacity-");var _=e$6(a$1,"spacing-");function K(t){return r$2.LoadsmartTheme[t]}function m$1(t){var e=K(t);return null==e?e:"--m-".concat(t)}function h(t,e){var o=K(t);return null==o?"":t.startsWith("color-")?"rgba(var(".concat(m$1(t),", ").concat(o,"), ").concat(null!=e?e:1,")"):"var(".concat(m$1(t),", ").concat(o,")")}function getToken(t){return r$4(toCSSValue(t))}function getColor(t,e=1){return r$4(toCSSValue(t,e))}function mr(t){return r$4(`\n\t\tmargin-inline-end: ${t}\n\t`)}function ml(t){return r$4(`\n\t\tmargin-inline-start: ${t}\n\t`)}function mx(t){return r$4(`\n\t\t${ml(t)};\n\t\t${mr(t)}\n\t`)}function mt(t){return r$4(`\n\t\tmargin-block-start: ${t}\n\t`)}function mb(t){return r$4(`\n\t\tmargin-block-end: ${t}\n\t`)}function my(t){return r$4(`\n\t\t${mt(t)};\n\t\t${mb(t)}\n\t`)}function m(t){return r$4(`\n\t\t${mx(t)};\n\t\t${my(t)}\n\t`)}function mediaDesktop(t){return r$4(`\n\t@media screen and (min-width: ${getToken$1("media-screen-desktop")}) {\n\t\t${t}\n\t}\n`)}function mediaTablet(t){return r$4(`\n\t@media screen and (min-width: ${getToken$1("media-screen-tablet")}) {\n\t\t${t}\n\t}\n`)}e$6(a$1,"media-"),t$4(["none"],_,!0),getToken$1=K,toCSSValue=h,toSpacingCSSValue=function(t,e){var o,i=e?h(e):"";return t&&null!==(o="none"===t?"0":h(t))&&void 0!==o?o:i};var toArray=function(t){return null==t?[]:Array.isArray(t)?t:[t]},toArray$1=getDefaultExportFromCjs(toArray);const pseudoClassMap={active:[":active"],disabled:[".is-disabled",":disabled"],focus:[".is-focused",":focus",":focus-visible",":focus-within"],hover:[":hover"],visited:[":visited"]};function isPseudoClass(t){return Object.keys(pseudoClassMap).includes(t)}function isNegated(t){return t.startsWith("not.")}function joinIs(t){const e=toArray$1(t).filter((t=>""!==t.trim()));return 0===e.length?"":1===e.length?e[0]:`:is(${e.join(", ")})`}function toString(t,e,o,i){let r=joinIs(t);for(const t of i)if(isNegated(t)){const e=t.slice(4);r=`${r}:not(${pseudoClassMap[e].join(", ")})`}else r=`${r}${joinIs(pseudoClassMap[t])}`;const n=joinIs(e);if(n){let t=` ${o} `;return null==o&&(t="")," "===o&&(t=o),`${r}${t}${n}`}return r}function on(t,e,o=" "){const i=[];let r=!1;const n=new Proxy(r$4(""),{get:(s,a,l)=>"cssText"===a?toString(t,e,o,i):"not"===a?(r=!r,n):isPseudoClass(a)?(i.push(r?`not.${a}`:a),r=!1,n):Reflect.get(s,a,l)});return n}function pr(t){return r$4(`\n\t\tpadding-inline-start: ${t}\n\t`)}function pl(t){return r$4(`\n\t\tpadding-inline-end: ${t}\n\t`)}function px(t){return r$4(`\n\t\t${pl(t)};\n\t\t${pr(t)}\n\t`)}function pt(t){return r$4(`\n\t\tpadding-block-start: ${t}\n\t`)}function pb(t){return r$4(`\n\t\tpadding-block-end: ${t}\n\t`)}function py(t){return r$4(`\n\t\t${pt(t)};\n\t\t${pb(t)}\n\t`)}function p(t){return r$4(`\n\t\t${px(t)};\n\t\t${py(t)}\n\t`)}function skeleton(){return r$4("animation: skeleton-loading 1s linear infinite alternate;")}skeleton.styles=()=>i$4`
		@keyframes skeleton-loading {
			0% {
				background-color: ${getColor("color-background-tertiary")};
				opacity: 0.3;
			}
			50% {
				background-color: ${getColor("color-background-tertiary")};
				opacity: 0.6;
			}
			100% {
				background-color: ${getColor("color-background-tertiary")};
			}
		}
	`;const DEFAULT_TRANSITION_CONFIG={property:"all",delay:"0s",duration:"0.35s",easing:"ease-in-out"};function toTransition(t){const e={...DEFAULT_TRANSITION_CONFIG,...t};return r$4(`${e.property} ${e.duration} ${e.easing} ${e.delay}`)}function transition(t){const e=toArray$1(t).map((t=>toTransition(t))).join(", ");return r$4(`\n\t\ttransition: ${e}\n\t`)}const typographyVariants=["body-lg-bold","body-lg","body-md-bold-underline","body-md-bold","body-md-underline","body-md","body-sm-bold-underline","body-sm-bold","body-sm-underline","body-sm","button-lg","button-md","button-sm","chips-md","chips-sm","heading-lg-bold","heading-lg","heading-md-bold","heading-md","heading-sm-bold","heading-sm","hero-lg-bold","hero-lg","hero-md-bold","hero-md","hero-sm-bold","hero-sm","number-md","number-sm","table-header-md","table-header-sm"];function getVariant(t){switch(t){case"hero-lg-bold":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-6")};\n\t\t\t\tfont-size: ${getToken("font-size-9")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"hero-lg":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-6")};\n\t\t\t\tfont-size: ${getToken("font-size-9")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")}\n\t\t\t`;case"hero-md-bold":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-6")};\n\t\t\t\tfont-size: ${getToken("font-size-8")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"hero-md":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-6")};\n\t\t\t\tfont-size: ${getToken("font-size-8")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")}\n\t\t\t`;case"hero-sm-bold":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-6")};\n\t\t\t\tfont-size: ${getToken("font-size-7")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"hero-sm":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-6")};\n\t\t\t\tfont-size: ${getToken("font-size-7")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")}\n\t\t\t`;case"heading-lg-bold":return`\n\t\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\t\tfont-size: ${getToken("font-size-6")};\n\t\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t\t`;case"heading-lg":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\tfont-size: ${getToken("font-size-6")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")}\n\t\t\t`;case"heading-md-bold":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\tfont-size: ${getToken("font-size-5")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"heading-md":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\tfont-size: ${getToken("font-size-5")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")}\n\t\t\t`;case"heading-sm-bold":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\tfont-size: ${getToken("font-size-4")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"heading-sm":return`\n\t\t\t\tfont-family: ${getToken("font-family-title")};\n\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\tfont-size: ${getToken("font-size-4")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")}\n\t\t\t`;case"body-lg-bold":return`\n\t\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\t\tline-height: ${getToken("line-height-6")};\n\t\t\t\t\tfont-size: ${getToken("font-size-5")};\n\t\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t\t`;case"body-lg":return`\n\t\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\t\tline-height: ${getToken("line-height-6")};\n\t\t\t\t\tfont-size: ${getToken("font-size-5")};\n\t\t\t\t\tfont-weight: ${getToken("font-weight-regular")}\n\t\t\t\t`;case"body-md":case"number-md":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\tfont-size: ${getToken("font-size-3")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")}\n\t\t\t`;case"body-md-underline":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\tfont-size: ${getToken("font-size-3")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")};\n\t\t\t\ttext-decoration: underline\n\t\t\t`;case"body-md-bold":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\tfont-size: ${getToken("font-size-3")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"body-md-bold-underline":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-5")};\n\t\t\t\tfont-size: ${getToken("font-size-3")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")};\n\t\t\t\ttext-decoration: underline\n\t\t\t`;case"body-sm":case"number-sm":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-4")};\n\t\t\t\tfont-size: ${getToken("font-size-2")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")}\n\t\t\t`;case"body-sm-underline":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-4")};\n\t\t\t\tfont-size: ${getToken("font-size-2")};\n\t\t\t\tfont-weight: ${getToken("font-weight-regular")};\n\t\t\t\ttext-decoration: underline\n\t\t\t`;case"body-sm-bold":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-4")};\n\t\t\t\tfont-size: ${getToken("font-size-2")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"body-sm-bold-underline":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-4")};\n\t\t\t\tfont-size: ${getToken("font-size-2")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")};\n\t\t\t\ttext-decoration: underline\n\t\t\t`;case"button-lg":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-1")};\n\t\t\t\tfont-size: ${getToken("font-size-4")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"button-md":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-1")};\n\t\t\t\tfont-size: ${getToken("font-size-3")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"button-sm":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-1")};\n\t\t\t\tfont-size: ${getToken("font-size-2")};\n\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t`;case"table-header-md":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-1")};\n\t\t\t\tfont-size: ${getToken("font-size-3")};\n\t\t\t\tfont-weight: ${getToken("font-weight-medium")};\n\t\t\t\ttext-transform: uppercase\n\t\t\t`;case"table-header-sm":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-1")};\n\t\t\t\tfont-size: ${getToken("font-size-2")};\n\t\t\t\tfont-weight: ${getToken("font-weight-medium")}\n\t\t\t`;case"chips-md":return`\n\t\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\t\tline-height: ${getToken("line-height-1")};\n\t\t\t\t\tfont-size: ${getToken("font-size-2")};\n\t\t\t\t\tfont-weight: ${getToken("font-weight-bold")}\n\t\t\t\t`;case"chips-sm":return`\n\t\t\t\tfont-family: ${getToken("font-family-default")};\n\t\t\t\tline-height: ${getToken("line-height-1")};\n\t\t\t\tfont-size: ${getToken("font-size-1")};\n\t\t\t\tfont-weight: ${getToken("font-weight-medium")};\n\t\t\t\ttext-transform: uppercase\n\t\t\t`;default:return""}}function typography(t){const e=r$4("\n\t\tfont-style: normal;\n\t\tfont-stretch: normal;\n\t\tletter-spacing: normal;\n\n\t\tfont-synthesis: none;\n\t\ttext-rendering: optimizeLegibility;\n\t\t-webkit-font-smoothing: antialiased;\n\t\t-moz-osx-font-smoothing: grayscale;\n\t\t-webkit-text-size-adjust: 100%;\n\t");return r$4(`${e}\n${getVariant(t)}`)}function styles$I(){return i$4`
		:host {
			background-color: ${getColor("color-background-primary")};
			width: 100%;
		}

		slot[name='title']::slotted(:not(m-accordion-title)),
		slot[name='content']::slotted(:not(m-accordion-content)) {
			display: none;
		}

		.m-accordion {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			border-radius: ${getToken("border-radius-s")};
			border: 1px solid ${getColor("color-divider")};
			overflow: hidden;
		}

		.m-accordion-header {
			margin: 0;
			width: 100%;
		}

		.m-accordion-trigger {
			${typography("body-md-bold")};
			display: flex;
			margin: 0;
			cursor: pointer;
			width: 100%;
			padding: ${getToken("spacing-3")} ${getToken("spacing-4")};
			color: ${getColor("color-text-primary")};
			outline: none;
			border: none;
			align-items: center;
			background-color: ${getColor("color-background-primary")};
		}

		.m-accordion-trigger:focus {
			background-color: ${getColor("color-background-tertiary")};
		}

		.m-accordion-trigger:hover {
			background-color: ${getColor("color-background-tertiary")};
		}

		.m-accordion-trigger:active {
			background-color: ${getColor("color-background-highlight")};
		}

		.m-accordion-trigger:disabled {
			background-color: ${getColor("color-background-primary")};
			cursor: default;
			color: ${getColor("color-text-disabled")};
		}

		.m-accordion-trigger:disabled m-icon {
			--m-icon-color: ${getColor("color-text-disabled")};
		}

		.m-accordion-trigger[aria-expanded='true']:not([disabled]) m-icon {
			transform: rotate(180deg);
		}

		.m-accordion-panel {
			height: auto;
			width: 100%;
		}

		@media (prefers-reduced-motion: no-preference) {
			.m-accordion-trigger {
				${transition([{property:"background-color"}])};
			}

			m-icon {
				${transition([{property:"transform"}])};
			}

			.m-accordion-panel {
				${transition([{property:"height"},{property:"visibility"}])};
				will-change: height;
			}
		}
	`}function accordionTitleStyles(){return i$4`
		:host {
			display: flex;
			text-align: left;
			justify-content: center;
			width: 100%;
		}

		.m-accordion-text {
			flex: 1;
			padding-left: ${getToken("spacing-1")};
		}
	`}function accordionContentStyles(){return i$4`
		.m-accordion-content {
			padding: ${getToken("spacing-2")} ${getToken("spacing-4")} ${getToken("spacing-4")};
		}
	`}function styles$H(){return[i$4`
			:host {
				--m-icon-size: 16px;
				--m-icon-color: ${getColor("color-text-primary")};

				display: inline-flex;
				align-items: center;
				justify-content: center;

				inline-size: var(--m-icon-size);
				block-size: var(--m-icon-size);
			}

			svg {
				${transition([{property:"color"},{property:"fill"}])};

				inline-size: var(--m-icon-size);
				block-size: var(--m-icon-size);

				color: var(--m-icon-color);
				fill: var(--m-icon-color);
			}
		`]}const icons=new Map([["alert-circle",()=>import("./alert-circle-CaCCcnPJ.js")],["arrow-left",()=>import("./arrow-left-okq0Cmps.js")],["attention",()=>import("./attention-DbflOMJ0.js")],["bell",()=>import("./bell-CE4iXAfv.js")],["caret-down",()=>import("./caret-down-Cr4yvJs0.js")],["caret-left",()=>import("./caret-left-BNMBmLoO.js")],["caret-right",()=>import("./caret-right-Cv_ZqJTk.js")],["check",()=>import("./check-BFeghAcH.js")],["close",()=>import("./close-C_f9cA1Z.js")],["double-caret-left",()=>import("./double-caret-left-D3YW7v1G.js")],["double-caret-right",()=>import("./double-caret-right-DedLAx4F.js")],["indeterminate",()=>import("./indeterminate-Bg0WYZDN.js")],["info-circle",()=>import("./info-circle-83HLAOq8.js")]]);var _Icon_loadIcon,_Accordion_instances,_Accordion_accordionTrigger_get,_Accordion_accordionPanel_get,_Accordion_accordionContent_get,_Accordion_handleExpand,_Accordion_toggle,_Accordion_handleTransition;icons.keys();class Icon extends Component{static get properties(){return{name:{type:String},size:{type:String},color:{type:String},loading:{state:!0}}}constructor(){super(),this.icon=null,_Icon_loadIcon.set(this,(async()=>{icons.has(this.name);try{this.icon=null;const{default:t}=await icons.get(this.name)();this.icon=t}catch{}finally{this.requestUpdate()}})),this.icon=null}connectedCallback(){super.connectedCallback(),__classPrivateFieldGet(this,_Icon_loadIcon,"f").call(this)}update(t){super.update(t),t.has("name")&&__classPrivateFieldGet(this,_Icon_loadIcon,"f").call(this)}updated(t){super.updated(t),t.has("size")&&null!=this.size&&this.style.setProperty("--m-icon-size",`${parseInt(String(this.size),10)||16}px`),t.has("color")&&null!=this.color&&this.style.setProperty("--m-icon-color",toCSSValue(this.color))}render(){return null!=this.name&&icons.has(this.name)&&null!=this.icon?this.icon:A}}_Icon_loadIcon=new WeakMap,Icon.styles=[styles$H()],window.customElements.define("m-icon",Icon);class Accordion extends Component{static get properties(){return{disabled:{type:Boolean,reflect:!0},expanded:{type:Boolean,reflect:!0}}}constructor(){super(),_Accordion_instances.add(this),_Accordion_handleTransition.set(this,(()=>{this.expanded&&!this.disabled&&(__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionPanel_get).style.height="auto")})),this.disabled=!1,this.expanded=!1,this.resizeObserver=new ResizeObserver((t=>{this.panelHeight=t[0].target.scrollHeight}))}firstUpdated(){__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionContent_get).style.transition="visibility 0.35s",__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionContent_get).setAttribute("role","region"),this.resizeObserver.observe(__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionPanel_get)),__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionPanel_get).addEventListener("transitionend",__classPrivateFieldGet(this,_Accordion_handleTransition,"f"))}update(t){super.update(t),(t.has("expanded")||t.has("disabled"))&&__classPrivateFieldGet(this,_Accordion_instances,"m",_Accordion_handleExpand).call(this)}disconnectedCallback(){super.disconnectedCallback(),__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionPanel_get).removeEventListener("transitionend",__classPrivateFieldGet(this,_Accordion_handleTransition,"f")),this.resizeObserver.disconnect()}render(){return x`
			<article class="m-accordion">
				<h3 class="m-accordion-header">
					<button
						id="accordion-trigger"
						class="m-accordion-trigger"
						@click="${__classPrivateFieldGet(this,_Accordion_instances,"m",_Accordion_toggle)}"
						?disabled=${Boolean(this.disabled)}
						aria-controls="section"
						tabindex="0"
						type="button"
					>
						<slot name="title"></slot>
						<m-icon name="caret-down"></m-icon>
					</button>
				</h3>
				<section
					id="section"
					class="m-accordion-panel"
					aria-labelledby="accordion-trigger"
				>
					<slot name="content"></slot>
				</section>
			</article>
		`}}_Accordion_handleTransition=new WeakMap,_Accordion_instances=new WeakSet,_Accordion_accordionTrigger_get=function(){return this.renderRoot.querySelector(".m-accordion-trigger")},_Accordion_accordionPanel_get=function(){return this.renderRoot.querySelector(".m-accordion-panel")},_Accordion_accordionContent_get=function(){return this.querySelector("m-accordion-content")},_Accordion_handleExpand=function(){__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionTrigger_get).setAttribute("aria-expanded",`${this.expanded&&!this.disabled}`),__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionPanel_get).style.height=`${this.panelHeight}px`,this.expanded&&!this.disabled?__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionContent_get).style.visibility="visible":setTimeout((()=>{__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionPanel_get).style.height="0px",__classPrivateFieldGet(this,_Accordion_instances,"a",_Accordion_accordionContent_get).style.visibility="hidden"}))},_Accordion_toggle=function(){this.expanded=!this.expanded,this.emit("m-toggle",{detail:{name:"accordion",value:this.expanded}})},Accordion.styles=[styles$I()],window.customElements.define("m-accordion",Accordion);class AccordionTitle extends Component{static get properties(){return{slot:{type:String,reflect:!0}}}connectedCallback(){super.connectedCallback(),this.setAttribute("role","button"),this.slot="title"}render(){return x`
			<slot name="leading"></slot>
			<div class="m-accordion-text"><slot></slot></div>
		`}}AccordionTitle.styles=[accordionTitleStyles()],window.customElements.define("m-accordion-title",AccordionTitle);class AccordionContent extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}connectedCallback(){super.connectedCallback(),this.slot="content"}render(){return x`<div class="m-accordion-content"><slot></slot></div>`}}function styles$G(){return i$4`
		:host {
			display: block;
		}
	`}
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */AccordionContent.styles=[accordionContentStyles()],window.customElements.define("m-accordion-content",AccordionContent);const e$5=Symbol.for(""),l$2=t=>{if((null==t?void 0:t.r)===e$5)return null==t?void 0:t._$litStatic$},o$3=t=>({_$litStatic$:t,r:e$5}),i$3=(t,...e)=>({_$litStatic$:e.reduce(((e,o,i)=>e+(t=>{if(void 0!==t._$litStatic$)return t._$litStatic$;throw Error(`Value passed to 'literal' function must be a 'literal' result: ${t}. Use 'unsafeStatic' to pass non-literal values, but\n            take care to ensure page security.`)})(o)+t[i+1]),t[0]),r:e$5}),s$4=new Map,a=t=>(e,...o)=>{const i=o.length;let r,n;const s=[],a=[];let l,c=0,d=!1;for(;c<i;){for(l=e[c];c<i&&void 0!==(n=o[c],r=l$2(n));)l+=r+e[++c],d=!0;c!==i&&a.push(n),s.push(l),c++}if(c===i&&s.push(e[i]),d){const t=s.join("$$lit$$");void 0===(e=s$4.get(t))&&(s.raw=s,s$4.set(t,e=s)),o=a}return t(e,...o)},n$4=a(x),l$1=t=>null!=t?t:A
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */,t$3={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},e$4=t=>(...e)=>({_$litDirective$:t,values:e});
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */let i$2=class{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,e,o){this._$Ct=t,this._$AM=e,this._$Ci=o}_$AS(t,e){return this.update(t,e)}update(t,e){return this.render(...e)}};
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const o$2=e$4(class extends i$2{constructor(t){var e;if(super(t),t.type!==t$3.ATTRIBUTE||"class"!==t.name||(null===(e=t.strings)||void 0===e?void 0:e.length)>2)throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.")}render(t){return" "+Object.keys(t).filter((e=>t[e])).join(" ")+" "}update(t,[e]){var o,i;if(void 0===this.it){this.it=new Set,void 0!==t.strings&&(this.nt=new Set(t.strings.join(" ").split(/\s/).filter((t=>""!==t))));for(const t in e)e[t]&&!(null===(o=this.nt)||void 0===o?void 0:o.has(t))&&this.it.add(t);return this.render(e)}const r=t.element.classList;this.it.forEach((t=>{t in e||(r.remove(t),this.it.delete(t))}));for(const t in e){const o=!!e[t];o===this.it.has(t)||(null===(i=this.nt)||void 0===i?void 0:i.has(t))||(o?(r.add(t),this.it.add(t)):(r.remove(t),this.it.delete(t)))}return T}});var _FormControl_form,_FormControl_updateAssignedForm,_Button_instances,_Button_element_get,_Button_isDisabled,_Button_getRole,_Button_setDisabled,_Button_setTabIndex,_Button_handleClick,_Button_isLink,_Badge_instances,_Badge_counter_get,_Badge_formatCounter;class FormControl extends s$5{constructor(){super(...arguments),_FormControl_form.set(this,void 0),this.getForm=()=>__classPrivateFieldGet(this,_FormControl_form,"f"),_FormControl_updateAssignedForm.set(this,(()=>{if(this.hasAttribute("form")){const t=this.getRootNode(),e=this.getAttribute("form");__classPrivateFieldSet(this,_FormControl_form,t.getElementById(e),"f")}else __classPrivateFieldSet(this,_FormControl_form,this.closest("form"),"f")}))}static get properties(){return{form:{type:String,reflect:!0}}}updated(t){super.updated(t),(t.has("form")||null==__classPrivateFieldGet(this,_FormControl_form,"f"))&&__classPrivateFieldGet(this,_FormControl_updateAssignedForm,"f").call(this)}}function styles$F(){return i$4`
		:host {
			--m-button-background-color: transparent;
			--m-button-base-size: ${getToken("global-height-default")};
			--m-button-border-color: ${getColor("color-neutral-90")};
			--m-button-border-radius: ${getToken("border-radius-s")};
			--m-button-color: ${getColor("color-text-secondary")};
			--m-button-outline-color: ${getColor("color-primary-100")};
			--m-button-outline-offset: 2px;
			--m-button-padding-x: ${getToken("spacing-4")};
			--m-button-padding-y: ${getToken("spacing-3")};
			/**
			 * Useful when overriding via host :slotted query.
			 */
			--m-button-font-size: ${getToken("font-size-3")};
		}

		:host([size='small']) {
			--m-button-base-size: ${getToken("global-height-small")};
		}

		:host([size='large']) {
			--m-button-base-size: ${getToken("global-height-large")};
		}

		:host([variant|='icon']) {
			--m-button-border-radius: ${getToken("border-radius-circle")};

			min-inline-size: var(--m-button-base-size);
			inline-size: var(--m-button-base-size);
		}

		:host {
			display: inline-block;
			min-block-size: var(--m-button-base-size);
			block-size: var(--m-button-base-size);
			border-radius: var(--m-button-border-radius);
		}

		.button {
			${transition([{property:"color"},{property:"background-color"},{property:"border-color"}])};

			${typography("button-md")};
			font-size: var(--m-button-font-size);

			cursor: pointer;
			position: relative;

			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;

			block-size: 100%;
			inline-size: 100%;
			box-sizing: border-box;

			text-decoration: none;

			gap: ${getToken("spacing-1")};

			padding-inline: var(--m-button-padding-x);
			padding-block: var(--m-button-padding-y);

			background-color: var(--m-button-background-color);
			color: var(--m-button-color);
			border: 1px solid var(--m-button-border-color);

			border-radius: var(--m-button-border-radius);
		}

		${on(".button").disabled} {
			cursor: default;
		}

		${on(".button","*").disabled} {
			pointer-events: none;
		}

		${on(".button").not.disabled.focus} {
			outline: 1px solid var(--m-button-outline-color);
			outline-offset: var(--m-button-outline-offset);
		}

		${on(".button").not.disabled.hover} {
			--m-button-background-color: ${getColor("color-background-inverted")};
			--m-button-border-color: ${getColor("color-background-inverted")};
			--m-button-color: ${getColor("color-text-inverted")};
		}

		::slotted(*) {
			display: inline-flex;
			align-items: center;

			${p(0)};
			${m(0)};
		}

		slot[name='leading']::slotted(span),
		slot[name='trailing']::slotted(span) {
			justify-content: center;
		}
	`}function styles$E(){return[styles$F(),i$4`
			.button.is-loading:not(.-icon, .-icon-secondary) *:not(.loader) {
				visibility: hidden;
			}

			.button.-primary {
				--m-button-background-color: ${getColor("color-primary-60")};
				--m-button-border-color: ${getColor("color-primary-60")};
				--m-button-color: ${getColor("color-text-inverted")};
			}

			${on(".button.-primary").disabled} {
				--m-button-background-color: ${getColor("color-primary-20")};
				--m-button-border-color: ${getColor("color-primary-20")};
			}

			${on(".button.-primary").not.disabled.focus} {
				--m-button-border-color: ${getColor("color-primary-60")};
				--m-button-outline-color: ${getColor("color-primary-60")};
			}

			${on(".button.-primary").not.disabled.hover},
			${on(".button.-primary").not.disabled.active} {
				--m-button-background-color: ${getColor("color-primary-100")};
				--m-button-border-color: ${getColor("color-primary-100")};
			}

			.button.-primary.is-loading {
				--m-button-background-color: ${getColor("color-primary-60")};
				--m-button-border-color: ${getColor("color-primary-60")};
				--m-button-color: ${getColor("color-text-inverted")};
			}

			.button.-secondary {
				--m-button-background-color: transparent;
				--m-button-border-color: ${getColor("color-primary-100")};
				--m-button-color: ${getColor("color-primary-100")};
			}

			${on(".button.-secondary").disabled} {
				--m-button-border-color: ${getColor("color-text-disabled")};
				--m-button-color: ${getColor("color-text-disabled")};
			}

			${on(".button.-secondary").not.disabled.focus} {
				--m-button-border-color: ${getColor("color-primary-100")};
				--m-button-color: ${getColor("color-primary-100")};

				--m-button-outline-color: ${getColor("color-primary-60")};
			}

			${on(".button.-secondary").not.disabled.hover},
			${on(".button.-secondary").not.disabled.active} {
				--m-button-background-color: ${getColor("color-background-tertiary")};
				--m-button-border-color: ${getColor("color-primary-60")};
				--m-button-color: ${getColor("color-primary-60")};
			}

			.button.-secondary.is-loading {
				--m-button-background-color: transparent;

				--m-button-border-color: ${getColor("color-primary-100")};
				--m-button-color: ${getColor("color-primary-100")};
			}

			.button.-tertiary {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
				--m-button-color: ${getColor("color-primary-100")};
			}

			${on(".button.-tertiary").disabled} {
				--m-button-color: ${getColor("color-text-disabled")};
			}

			${on(".button.-tertiary").not.disabled.focus} {
				--m-button-color: ${getColor("color-primary-100")};
				--m-button-outline-color: ${getColor("color-primary-60")};
			}

			${on(".button.-tertiary").not.disabled.hover} {
				--m-button-background-color: ${getColor("color-background-tertiary")};
				--m-button-border-color: ${getColor("color-background-tertiary")};
				--m-button-color: ${getColor("color-primary-60")};
			}

			${on(".button.-tertiary").not.disabled.active} {
				--m-button-background-color: ${getColor("color-neutral-20")};
				--m-button-border-color: ${getColor("color-neutral-20")};
				--m-button-color: ${getColor("color-primary-60")};
			}

			.button.-tertiary.is-loading {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
				--m-button-color: ${getColor("color-primary-100")};
			}

			.button.-warning {
				--m-button-background-color: ${getColor("color-warning-60")};
				--m-button-border-color: ${getColor("color-warning-60")};
				--m-button-color: ${getColor("color-text-primary")};
			}

			${on(".button.-warning").disabled} {
				--m-button-background-color: ${getColor("color-warning-20")};
				--m-button-border-color: ${getColor("color-warning-20")};
				--m-button-color: ${getColor("color-text-inverted")};
			}

			${on(".button.-warning").not.disabled.focus} {
				--m-button-background-color: ${getColor("color-warning-60")};
				--m-button-outline-color: ${getColor("color-warning-60")};
			}

			${on(".button.-warning").not.disabled.hover},
			${on(".button.-warning").not.disabled.active} {
				--m-button-background-color: ${getColor("color-warning-100")};
				--m-button-border-color: ${getColor("color-warning-100")};
				--m-button-color: ${getColor("color-text-inverted")};
			}

			.button.-warning.is-loading {
				--m-button-background-color: ${getColor("color-warning-60")};
				--m-button-border-color: ${getColor("color-warning-60")};
				--m-button-color: ${getColor("color-text-primary")};
			}

			.button.-danger {
				--m-button-background-color: ${getColor("color-danger-60")};
				--m-button-border-color: ${getColor("color-danger-60")};
				--m-button-color: ${getColor("color-text-inverted")};
			}

			${on(".button.-danger").disabled} {
				--m-button-background-color: ${getColor("color-danger-20")};
				--m-button-border-color: ${getColor("color-danger-20")};
			}

			${on(".button.-danger").not.disabled.focus} {
				--m-button-background-color: ${getColor("color-danger-60")};
				--m-button-outline-color: ${getColor("color-danger-60")};
			}

			${on(".button.-danger").not.disabled.hover},
			${on(".button.-danger").not.disabled.active} {
				--m-button-background-color: ${getColor("color-danger-100")};
				--m-button-border-color: ${getColor("color-danger-100")};
			}

			.button.-danger.is-loading {
				--m-button-background-color: ${getColor("color-danger-60")};
				--m-button-border-color: ${getColor("color-danger-60")};
				--m-button-color: ${getColor("color-text-inverted")};
			}

			.button.-icon,
			.button.-icon-secondary {
				--m-button-color: ${getColor("color-neutral-90")};
				--m-button-padding-x: ${getToken("spacing-1")};
				--m-button-padding-y: ${getToken("spacing-1")};
			}

			.button.-icon {
				--m-button-background-color: ${getColor("color-background-tertiary")};
				--m-button-border-color: ${getColor("color-background-tertiary")};
			}

			.button.-icon-secondary {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
			}

			.button.-icon slot[name='leading']::slotted(*),
			.button.-icon slot[name='trailing']::slotted(*),
			.button.-icon-secondary slot[name='leading']::slotted(*),
			.button.-icon-secondary slot[name='trailing']::slotted(*) {
				display: none;
			}

			${on([".button.-icon",".button.-icon-secondary"]).disabled} {
				--m-button-color: ${getColor("color-neutral-40")};
			}

			${on(".button.-icon").disabled} {
				--m-button-background-color: ${getColor("color-neutral-20")};
				--m-button-border-color: ${getColor("color-neutral-20")};
			}

			${on(".button.-icon-secondary").disabled} {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
			}

			${on([".button.-icon",".button.-icon-secondary"]).not.disabled.focus} {
				--m-button-color: ${getColor("color-primary-60")};
				--m-button-outline-color: ${getColor("color-primary-60")};
			}

			${on(".button.-icon").not.disabled.focus} {
				--m-button-background-color: ${getColor("color-neutral-20")};
			}

			${on(".button.-icon-secondary").not.disabled.focus} {
				--m-button-background-color: transparent;
			}

			${on([".button.-icon",".button.-icon-secondary"]).not.disabled.hover},
			${on([".button.-icon",".button.-icon-secondary"]).not.disabled.active} {
				--m-button-color: ${getColor("color-primary-60")};
			}

			${on(".button.-icon").not.disabled.hover},
			${on(".button.-icon").not.disabled.active} {
				--m-button-background-color: ${getColor("color-background-highlight")};
				--m-button-border-color: ${getColor("color-background-highlight")};
			}

			${on(".button.-icon-secondary").not.disabled.hover},
			${on(".button.-icon-secondary").not.disabled.active} {
				--m-button-background-color: transparent;
				--m-button-border-color: transparent;
			}

			.button.-small {
				--m-button-padding-y: ${getToken("spacing-2")};

				${typography("button-sm")};
			}

			.button.-large {
				--m-button-padding-y: ${getToken("spacing-4")};

				${typography("button-lg")};
			}

			/* TODO: to be removed when the loading dots component is ready */
			.loader {
				position: absolute;
				inset: 0;

				display: flex;
				align-items: center;
				justify-content: center;

				pointer-events: none;
			}
		`]}_FormControl_form=new WeakMap,_FormControl_updateAssignedForm=new WeakMap;class Button extends FormControl{get tag(){const t=__classPrivateFieldGet(this,_Button_instances,"m",_Button_isLink).call(this)?"a":"button";return i$3`${o$3(t)}`}static get properties(){return{...FormControl.properties,role:{type:String,reflect:!0},loading:{type:Boolean,reflect:!0},disabled:{type:Boolean,reflect:!0},variant:{type:String,reflect:!0},size:{type:String,reflect:!0},type:{type:String},href:{type:String,reflect:!0},target:{type:String},download:{type:String}}}constructor(){super(),_Button_instances.add(this),_Button_isDisabled.set(this,(()=>Boolean(this.disabled)||Boolean(this.loading))),_Button_getRole.set(this,(()=>__classPrivateFieldGet(this,_Button_instances,"m",_Button_isLink).call(this)?"link":"button")),_Button_setDisabled.set(this,(()=>{const t=__classPrivateFieldGet(this,_Button_isDisabled,"f").call(this);this.setAttribute("aria-disabled",String(t))})),_Button_setTabIndex.set(this,(()=>{this.disabled?this.setAttribute("tabindex","-1"):this.removeAttribute("tabindex")})),_Button_handleClick.set(this,(t=>{if(this.disabled||this.loading)return t.preventDefault(),void t.stopPropagation();"submit"!==this.type?"reset"===this.type&&this.getForm()?.reset():this.getForm()?.requestSubmit()})),this.disabled=!1,this.loading=!1,this.size="default",this.type="button",this.variant="secondary",this.target="_self"}connectedCallback(){super.connectedCallback(),this.setAttribute("role",__classPrivateFieldGet(this,_Button_getRole,"f").call(this)),this.addEventListener("click",__classPrivateFieldGet(this,_Button_handleClick,"f"))}disconnectedCallback(){super.disconnectedCallback(),this.removeEventListener("click",__classPrivateFieldGet(this,_Button_handleClick,"f"))}willUpdate(t){super.willUpdate(t),t.has("href")&&this.setAttribute("role",__classPrivateFieldGet(this,_Button_getRole,"f").call(this)),__classPrivateFieldGet(this,_Button_setTabIndex,"f").call(this)}updated(t){super.updated(t),(t.has("disabled")||t.has("loading"))&&__classPrivateFieldGet(this,_Button_setDisabled,"f").call(this)}render(){const t=__classPrivateFieldGet(this,_Button_instances,"m",_Button_isLink).call(this);return n$4`
			<${this.tag}
				class=${o$2({button:!0,"-primary":"primary"===this.variant,"-secondary":"secondary"===this.variant,"-tertiary":"tertiary"===this.variant,"-warning":"warning"===this.variant,"-danger":"danger"===this.variant,"-icon":"icon"===this.variant,"-icon-secondary":"icon-secondary"===this.variant,"-small":"small"===this.size,"-default":"default"===this.size,"-large":"large"===this.size,"is-loading":Boolean(this.loading),"is-disabled":__classPrivateFieldGet(this,_Button_isDisabled,"f").call(this)})}
				type=${t?A:this.type}
				?disabled="${t?A:__classPrivateFieldGet(this,_Button_isDisabled,"f").call(this)}"
				aria-disabled=${this.disabled&&t?"true":"false"}
				role=${l$1(this.role)}
				href=${t?this.href:A}
				target=${t?l$1(this.target):A}
				download=${t?l$1(this.download):A}
				rel=${t&&"_blank"===this.target?"noreferrer noopener":A}
			>
				<!-- TODO: Replace this with the loading dots component as soon as it is ready. -->
				${this.loading&&!["icon","icon-secondary"].includes(this.variant)?n$4`<span class="loader">&#x25cf;&#x25cf;&#x25cf;</span>`:A}
				<slot name="leading"></slot>
				<slot></slot>
				<slot name="trailing"></slot>
			</${this.tag}>
		`}focus(t){__classPrivateFieldGet(this,_Button_instances,"a",_Button_element_get)?.focus(t)}}_Button_isDisabled=new WeakMap,_Button_getRole=new WeakMap,_Button_setDisabled=new WeakMap,_Button_setTabIndex=new WeakMap,_Button_handleClick=new WeakMap,_Button_instances=new WeakSet,_Button_element_get=function(){return this.renderRoot?.querySelector(".button")??null},_Button_isLink=function(){return Boolean(this.href)},Button.styles=[styles$E()],window.customElements.define("m-button",Button);class BackButton extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="back-button"}render(){return x`
			<m-button variant="icon" size="default">
				<m-icon name="arrow-left"></m-icon>
			</m-button>
		`}}function styles$D(){return i$4`
		:host {
			--m-host-size: 24px;
			--m-badge-size: 12px;
			--m-badge-border-radius: ${getToken("border-radius-circle")};

			display: inline-flex;
			position: relative;
			inline-size: var(--m-host-size);
			block-size: var(--m-host-size);
		}

		:host([size='small']) {
			--m-host-size: 16px;
			--m-badge-size: 8px;
		}

		.badge {
			display: flex;
			position: absolute;
			top: 0;
			inline-size: var(--m-badge-size);
			block-size: var(--m-badge-size);
			align-items: center;
			justify-content: center;
			color: ${getColor("color-neutral-0")};
			background-color: ${getColor("color-text-error")};
			font-size: ${getToken("font-size-1")};
			border-radius: var(--m-badge-border-radius);
		}

		:host([placement='top-left']) .badge {
			right: calc(100% - var(--m-badge-size) / 2);
		}

		:host([placement='top-right']) .badge {
			left: calc(100% - var(--m-badge-size) / 2);
		}

		.badge.-hidden {
			display: none;
		}

		:host([size='default']) .badge.-large-badge {
			inline-size: 18px;
			--m-badge-border-radius: ${getToken("border-radius-m")};
		}

		:host([size='default']) .badge.-extra-large-badge {
			inline-size: 24px;
			--m-badge-border-radius: ${getToken("border-radius-m")};
		}
	`}BackButton.styles=[styles$G()],window.customElements.define("m-back-button",BackButton);class Badge extends s$5{static get properties(){return{counter:{type:Number,reflect:!0},placement:{type:String,reflect:!0},size:{type:String,reflect:!0}}}constructor(){super(),_Badge_instances.add(this),this.counter=1,this.placement="top-right",this.size="default"}render(){return x`
			<slot></slot>
			<span
				class=${o$2({badge:!0,"-hidden":__classPrivateFieldGet(this,_Badge_instances,"a",_Badge_counter_get)<=0,"-large-badge":__classPrivateFieldGet(this,_Badge_instances,"a",_Badge_counter_get)>=10&&__classPrivateFieldGet(this,_Badge_instances,"a",_Badge_counter_get)<100,"-extra-large-badge":__classPrivateFieldGet(this,_Badge_instances,"a",_Badge_counter_get)>=100})}
				>${__classPrivateFieldGet(this,_Badge_instances,"m",_Badge_formatCounter).call(this)}</span
			>
		`}}_Badge_instances=new WeakSet,_Badge_counter_get=function(){return"number"!=typeof this.counter||Number.isNaN(this.counter)||this.counter<0?0:this.counter},_Badge_formatCounter=function(){return"default"===this.size?__classPrivateFieldGet(this,_Badge_instances,"a",_Badge_counter_get)>99?"99+":__classPrivateFieldGet(this,_Badge_instances,"a",_Badge_counter_get):A},Badge.styles=[styles$D()],window.customElements.define("m-badge",Badge);class BannerActionPrimary extends Button{constructor(){super(),this.size="small"}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","primary-action")}}window.customElements.define("m-banner-action-primary",BannerActionPrimary);class BannerActionSecondary extends Button{constructor(){super(),this.variant="tertiary",this.size="small"}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","secondary-action")}}function styles$C(){return i$4`
		:host {
			display: flex;
			justify-content: flex-end;
			gap: ${getToken("spacing-2")};
		}
	`}window.customElements.define("m-banner-action-secondary",BannerActionSecondary);class BannerActions extends s$5{connectedCallback(){super.connectedCallback(),this.setAttribute("slot","actions")}render(){return x`
			<slot name="secondary-action"></slot>
			<slot name="primary-action"></slot>
		`}}function styles$B(){return i$4`
		:host {
			${typography("body-md")};
			color: ${getColor("color-text-secondary")};
		}
	`}BannerActions.styles=[styles$C()],window.customElements.define("m-banner-actions",BannerActions);class BannerDescription extends s$5{connectedCallback(){super.connectedCallback(),this.setAttribute("slot","description")}render(){return x`<slot></slot>`}}BannerDescription.styles=[styles$B()],window.customElements.define("m-banner-description",BannerDescription);class BannerIcon extends s$5{connectedCallback(){super.connectedCallback(),this.setAttribute("slot","icon")}render(){return x`<slot></slot>`}}function styles$A(){return i$4`
		:host {
			${typography("body-md-bold")};
			color: ${getColor("color-text-secondary")};
		}
	`}window.customElements.define("m-banner-icon",BannerIcon);class BannerTitle extends s$5{connectedCallback(){super.connectedCallback(),this.setAttribute("slot","title")}render(){return x`<slot></slot>`}}function styles$z(){return i$4`
		:host {
			display: block;
			width: 100%;
		}

		:host([dismissed]) {
			display: none;
		}

		.banner {
			background-color: var(
				--m-banner-background-color,
				${getColor("color-background-secondary")}
			);
			border: var(--m-banner-border, 1px solid ${getColor("color-border")});
			border-radius: var(--m-banner-border-radius, ${getToken("border-radius-m")});
			padding-inline: var(--m-banner-padding-x, ${getToken("spacing-6")});
			padding-block: var(--m-banner-padding-y, ${getToken("spacing-4")});
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-end;
			gap: ${getToken("spacing-6")};
		}

		.banner.-success {
			--m-banner-background-color: ${getColor("color-success-20")};
			--m-banner-border: 1px solid ${getColor("color-success-20")};
			--m-banner-icon-color: ${getColor("color-success-60")};
		}

		.banner.-warning {
			--m-banner-background-color: ${getColor("color-warning-20")};
			--m-banner-border: 1px solid ${getColor("color-warning-20")};
			--m-banner-icon-color: ${getColor("color-warning-100")};
		}

		.banner.-danger {
			--m-banner-background-color: ${getColor("color-danger-20")};
			--m-banner-border: 1px solid ${getColor("color-danger-20")};
			--m-banner-icon-color: ${getColor("color-danger-60")};
		}

		.banner.-with-description {
			flex-direction: column;
		}

		.wrapper {
			display: flex;
			gap: ${getToken("spacing-6")};
			align-items: center;
			flex-grow: 1;
		}

		slot[name='icon'] > m-icon,
		slot[name='icon']::slotted(*) {
			--m-icon-color: var(--m-banner-icon-color, ${getColor("color-neutral-90")});
			--m-icon-size: var(--m-banner-icon-size, 24px);

			fill: var(--m-banner-icon-color, ${getColor("color-neutral-90")});
			block-size: var(--m-banner-icon-size, 24px);
			inline-size: var(--m-banner-icon-size, 24px);
		}

		.content {
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			gap: ${getToken("spacing-1")};
		}
	`}BannerTitle.styles=[styles$A()],window.customElements.define("m-banner-title",BannerTitle);var _CloseButton_instances,_CloseButton_button_get,_CloseButton_handleClick,indexFlGcVSBB={BASE_PIXELS:16,toRem:function(t,e=16){return parseInt(String(t),10)/e+"rem"}},e$3=indexFlGcVSBB,toRem$1=e$3.toRem,rem=getDefaultExportFromCjs(toRem$1);function toRem(t,e){return r$4(rem(t,e))}function styles$y(){return i$4`
		:host {
			--m-close-button-color: ${getColor("color-text-primary")};
			--m-close-button-outline-color: ${getColor("color-primary-100")};
			--m-close-button-outline-offset: 2px;
		}

		.close-button {
			--button-color: transparent;
			--icon-color: var(--m-close-button-color);

			width: var(--button-size);
			height: var(--button-size);
			${m(0)};
			${p(0)};
			background-color: var(--button-color);
			border: none;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;

			${transition([{property:"background-color"}])};
		}

		.close-button.-size-small {
			--button-size: ${toRem("12px")};
			--icon-size: ${toRem("8px")};
		}

		.close-button.-size-default {
			--button-size: ${toRem("16px")};
			--icon-size: ${toRem("12px")};
		}

		.close-button.-size-large {
			--button-size: ${toRem("20px")};
			--icon-size: ${toRem("16px")};
		}

		.close-button.-inverted {
			--button-color: transparent;
			--icon-color: ${getColor("color-text-inverted")};
		}

		m-icon {
			--m-icon-size: var(--icon-size);
			--m-icon-color: var(--icon-color);

			display: block;
		}

		${on(".close-button").not.disabled.focus} {
			outline: 1px solid var(--m-close-button-outline-color);
			outline-offset: var(--m-close-button-outline-offset);
		}

		${on(".close-button").not.disabled.hover} {
			--button-color: var(--m-close-button-color);
			--icon-color: ${getColor("color-text-inverted")};
		}

		${on(".close-button.-inverted").not.disabled.hover} {
			--button-color: ${getColor("color-text-inverted")};
			--icon-color: var(--m-close-button-color);
		}

		${on(".close-button").disabled} {
			--icon-color: ${getColor("color-text-disabled")};
			cursor: default;
		}

		${on(".close-button","*").disabled} {
			pointer-events: none;
		}
	`}class CloseButton extends Component{static get properties(){return{controls:{type:String},disabled:{type:Boolean},inverted:{type:Boolean},label:{type:String},size:{type:String}}}constructor(){super(),_CloseButton_instances.add(this),_CloseButton_handleClick.set(this,(()=>{this.emit("m-close")})),this.disabled=!1,this.inverted=!1,this.label="Close",this.size="default"}render(){return x`
			<button
				type="button"
				aria-controls="${l$1(this.controls)}"
				aria-label="${l$1(this.label)}"
				class=${o$2({"close-button":!0,"-size-small":"small"===this.size,"-size-default":"default"===this.size,"-size-large":"large"===this.size,"-inverted":this.inverted??!1})}
				?disabled="${this.disabled}"
				@click=${__classPrivateFieldGet(this,_CloseButton_handleClick,"f")}
			>
				<m-icon name="close"></m-icon>
			</button>
		`}focus(t){__classPrivateFieldGet(this,_CloseButton_instances,"a",_CloseButton_button_get)?.focus(t)}}_CloseButton_handleClick=new WeakMap,_CloseButton_instances=new WeakSet,_CloseButton_button_get=function(){return this.renderRoot.querySelector("button")??null},CloseButton.styles=[styles$y()],window.customElements.define("m-close-button",CloseButton);
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const i$1="important",n$3=" !"+i$1,o$1=e$4(class extends i$2{constructor(t){var e;if(super(t),t.type!==t$3.ATTRIBUTE||"style"!==t.name||(null===(e=t.strings)||void 0===e?void 0:e.length)>2)throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.")}render(t){return Object.keys(t).reduce(((e,o)=>{const i=t[o];return null==i?e:e+`${o=o.includes("-")?o:o.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g,"-$&").toLowerCase()}:${i};`}),"")}update(t,[e]){const{style:o}=t.element;if(void 0===this.ht){this.ht=new Set;for(const t in e)this.ht.add(t);return this.render(e)}this.ht.forEach((t=>{null==e[t]&&(this.ht.delete(t),t.includes("-")?o.removeProperty(t):o[t]="")}));for(const t in e){const i=e[t];if(null!=i){this.ht.add(t);const e="string"==typeof i&&i.endsWith(n$3);t.includes("-")||e?o.setProperty(t,e?i.slice(0,-11):i,e?i$1:""):o[t]=i}}return T}}),HTML_TAGS=["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","label","legend","li","link","main","map","mark","menu","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","slot","small","source","span","strong","style","sub","summary","sup","table","tbody","td","template","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr"],PolymorphicTagMixin=({superClass:t,allowedTags:e=HTML_TAGS,fallbackTag:o="div"})=>class extends t{static get properties(){return{as:{type:String}}}attributeChangedCallback(t,i,r){super.attributeChangedCallback(t,i,r),"as"===t&&(null!==r&&e.includes(r)?this.as=r:this.as=o)}get tag(){return i$3`${o$3(this.as)}`}};function styles$x(){return i$4`
		:host {
			--m-text-color: ${getColor("color-text-primary")};
			--m-text-display: inline-block;
			--m-text-max-width: initial;
			--m-text-padding: 0;
			--m-text-margin: 0;

			display: contents;
		}

		.m-text {
			${transition([{property:"color"}])};

			${typography()};

			color: var(--m-text-color);
			display: var(--m-text-display);
			padding: var(--m-text-padding);
			margin: var(--m-text-margin);
		}

		.-body-lg-bold {
			${typography("body-lg-bold")};
		}

		.-body-lg {
			${typography("body-lg")};
		}

		.-body-md-bold-underline {
			${typography("body-md-bold-underline")};
		}

		.-body-md-bold {
			${typography("body-md-bold")};
		}

		.-body-md-underline {
			${typography("body-md-underline")};
		}

		.-body-md {
			${typography("body-md")};
		}

		.-body-sm-bold-underline {
			${typography("body-sm-bold-underline")};
		}

		.-body-sm-bold {
			${typography("body-sm-bold")};
		}

		.-body-sm-underline {
			${typography("body-sm-underline")};
		}

		.-body-sm {
			${typography("body-sm")};
		}

		.-button-lg {
			${typography("button-lg")};
		}

		.-button-md {
			${typography("button-md")};
		}

		.-button-sm {
			${typography("button-sm")};
		}

		.-chips-md {
			${typography("chips-md")};
		}

		.-chips-sm {
			${typography("chips-sm")};
		}

		.-heading-lg-bold {
			${typography("heading-lg-bold")};
		}

		.-heading-lg {
			${typography("heading-lg")};
		}

		.-heading-md-bold {
			${typography("heading-md-bold")};
		}

		.-heading-md {
			${typography("heading-md")};
		}

		.-heading-sm-bold {
			${typography("heading-sm-bold")};
		}

		.-heading-sm {
			${typography("heading-sm")};
		}

		.-hero-lg-bold {
			${typography("hero-lg-bold")};
		}

		.-hero-lg {
			${typography("hero-lg")};
		}

		.-hero-md-bold {
			${typography("hero-md-bold")};
		}

		.-hero-md {
			${typography("hero-md")};
		}

		.-hero-sm-bold {
			${typography("hero-sm-bold")};
		}

		.-hero-sm {
			${typography("hero-sm")};
		}

		.-number-md {
			${typography("number-md")};
		}

		.-number-sm {
			${typography("number-sm")};
		}

		.-table-header-md {
			${typography("table-header-md")};
		}

		.-table-header-sm {
			${typography("table-header-sm")};
		}

		.-ellipsized {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			max-width: var(--m-text-max-width);
		}
	`}class Text extends(PolymorphicTagMixin({superClass:s$5,allowedTags:["h1","h2","h3","h4","h5","h6","p","span"],fallbackTag:"span"})){static get properties(){return{color:{type:String,reflect:!0},ellipsized:{type:Boolean,reflect:!0},variant:{type:String,reflect:!0}}}constructor(){super(),this.as="span",this.color="color-text-primary",this.ellipsized=!1,this.variant="body-md"}render(){return n$4`
			<${this.tag}
				class=${o$2({"m-text":!0,"-body-lg-bold":"body-lg-bold"===this.variant,"-body-lg":"body-lg"===this.variant,"-body-md-bold-underline":"body-md-bold-underline"===this.variant,"-body-md-bold":"body-md-bold"===this.variant,"-body-md-underline":"body-md-underline"===this.variant,"-body-md":"body-md"===this.variant,"-body-sm-bold-underline":"body-sm-bold-underline"===this.variant,"-body-sm-bold":"body-sm-bold"===this.variant,"-body-sm-underline":"body-sm-underline"===this.variant,"-body-sm":"body-sm"===this.variant,"-button-lg":"button-lg"===this.variant,"-button-md":"button-md"===this.variant,"-button-sm":"button-sm"===this.variant,"-chips-md":"chips-md"===this.variant,"-chips-sm":"chips-sm"===this.variant,"-heading-lg-bold":"heading-lg-bold"===this.variant,"-heading-lg":"heading-lg"===this.variant,"-heading-md-bold":"heading-md-bold"===this.variant,"-heading-md":"heading-md"===this.variant,"-heading-sm-bold":"heading-sm-bold"===this.variant,"-heading-sm":"heading-sm"===this.variant,"-hero-lg-bold":"hero-lg-bold"===this.variant,"-hero-lg":"hero-lg"===this.variant,"-hero-md-bold":"hero-md-bold"===this.variant,"-hero-md":"hero-md"===this.variant,"-hero-sm-bold":"hero-sm-bold"===this.variant,"-hero-sm":"hero-sm"===this.variant,"-number-md":"number-md"===this.variant,"-number-sm":"number-sm"===this.variant,"-table-header-md":"table-header-md"===this.variant,"-table-header-sm":"table-header-sm"===this.variant,"-ellipsized":Boolean(this.ellipsized)})}
				style=${o$1({"--m-text-color":toCSSValue(this.color)})}
			>
				<slot></slot>
			</${this.tag}>
		`}}var _Banner_primaryAction,_Banner_handleDismissClick;function getIcon(t){switch(t){case"success":return"check";case"warning":case"danger":return"attention";default:return"info-circle"}}function getPrimaryActionVariant(t){switch(t){case"warning":return"warning";case"danger":return"danger";default:return"primary"}}Text.styles=[styles$x()],window.customElements.define("m-text",Text);class Banner extends Component{static get properties(){return{variant:{type:String},dismissible:{type:Boolean},dismissed:{type:Boolean,reflect:!0}}}constructor(){super(),_Banner_primaryAction.set(this,void 0),_Banner_handleDismissClick.set(this,(()=>{this.dismissed=!0,this.emit("m-dismiss",{composed:!0})})),this.variant="neutral",this.dismissible=!1,this.dismissed=!1}get primaryAction(){return null==__classPrivateFieldGet(this,_Banner_primaryAction,"f")&&__classPrivateFieldSet(this,_Banner_primaryAction,this.querySelector("m-banner-action-primary"),"f"),__classPrivateFieldGet(this,_Banner_primaryAction,"f")}updated(t){super.updated(t),t.has("variant")&&null!=this.primaryAction&&(this.primaryAction.variant=getPrimaryActionVariant(this.variant))}render(){if(this.dismissed)return A;const t=null!=this.querySelector("*[slot='description']"),e=null!=this.querySelector("*[slot='actions']"),o=x`
			<m-close-button
				id="close"
				label="Dismiss"
				@click=${__classPrivateFieldGet(this,_Banner_handleDismissClick,"f")}
			></m-close-button>
		`;return x`
			<div
				class=${o$2({banner:!0,"-success":"success"===this.variant,"-warning":"warning"===this.variant,"-danger":"danger"===this.variant,"-with-description":t})}
			>
				<div class="wrapper">
					<slot name="icon">
						<m-icon name="${getIcon(this.variant)}"></m-icon>
					</slot>
					<div class="content">
						<slot name="title"></slot>
						<slot name="description"></slot>
					</div>
					${this.dismissible&&!e?o:A}
				</div>
				<slot name="actions"></slot>
			</div>
		`}}function styles$w(){return i$4`
		:host {
			display: block;
			box-sizing: border-box;
			width: 100%;
		}
		.body-wrapper {
			padding: ${getToken("spacing-4")};

			slot[name='page-body']::slotted(*) {
				max-width: 1280px;
				margin: auto;
			}
		}

		${mediaDesktop(i$4`
			.body-wrapper {
				padding: ${getToken("spacing-6")};
			}
		`)}
	`}_Banner_primaryAction=new WeakMap,_Banner_handleDismissClick=new WeakMap,Banner.styles=[styles$z()],window.customElements.define("m-banner",Banner);class Body extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="page-body"}render(){return n$4`<div class="body-wrapper"><slot></slot></div>`}}function cardStyles(){return i$4`
		:host {
			--m-card-background-color: ${getColor("color-background-primary")};
		}

		.m-card {
			position: relative;
			display: flex;
			flex-direction: row;

			background-color: var(--m-card-background-color);
			border-radius: ${getToken("border-radius-s")};
			border: solid 1px ${getColor("color-divider")};
		}

		.m-card-flag {
			position: absolute;
			top: -1px;
			bottom: -1px;
			left: -1px;
			display: block;

			box-sizing: border-box;
			border: 1px solid var(--m-card-flag-color);
			background-color: var(--m-card-flag-color);
			width: ${getToken("border-thick")};
			border-top-left-radius: ${getToken("border-radius-s")};
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			border-bottom-left-radius: ${getToken("border-radius-s")};
		}

		.m-card-content {
			display: flex;
			flex: 1;
			flex-direction: column;
		}

		::slotted(m-divider) {
			--m-divider-margin-top: ${getToken("spacing-4")};
		}

		.m-title-wrapper {
			padding: ${getToken("spacing-4")};
		}

		.hidden {
			display: none;
		}

		.m-title-wrapper > m-stack {
			flex: 1;
		}

		.m-collapse-trigger {
			${typography("body-md-bold")};
			display: flex;
			margin: 0;
			cursor: pointer;
			color: ${getColor("color-text-primary")};
			outline: none;
			border: none;
			align-items: center;
			background-color: ${getColor("color-background-primary")};
		}

		.m-collapsed-content {
			display: none;
		}

		.m-collapse-trigger[aria-expanded='true'] m-icon {
			transform: rotate(180deg);
		}

		@media (prefers-reduced-motion: no-preference) {
			m-icon {
				${transition([{property:"transform"}])};
			}
		}
	`}function cardBodyStyles(){return i$4`
		:host {
			--m-card-body-padding-x: ${getToken("spacing-4")};
			--m-card-body-padding-y: ${getToken("spacing-4")};
		}

		.m-card-body {
			padding: var(--m-card-body-padding-y) var(--m-card-body-padding-x);
		}
	`}function cardSubtitleStyles(){return i$4`
		:host {
			--m-card-subtitle-margin-top: ${getToken("spacing-2")};
		}

		.m-card-subtitle {
			${typography("body-md")};

			margin-block-start: var(--m-card-subtitle-margin-top);

			color: ${getColor("color-text-tertiary")};
		}
	`}function cardTitleStyles(){return i$4`
		.m-card-title {
			${typography("heading-sm-bold")};
			color: ${getColor("color-text-primary")};
		}

		slot[name='leading']::slotted(*) {
			display: inline-flex;
			flex-flow: row nowrap;
			align-items: center;
			justify-content: center;
			pointer-events: none;
			margin-inline-end: ${getToken("spacing-1")};
		}
	`}function cardDividerStyles(){return i$4`
		:host {
			--m-divider-margin-top: 0;
		}
	`}Body.styles=[styles$w()],window.customElements.define("m-body",Body);const ALIGN_ITEMS_VALUES=["baseline","center","flex-start","flex-end","stretch"],JUSTIFY_CONTENT_VALUES=["center","flex-start","flex-end","space-between","space-around","space-evenly"];var _BaseLayout_setOrRemoveProperty;class BaseLayout extends s$5{constructor(){super(...arguments),_BaseLayout_setOrRemoveProperty.set(this,((t,e)=>{e?this.style.setProperty(t,toSpacingCSSValue(e)):this.style.removeProperty(t)}))}static get properties(){return{padding:{type:String},paddingX:{type:String,attribute:"padding-x"},paddingY:{type:String,attribute:"padding-y"},paddingT:{type:String,attribute:"padding-t"},paddingB:{type:String,attribute:"padding-b"},paddingL:{type:String,attribute:"padding-l"},paddingR:{type:String,attribute:"padding-r"}}}getCSSPropertiesPrefix(){return"layout"}update(t){super.update(t);const e=this.getCSSPropertiesPrefix();t.has("padding")&&this.style.setProperty(`--m-${e}-padding`,toSpacingCSSValue(this.padding)),t.has("paddingX")&&__classPrivateFieldGet(this,_BaseLayout_setOrRemoveProperty,"f").call(this,`--m-${e}-padding-x`,this.paddingX),t.has("paddingY")&&__classPrivateFieldGet(this,_BaseLayout_setOrRemoveProperty,"f").call(this,`--m-${e}-padding-y`,this.paddingY),t.has("paddingT")&&__classPrivateFieldGet(this,_BaseLayout_setOrRemoveProperty,"f").call(this,`--m-${e}-padding-t`,this.paddingT),t.has("paddingB")&&__classPrivateFieldGet(this,_BaseLayout_setOrRemoveProperty,"f").call(this,`--m-${e}-padding-b`,this.paddingB),t.has("paddingL")&&__classPrivateFieldGet(this,_BaseLayout_setOrRemoveProperty,"f").call(this,`--m-${e}-padding-l`,this.paddingL),t.has("paddingR")&&__classPrivateFieldGet(this,_BaseLayout_setOrRemoveProperty,"f").call(this,`--m-${e}-padding-r`,this.paddingR)}render(){return x`<slot></slot>`}}function getBaseLayoutStyles(t){return i$4`
		:host {
			/** reset layout custom properties to avoid inheritance */
			--m-${r$4(t)}-padding-x: initial;
			--m-${r$4(t)}-padding-y: initial;
			--m-${r$4(t)}-padding-t: initial;
			--m-${r$4(t)}-padding-r: initial;
			--m-${r$4(t)}-padding-b: initial;
			--m-${r$4(t)}-padding-l: initial;
			--m-${r$4(t)}-padding: initial;

			padding-block-start: var(
				--m-${r$4(t)}-padding-t,
				var(
					--m-${r$4(t)}-padding-y,
					var(--m-${r$4(t)}-padding, 0)
				)
			);
			padding-block-end: var(
				--m-${r$4(t)}-padding-b,
				var(
					--m-${r$4(t)}-padding-y,
					var(--m-${r$4(t)}-padding, 0)
				)
			);
			padding-inline-start: var(
				--m-${r$4(t)}-padding-l,
				var(
					--m-${r$4(t)}-padding-x,
					var(--m-${r$4(t)}-padding, 0)
				)
			);
			padding-inline-end: var(
				--m-${r$4(t)}-padding-r,
				var(
					--m-${r$4(t)}-padding-x,
					var(--m-${r$4(t)}-padding, 0)
				)
			);
		}
	`}_BaseLayout_setOrRemoveProperty=new WeakMap;const defaultBoxProps={padding:"spacing-4",borderRadius:"border-radius-s",borderWidth:"border-none",borderColor:"color-background-highlight",textAlign:"left"};function boxStyles(){return i$4`
		:host {
			--m-box-padding: ${getToken(defaultBoxProps.padding)};
			--m-box-background-color: transparent;
			--m-box-border-radius: ${getToken(defaultBoxProps.borderRadius)};
			--m-box-border-width: ${getToken(defaultBoxProps.borderWidth)};
			--m-box-border-color: ${getColor(defaultBoxProps.borderColor)};
			--m-box-text-align: ${r$4(defaultBoxProps.textAlign)};

			box-sizing: border-box;

			background-color: var(--m-box-background-color);
			border-radius: var(--m-box-border-radius);
			border-style: solid;
			border-width: var(--m-box-border-width);
			border-color: var(--m-box-border-color);
			text-align: var(--m-box-text-align);
			display: block;
		}
	`}class Box extends BaseLayout{static get properties(){return{...super.properties,backgroundColor:{type:String,attribute:"background-color"},borderRadius:{type:String,attribute:"border-radius"},borderWidth:{type:String,attribute:"border-width"},borderColor:{type:String,attribute:"border-color"},textAlign:{type:String,attribute:"text-align"}}}getCSSPropertiesPrefix(){return Box.CSSPropertiesPrefix}update(t){super.update(t),t.has("backgroundColor")&&this.style.setProperty("--m-box-background-color",(this.backgroundColor&&toCSSValue(this.backgroundColor))??"transparent"),t.has("borderRadius")&&this.style.setProperty("--m-box-border-radius",(this.borderRadius&&toCSSValue(this.borderRadius))??toCSSValue(defaultBoxProps.borderRadius)),t.has("borderWidth")&&this.style.setProperty("--m-box-border-width",(this.borderWidth&&toCSSValue(this.borderWidth))??toCSSValue(defaultBoxProps.borderWidth)),t.has("borderColor")&&this.style.setProperty("--m-box-border-color",(this.borderColor&&toCSSValue(this.borderColor))??toCSSValue(defaultBoxProps.borderColor)),t.has("textAlign")&&this.style.setProperty("--m-box-text-align",this.textAlign||defaultBoxProps.textAlign)}render(){return x`<slot></slot>`}}Box.CSSPropertiesPrefix="box",Box.styles=[getBaseLayoutStyles(Box.CSSPropertiesPrefix),boxStyles()],window.customElements.define("m-box",Box);const defaultGroupProps={gap:"spacing-4",align:"stretch",justify:"flex-start"};function groupStyles(){return i$4`
		:host {
			--m-group-gap: ${getToken(defaultGroupProps.gap)};
			--m-group-align: ${r$4(defaultGroupProps.align)};
			--m-group-justify: ${r$4(defaultGroupProps.justify)};

			display: flex;
			flex-wrap: wrap;
			gap: var(--m-group-gap);
			align-items: var(--m-group-align);
			justify-content: var(--m-group-justify);
		}
	`}class Group extends BaseLayout{static get properties(){return{...super.properties,gap:{type:String},align:{type:String},justify:{type:String}}}getCSSPropertiesPrefix(){return Group.CSSPropertiesPrefix}update(t){super.update(t),t.has("gap")&&this.style.setProperty("--m-group-gap",toSpacingCSSValue(this.gap,defaultGroupProps.gap)),t.has("align")&&this.style.setProperty("--m-group-align",this.align||defaultGroupProps.align),t.has("justify")&&this.style.setProperty("--m-group-justify",this.justify||defaultGroupProps.justify)}render(){return x`<slot></slot>`}}Group.CSSPropertiesPrefix="group",Group.styles=[getBaseLayoutStyles(Group.CSSPropertiesPrefix),groupStyles()],window.customElements.define("m-group",Group);const defaultStackProps={gap:"spacing-4",align:"stretch",justify:"flex-start"};function stackStyles(){return i$4`
		:host {
			--m-stack-gap: ${getToken(defaultStackProps.gap)};
			--m-stack-align: ${r$4(defaultStackProps.align)};
			--m-stack-justify: ${r$4(defaultStackProps.justify)};

			display: flex;
			flex-direction: column;

			row-gap: var(--m-stack-gap);
			align-items: var(--m-stack-align);
			justify-content: var(--m-stack-justify);
		}
	`}class Stack extends BaseLayout{static get properties(){return{...super.properties,gap:{type:String},align:{type:String},justify:{type:String}}}getCSSPropertiesPrefix(){return Stack.CSSPropertiesPrefix}update(t){super.update(t),t.has("gap")&&this.style.setProperty("--m-stack-gap",toSpacingCSSValue(this.gap,defaultStackProps.gap)),t.has("align")&&this.style.setProperty("--m-stack-align",this.align||defaultStackProps.align),t.has("justify")&&this.style.setProperty("--m-stack-justify",this.justify||defaultStackProps.justify)}render(){return x`<slot></slot>`}}Stack.CSSPropertiesPrefix="stack",Stack.styles=[getBaseLayoutStyles(Stack.CSSPropertiesPrefix),stackStyles()],window.customElements.define("m-stack",Stack);const defaultGridProps={gap:"spacing-4",minColumnWidth:getToken$1("spacing-30")};function gridStyles(){return i$4`
		:host {
			--m-grid-gap: ${getToken(defaultGridProps.gap)};
			--m-grid-min-column-width: ${r$4(defaultGridProps.minColumnWidth)};

			display: grid;

			row-gap: var(--m-grid-row-gap, var(--m-grid-gap));
			column-gap: var(--m-grid-column-gap, var(--m-grid-gap));

			grid-template-columns: repeat(
				auto-fit,
				minmax(min(var(--m-grid-min-column-width), 100%), 1fr)
			);
		}
	`}class Grid extends BaseLayout{static get properties(){return{...super.properties,gap:{type:String},rowGap:{type:String,attribute:"row-gap"},columnGap:{type:String,attribute:"column-gap"},minColumnWidth:{type:String,attribute:"min-column-width"}}}getCSSPropertiesPrefix(){return Grid.CSSPropertiesPrefix}update(t){super.update(t),t.has("gap")&&this.style.setProperty("--m-grid-gap",toSpacingCSSValue(this.gap,defaultGridProps.gap)),t.has("rowGap")&&(this.rowGap?this.style.setProperty("--m-grid-row-gap",toSpacingCSSValue(this.rowGap)):this.style.removeProperty("--m-grid-row-gap")),t.has("columnGap")&&(this.columnGap?this.style.setProperty("--m-grid-column-gap",toSpacingCSSValue(this.columnGap)):this.style.removeProperty("--m-grid-column-gap")),t.has("minColumnWidth")&&this.style.setProperty("--m-grid-min-column-width",this.minColumnWidth||defaultGridProps.minColumnWidth)}render(){return x`<slot></slot>`}}Grid.CSSPropertiesPrefix="grid",Grid.styles=[getBaseLayoutStyles(Grid.CSSPropertiesPrefix),gridStyles()],window.customElements.define("m-grid",Grid);const defaultSidebarProps={gap:"spacing-4",sideWidth:"auto",minContentWidth:"50%",reversed:!1};function getFlexDirectionValue(t){return t?"row-reverse":"row"}function sidebarStyles(){return i$4`
		:host {
			--m-sidebar-gap: ${getToken(defaultSidebarProps.gap)};
			--m-sidebar-flex-direction: ${r$4(getFlexDirectionValue(defaultSidebarProps.reversed))};
			--m-sidebar-side-width: ${r$4(defaultSidebarProps.sideWidth)};
			--m-sidebar-min-content-width: ${r$4(defaultSidebarProps.minContentWidth)};

			display: flex;
			flex-wrap: wrap;
			flex-direction: var(--m-sidebar-flex-direction);

			gap: var(--m-sidebar-gap);
		}

		slot[name='sidebar']::slotted(*) {
			flex-basis: var(--m-sidebar-side-width);
			flex-grow: 1;
		}

		slot[name='content']::slotted(*) {
			flex-basis: 0;
			flex-grow: 999;
			min-width: var(--m-sidebar-min-content-width);
		}
	`}class Sidebar extends BaseLayout{static get properties(){return{...super.properties,gap:{type:String},sideWidth:{type:String,attribute:"side-width"},minContentWidth:{type:String,attribute:"min-content-width"},reversed:{type:Boolean}}}constructor(){super(),this.gap=defaultSidebarProps.gap,this.sideWidth=defaultSidebarProps.sideWidth,this.minContentWidth=defaultSidebarProps.minContentWidth,this.reversed=defaultSidebarProps.reversed}getCSSPropertiesPrefix(){return Sidebar.CSSPropertiesPrefix}update(t){super.update(t),t.has("gap")&&this.style.setProperty("--m-sidebar-gap",toSpacingCSSValue(this.gap,defaultSidebarProps.gap)),t.has("sideWidth")&&this.style.setProperty("--m-sidebar-side-width",this.sideWidth||defaultSidebarProps.sideWidth),t.has("minContentWidth")&&this.style.setProperty("--m-sidebar-min-content-width",this.minContentWidth||defaultSidebarProps.minContentWidth),t.has("reversed")&&this.style.setProperty("--m-sidebar-flex-direction",getFlexDirectionValue(this.reversed))}render(){return x`
			<slot name="sidebar"></slot>
			<slot name="content"></slot>
		`}}Sidebar.CSSPropertiesPrefix="sidebar",Sidebar.styles=[getBaseLayoutStyles(Sidebar.CSSPropertiesPrefix),sidebarStyles()],window.customElements.define("m-sidebar",Sidebar);const defaultSwitcherProps={gap:"spacing-4",threshold:"10rem"};function switcherStyles(){return i$4`
		:host {
			--m-switcher-gap: ${getToken(defaultSwitcherProps.gap)};
			--m-switcher-threshold: ${r$4(defaultSwitcherProps.threshold)};

			display: flex;
			flex-wrap: wrap;

			row-gap: var(--m-switcher-row-gap, var(--m-switcher-gap));
			column-gap: var(--m-switcher-column-gap, var(--m-switcher-gap));
		}

		::slotted(*) {
			flex-basis: calc((var(--m-switcher-threshold) - 100%) * 999);
			flex-grow: 1;
		}
	`}class Switcher extends BaseLayout{static get properties(){return{...super.properties,gap:{type:String},rowGap:{type:String,attribute:"row-gap"},columnGap:{type:String,attribute:"column-gap"},threshold:{type:String},limit:{type:Number}}}getCSSPropertiesPrefix(){return Switcher.CSSPropertiesPrefix}update(t){super.update(t),t.has("gap")&&this.style.setProperty("--m-switcher-gap",toSpacingCSSValue(this.gap,defaultSwitcherProps.gap)),t.has("rowGap")&&(this.rowGap?this.style.setProperty("--m-switcher-row-gap",toSpacingCSSValue(this.rowGap)):this.style.removeProperty("--m-switcher-row-gap")),t.has("columnGap")&&(this.columnGap?this.style.setProperty("--m-switcher-column-gap",toSpacingCSSValue(this.columnGap)):this.style.removeProperty("--m-switcher-column-gap")),t.has("threshold")&&this.style.setProperty("--m-switcher-threshold",this.threshold||defaultSwitcherProps.threshold)}render(){const t=this.limit?x`
					<style>
						::slotted(*:nth-last-child(n + ${this.limit+1})) {
							flex-basis: 100%;
						}
						::slotted(*:nth-last-child(n + ${this.limit+1}) ~ *) {
							flex-basis: 100%;
						}
					</style>
			  `:"";return x`
			${t}
			<slot></slot>
		`}}function range(t,e){return Array.from({length:(e-t)/1+1},((e,o)=>t+1*o))}Switcher.CSSPropertiesPrefix="switcher",Switcher.styles=[getBaseLayoutStyles(Switcher.CSSPropertiesPrefix),switcherStyles()],window.customElements.define("m-switcher",Switcher);const COLUMNS=4,defaultRowProps={gap:"spacing-4"};function generateSlicedStyles(t){return r$4(range(1,COLUMNS).map((e=>`\n\t\t\t\t:host {\n                    flex: 1 1 0%;\n                    max-inline-size: ${100*e/COLUMNS}%;\n\t\t\t\t}\n\n\t\t\t\t:host([${t}="${e}"]) {\n                    flex: 0 0 ${100*e/COLUMNS}%;\n                    max-inline-size: ${100*e/COLUMNS}%;\n\t\t\t\t}\n\n\t\t\t\t:host([offset-${t}="${e}"]) {\n                    margin-inline-start: ${100*e/COLUMNS}%;\n\t\t\t\t}\n\t\t\t`)).join("\n"))}function containerStyles(){return i$4`
		:host {
			--m-column-gap: ${getToken(defaultRowProps.gap)};
			--m-row-gap: ${getToken(defaultRowProps.gap)};

			display: block;
			box-sizing: border-box;

			inline-size: 100%;
			padding-inline: calc(var(--m-column-gap) / -2);
			padding-block: 0;
			margin-inline: auto;
			margin-block: 0;
		}
	`}function rowStyles(){return i$4`
		:host {
			display: flex;
			flex-wrap: wrap;
			margin-inline: calc(var(--m-column-gap) / -2);
			box-sizing: border-box;

			row-gap: var(--m-row-gap);
		}

		:host(:not(:first-of-type)) {
			margin-block: var(--m-row-gap);
		}
	`}function columnStyles(){return i$4`
		:host {
			position: relative;
			inline-size: 100%;
			min-block-size: 1px;
			padding-inline: calc(var(--m-column-gap) / 2);

			box-sizing: border-box;
		}

		${generateSlicedStyles("sm")}

		${mediaTablet(generateSlicedStyles("md"))}

		${mediaDesktop(generateSlicedStyles("lg"))}
	`}class Container extends s$5{render(){return x`<slot name="row"></slot>`}}Container.CSSPropertiesPrefix="container",Container.styles=[containerStyles()],window.customElements.define("m-container",Container);class Row extends s$5{static get properties(){return{...super.properties,gap:{type:String},columnGap:{type:String,attribute:"column-gap"},rowGap:{type:String,attribute:"row-gap"}}}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","row")}update(t){if(super.update(t),t.has("gap")){const t=toSpacingCSSValue(this.gap,defaultRowProps.gap);this.style.setProperty("--m-row-gap",t),this.style.setProperty("--m-column-gap",t)}t.has("rowGap")&&(this.rowGap?this.style.setProperty("--m-row-gap",toSpacingCSSValue(this.rowGap)):this.style.removeProperty("--m-row-gap")),t.has("columnGap")&&(this.columnGap?this.style.setProperty("--m-column-gap",toSpacingCSSValue(this.columnGap)):this.style.removeProperty("--m-column-gap"))}render(){return x`<slot name="column"></slot>`}}Row.CSSPropertiesPrefix="row",Row.styles=[rowStyles()],window.customElements.define("m-row",Row);class Column extends s$5{static get properties(){return{...super.properties,sm:{type:String,reflect:!0},md:{type:String,reflect:!0},lg:{type:String,reflect:!0},offsetSm:{type:String,reflect:!0,attribute:"offset-sm"},offsetMd:{type:String,reflect:!0,attribute:"offset-md"},offsetLg:{type:String,reflect:!0,attribute:"offset-lg"}}}connectedCallback(){super.connectedCallback(),this.slot="column"}update(t){t.has("sm")&&(this.md=this.md??this.sm,this.lg=this.lg??this.md),t.has("md")&&(this.lg=this.lg??this.md),this.offsetSm=this.offsetSm??void 0,t.has("offsetSm")&&(this.offsetMd=this.offsetMd??this.offsetSm,this.offsetLg=this.offsetLg??this.offsetMd),t.has("offsetMd")&&(this.offsetLg=this.offsetLg??this.offsetMd),super.update(t)}render(){return x`<slot></slot>`}}Column.CSSPropertiesPrefix="column",Column.styles=[columnStyles()],window.customElements.define("m-column",Column);const defaultFlagColor="color-background-inverted";class Card extends Component{static get properties(){return{flagged:{type:Boolean},flagColor:{type:String,attribute:"flag-color"},collapsible:{type:Boolean},collapsed:{type:Boolean,state:!0}}}constructor(){super(),this.flagged=!1,this.flagColor=defaultFlagColor,this.collapsible=!1,this.collapsed=!1}toggleCollapse(){this.collapsible&&(this.collapsed=!this.collapsed,this.emit("m-toggle"))}isExpanded(){if(this.collapsible)return this.collapsed?"false":"true"}firstUpdated(){const t=this.querySelector("m-card-title"),e=this.querySelector("m-card-subtitle"),o=this.renderRoot.querySelector(".m-title-wrapper");o&&(t||e?o.classList.remove("hidden"):o.classList.add("hidden"))}render(){return x`
			<div
				class="m-card"
				style="${o$1({"--m-card-flag-color":toCSSValue(this.flagColor)})}"
			>
				${this.flagged?x`<span class="m-card-flag"></span>`:A}
				<div class="m-card-content">
					<m-group justify="space-between" class="m-title-wrapper">
						<m-stack gap="spacing-1">
							<slot name="title"></slot>
							<slot name="subtitle"></slot>
						</m-stack>
						${this.collapsible?x`<button
									id="collapse-trigger"
									class="m-collapse-trigger"
									@click="${this.toggleCollapse}"
									aria-expanded="${l$1(this.isExpanded())}"
									type="button"
							  >
									<m-icon name="caret-down"></m-icon>
							  </button>`:A}
					</m-group>
					<m-stack
						class="${o$2({"m-collapsed-content":!!this.collapsed,"m-card-content":!this.collapsed})}"
					>
						<slot name="divider"></slot>
						<slot name="body"></slot>
						<slot name="footer"></slot>
					</m-stack>
				</div>
			</div>
		`}}Card.styles=[cardStyles()],window.customElements.define("m-card",Card);class CardBody extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="body"}render(){return x`
			<div class="m-card-body">
				<slot></slot>
			</div>
		`}}CardBody.styles=[cardBodyStyles()],window.customElements.define("m-card-body",CardBody);class CardSubtitle extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="subtitle"}render(){return x`
			<div class="m-card-subtitle">
				<slot></slot>
			</div>
		`}}CardSubtitle.styles=[cardSubtitleStyles()],window.customElements.define("m-card-subtitle",CardSubtitle);class CardTitle extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="title"}render(){return x`
			<div class="m-card-title">
				<slot name="leading"></slot>
				<slot></slot>
			</div>
		`}}function styles$v(){return i$4`
		.m-divider {
			border: 0;
			border-block-end: solid 1px ${getColor("color-divider")};
			margin-block-start: var(
				--m-divider-margin-top,
				var(--m-divider-margin-y, 0)
			);
			margin-block-end: var(
				--m-divider-margin-bottom,
				var(--m-divider-margin-y, 0)
			);
		}
	`}CardTitle.styles=[cardTitleStyles()],window.customElements.define("m-card-title",CardTitle);class Divider extends s$5{render(){return x`<hr class="m-divider" />`}}Divider.styles=[styles$v()],window.customElements.define("m-divider",Divider);class CardDivider extends Divider{constructor(){super(),this.slot="divider"}}CardDivider.styles=[...Divider.styles,cardDividerStyles()],CardDivider.properties={slot:{attribute:!0,type:String,reflect:!0}},window.customElements.define("m-card-divider",CardDivider);class CardFooter extends s$5{static get properties(){return{slot:{type:String,reflect:!0},gap:{type:String},align:{type:String},justify:{type:String}}}constructor(){super(),this.slot="footer",this.gap="spacing-2",this.align="stretch",this.justify="flex-start"}render(){return x`<div class="m-card-footer">
			<m-card-divider></m-card-divider>
			<m-group
				gap=${this.gap}
				align=${this.align}
				justify=${this.justify}
				padding-x="spacing-4"
				padding-y="spacing-4"
			>
				<slot></slot>
			</m-group>
		</div>`}}window.customElements.define("m-card-footer",CardFooter);class CardActionPrimary extends Button{constructor(){super(),this.type="button",this.variant="primary"}}window.customElements.define("m-card-action-primary",CardActionPrimary);class CardActionSecondary extends Button{constructor(){super(),this.type="button",this.variant="secondary"}}window.customElements.define("m-card-action-secondary",CardActionSecondary);class CardActionTertiary extends Button{constructor(){super(),this.type="button",this.variant="tertiary"}}window.customElements.define("m-card-action-tertiary",CardActionTertiary);const baseTransitionConfig={delay:"0s",duration:"0.35s",easing:"ease-in-out"};function styles$u(){return i$4`
		${on(".check-input-label").not.disabled.focus} {
			border-radius: 2px;
			outline: 1px solid ${getColor("color-primary-60")};
		}

		.check-input-label {
			${typography("body-md")};

			gap: ${getToken("spacing-1")};
			align-items: center;
			display: inline-flex;
			padding: 4px 2px;
			position: relative;
		}

		.check-input-label,
		.check-input {
			cursor: pointer;
		}

		.check-input {
			--checkbox-input-size: ${getToken("font-size-4")};

			color: ${getColor("color-text-tertiary")};
			width: var(--checkbox-input-size);
			height: var(--checkbox-input-size);
			background: ${getColor("color-neutral-0")};
			appearance: none;
			outline: none;
			border-style: solid;
			border-radius: ${getToken("border-radius-s")};
			border-color: ${getColor("color-border")};
			border-width: ${getToken("border-thin")};
			margin: 0;
			flex-grow: 0;
			flex-shrink: 0;
			flex-basis: var(--checkbox-input-size);
			${transition([{property:"border",...baseTransitionConfig},{property:"background",...baseTransitionConfig}])};
		}

		.check-input:indeterminate,
		.check-input:checked {
			background: ${getColor("color-primary-60")};
			border-color: ${getColor("color-primary-60")};
		}

		${on(".check-input").disabled} {
			background: ${getColor("color-background-tertiary")};
			cursor: not-allowed;
		}

		${on(".check-input:indeterminate").disabled},
		${on(".check-input:checked").disabled} {
			background: ${getColor("color-neutral-40")};
			border-color: ${getColor("color-neutral-40")};
		}

		${on(".check-input:indeterminate").not.disabled.hover},
		${on(".check-input:checked").not.disabled.hover} {
			background: ${getColor("color-primary-100")};
			border-color: ${getColor("color-primary-100")};
		}

		${on(".check-input").not.disabled.hover} {
			border-color: ${getColor("color-primary-100")};
		}

		:host([disabled]) .check-input-label {
			cursor: not-allowed;
			color: ${getColor("color-text-disabled")};
		}

		.check-icon,
		.indeterminate-icon {
			--m-icon-size: 1em;
			--m-icon-color: ${getColor("color-neutral-0")};

			position: absolute;

			pointer-events: none;
			border-width: ${getToken("border-thin")};
			border-style: solid;
			border-color: transparent;
			border-radius: ${getToken("border-radius-s")};
			display: none;
		}

		.check-input:checked:not(:indeterminate) ~ .check-icon,
		.check-input:indeterminate:not(:checked) ~ .indeterminate-icon {
			display: inline-flex;
		}
	`}const CHANGE_EVENT="m-change";var _Checkbox_instances,_Checkbox_setAttributes,_Checkbox_handleChange;class Checkbox extends s$5{static get properties(){return{name:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0},checked:{type:Boolean,reflect:!0},indeterminate:{type:Boolean,reflect:!0}}}constructor(){super(),_Checkbox_instances.add(this),_Checkbox_handleChange.set(this,(t=>{const e=t.target,o=new CustomEvent("m-change",{cancelable:!1,composed:!1,bubbles:!0,detail:{checked:e.checked,indeterminate:e.indeterminate}});this.dispatchEvent(o),this.checked=e.checked,this.indeterminate=e.indeterminate})),this.name=void 0,this.disabled=!1,this.checked=!1,this.indeterminate=!1}connectedCallback(){super.connectedCallback(),this.setAttribute("role","checkbox")}disconnectedCallback(){super.connectedCallback()}firstUpdated(){this.input=this.renderRoot.querySelector("input"),this.label=this.renderRoot.querySelector("label")}updated(){__classPrivateFieldGet(this,_Checkbox_instances,"m",_Checkbox_setAttributes).call(this)}render(){return x`
			<label for="${l$1(this.id)}" class="check-input-label">
				<input
					id="${l$1(this.id)}"
					name="${l$1(this.name)}"
					type="checkbox"
					class="check-input"
					?disabled="${this.disabled}"
					?checked="${this.checked}"
					@change=${__classPrivateFieldGet(this,_Checkbox_handleChange,"f")}
				/>
				<m-icon name="check" class="check-icon"></m-icon>
				<m-icon name="indeterminate" class="indeterminate-icon"></m-icon>
				<slot name="leading"></slot>
				<slot></slot>
			</label>
		`}focus(t){this.input?.focus(t)}}_Checkbox_handleChange=new WeakMap,_Checkbox_instances=new WeakSet,_Checkbox_setAttributes=function(){this.setAttribute("aria-disabled",String(this.disabled??!1)),this.setAttribute("aria-checked",this.indeterminate?"mixed":String(this.checked??!1)),this.input.indeterminate=this.indeterminate,this.input.checked=this.checked},Checkbox.styles=[styles$u()],window.customElements.define("m-checkbox",Checkbox);
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let s$3=class extends Event{constructor(t,e,o){super("context-request",{bubbles:!0,composed:!0}),this.context=t,this.callback=e,this.subscribe=o??!1}};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function n$2(t){return t}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */let s$2=class{constructor(t,e,o,i){if(this.subscribe=!1,this.provided=!1,this.value=void 0,this.t=(t,e)=>{this.unsubscribe&&(this.unsubscribe!==e&&(this.provided=!1,this.unsubscribe()),this.subscribe||this.unsubscribe()),this.value=t,this.host.requestUpdate(),this.provided&&!this.subscribe||(this.provided=!0,this.callback&&this.callback(t,e)),this.unsubscribe=e},this.host=t,void 0!==e.context){const t=e;this.context=t.context,this.callback=t.callback,this.subscribe=t.subscribe??!1}else this.context=e,this.callback=o,this.subscribe=i??!1;this.host.addController(this)}hostConnected(){this.dispatchRequest()}hostDisconnected(){this.unsubscribe&&(this.unsubscribe(),this.unsubscribe=void 0)}dispatchRequest(){this.host.dispatchEvent(new s$3(this.context,this.t,this.subscribe))}},s$1=class{get value(){return this.o}set value(t){this.setValue(t)}setValue(t,e=!1){const o=e||!Object.is(t,this.o);this.o=t,o&&this.updateObservers()}constructor(t){this.subscriptions=new Map,this.updateObservers=()=>{for(const[t,{disposer:e}]of this.subscriptions)t(this.o,e)},void 0!==t&&(this.value=t)}addCallback(t,e,o){if(!o)return void t(this.value);this.subscriptions.has(t)||this.subscriptions.set(t,{disposer:()=>{this.subscriptions.delete(t)},consumerHost:e});const{disposer:i}=this.subscriptions.get(t);t(this.value,i)}clearCallbacks(){this.subscriptions.clear()}},e$2=class extends Event{constructor(t){super("context-provider",{bubbles:!0,composed:!0}),this.context=t}};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */class i extends s$1{constructor(t,e,o){super(void 0!==e.context?e.initialValue:o),this.onContextRequest=t=>{const e=t.composedPath()[0];t.context===this.context&&e!==this.host&&(t.stopPropagation(),this.addCallback(t.callback,e,t.subscribe))},this.onProviderRequest=t=>{const e=t.composedPath()[0];if(t.context!==this.context||e===this.host)return;const o=new Set;for(const[t,{consumerHost:e}]of this.subscriptions)o.has(t)||(o.add(t),e.dispatchEvent(new s$3(this.context,t,!0)));t.stopPropagation()},this.host=t,void 0!==e.context?this.context=e.context:this.context=e,this.attachListeners(),this.host.addController?.(this)}attachListeners(){this.host.addEventListener("context-request",this.onContextRequest),this.host.addEventListener("context-provider",this.onProviderRequest)}hostConnected(){this.host.dispatchEvent(new e$2(this.context))}}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */let t$2=class{constructor(){this.pendingContextRequests=new Map,this.onContextProvider=t=>{const e=this.pendingContextRequests.get(t.context);if(void 0===e)return;this.pendingContextRequests.delete(t.context);const{requests:o}=e;for(const{elementRef:e,callbackRef:i}of o){const o=e.deref(),r=i.deref();void 0===o||void 0===r||o.dispatchEvent(new s$3(t.context,r,!0))}},this.onContextRequest=t=>{if(!0!==t.subscribe)return;const e=t.composedPath()[0],o=t.callback;let i=this.pendingContextRequests.get(t.context);void 0===i&&this.pendingContextRequests.set(t.context,i={callbacks:new WeakMap,requests:[]});let r=i.callbacks.get(e);void 0===r&&i.callbacks.set(e,r=new WeakSet),r.has(o)||(r.add(o),i.requests.push({elementRef:new WeakRef(e),callbackRef:new WeakRef(o)}))}}attach(t){t.addEventListener("context-request",this.onContextRequest),t.addEventListener("context-provider",this.onContextProvider)}detach(t){t.removeEventListener("context-request",this.onContextRequest),t.removeEventListener("context-provider",this.onContextProvider)}};var waitForAnimations_1=async function(t,e){const o=t.getAnimations(e).map((({finished:t})=>t));await Promise.allSettled(o)};let isAttached=!1;function attachContextRoot(){if(isAttached)return;(new t$2).attach(document.body),isAttached=!0}const dialogContext=n$2(Symbol("dialog"));function styles$t(){return i$4`
		:host {
			--margin: ${getToken("spacing-6")};
			--padding: ${getToken("spacing-6")};
			--gap: ${getToken("spacing-6")};
		}

		slot::slotted(*) {
			padding-inline: var(--padding);
			padding-block: calc(var(--gap) / 2);
		}

		dialog {
			box-sizing: border-box;
			padding: calc(var(--padding) - (var(--gap) / 2)) 0;
			border: none;
			border-radius: ${getToken("border-radius-m")};
			background-color: white;
			box-shadow: ${getToken("elevation-4")};
			width: auto;
			max-height: calc(100% - var(--margin));

			${transition([{property:"max-width"}])};
		}

		dialog[open] {
			display: flex;
			flex-direction: column;
		}

		dialog.-size-small {
			max-width: min(${toRem("400px")}, calc(100vw - var(--margin)));
		}

		dialog.-size-medium {
			max-width: min(${toRem("600px")}, calc(100% - var(--margin)));
		}

		dialog.-size-large {
			max-width: min(${toRem("800px")}, calc(100% - var(--margin)));
		}

		dialog.-size-extra-large {
			max-width: min(${toRem("1000px")}, calc(100% - var(--margin)));
		}

		dialog::backdrop {
			background-color: ${getColor("color-background-secondary-inverted",.4)};
		}

		@media (prefers-reduced-motion: no-preference) {
			dialog[open] {
				animation: show-dialog 0.25s ease forwards;
			}

			dialog.is-hiding {
				animation: hide-dialog 0.25s ease forwards;
			}

			dialog[open]::backdrop {
				animation: show-backdrop 0.25s ease forwards;
			}

			dialog.is-hiding::backdrop {
				animation: hide-backdrop 0.25s ease forwards;
			}
		}

		@keyframes show-dialog {
			from {
				opacity: 0;
				transform: translateY(250px);
			}
		}

		@keyframes hide-dialog {
			to {
				opacity: 0;
				transform: scale(0.75);
			}
		}

		@keyframes show-backdrop {
			from {
				opacity: 0;
			}
		}

		@keyframes hide-backdrop {
			to {
				opacity: 0;
			}
		}
	`}var _Dialog_instances,_Dialog_contextProvider,_Dialog_dialog_get,_Dialog_toggleVisibility,_Dialog_emitLifecycleEvent,_Dialog_emitCloseEvent,_Dialog_handleClick,_Dialog_handleCancel;attachContextRoot();class Dialog extends Component{static get properties(){return{open:{type:Boolean,reflect:!0},size:{type:String,reflect:!0},variant:{type:String,reflect:!0}}}constructor(){super(),_Dialog_instances.add(this),_Dialog_contextProvider.set(this,new i(this,dialogContext,{variant:"neutral"})),this.open=!1,this.size="small",this.variant="neutral"}render(){return x`
			<dialog
				class="${o$2({"-size-small":"small"===this.size||!this.size,"-size-medium":"medium"===this.size,"-size-large":"large"===this.size,"-size-extra-large":"extra-large"===this.size})}"
				@click=${__classPrivateFieldGet(this,_Dialog_instances,"m",_Dialog_handleClick)}
				@cancel=${__classPrivateFieldGet(this,_Dialog_instances,"m",_Dialog_handleCancel)}
			>
				<slot name="header"></slot>
				<slot name="body"></slot>
				<slot name="footer"></slot>
				<slot name="actions"></slot>
			</dialog>
		`}updated(t){super.updated(t),t.has("variant")&&__classPrivateFieldGet(this,_Dialog_contextProvider,"f").setValue({variant:this.variant??"neutral"}),t.has("open")&&__classPrivateFieldGet(this,_Dialog_instances,"m",_Dialog_toggleVisibility).call(this,t.get("open"))}show(){this.open=!0}hide(){this.open=!1}}_Dialog_contextProvider=new WeakMap,_Dialog_instances=new WeakSet,_Dialog_dialog_get=function(){return this.renderRoot?.querySelector("dialog")},_Dialog_toggleVisibility=async function(t){const e=__classPrivateFieldGet(this,_Dialog_instances,"a",_Dialog_dialog_get);e&&(!t&&this.open?(this.style.display="block",__classPrivateFieldGet(this,_Dialog_instances,"m",_Dialog_emitLifecycleEvent).call(this,"m-opening"),e.showModal(),await waitForAnimations_1(e),__classPrivateFieldGet(this,_Dialog_instances,"m",_Dialog_emitLifecycleEvent).call(this,"m-opened")):t&&!this.open?(__classPrivateFieldGet(this,_Dialog_instances,"m",_Dialog_emitLifecycleEvent).call(this,"m-closing"),e.classList.add("is-hiding"),await waitForAnimations_1(e),e.classList.remove("is-hiding"),e.close(),__classPrivateFieldGet(this,_Dialog_instances,"m",_Dialog_emitLifecycleEvent).call(this,"m-closed"),this.style.display="none"):null!=t||this.open||(this.style.display="none"))},_Dialog_emitLifecycleEvent=function(t){this.emit(t,{cancelable:!1,bubbles:!1})},_Dialog_emitCloseEvent=function(){this.open&&this.emit("m-close")},_Dialog_handleClick=function(t){const e=t.target instanceof HTMLDialogElement,o=__classPrivateFieldGet(this,_Dialog_instances,"a",_Dialog_dialog_get)?.getBoundingClientRect();if(e&&o){(t.clientY<o.top||t.clientY>o.bottom||t.clientX<o.left||t.clientX>o.right)&&(t.preventDefault(),t.stopPropagation(),__classPrivateFieldGet(this,_Dialog_instances,"m",_Dialog_emitCloseEvent).call(this))}},_Dialog_handleCancel=function(t){t.preventDefault(),__classPrivateFieldGet(this,_Dialog_instances,"m",_Dialog_emitCloseEvent).call(this)},Dialog.styles=[styles$t()],window.customElements.define("m-dialog",Dialog);const DIALOG_SIZES=["small","medium","large","extra-large"],DIALOG_VARIANTS=["neutral","success","warning","danger"];var _DialogActionPrimary_contextCallback,_DialogHeader_instances,_DialogHeader_context,_DialogHeader_icon_get,_Drawer_instances,_Drawer_dialog_get,_Drawer_toggleVisibility,_Drawer_emitLifecycleEvent,_Drawer_emitCloseEvent,_Drawer_handleClick,_Drawer_handleCancel;class DialogActionPrimary extends Button{constructor(){super(),_DialogActionPrimary_contextCallback.set(this,(t=>{switch(t.variant){case"danger":this.variant="danger";break;case"warning":this.variant="warning";break;default:this.variant="primary"}})),this.type="button",this.variant="primary",this.context=new s$2(this,{context:dialogContext,callback:__classPrivateFieldGet(this,_DialogActionPrimary_contextCallback,"f"),subscribe:!0})}}_DialogActionPrimary_contextCallback=new WeakMap,window.customElements.define("m-dialog-action-primary",DialogActionPrimary);class DialogActionSecondary extends Button{constructor(){super(),this.type="button",this.variant="secondary"}}window.customElements.define("m-dialog-action-secondary",DialogActionSecondary);class DialogActionTertiary extends Button{constructor(){super(),this.type="button",this.variant="tertiary"}}window.customElements.define("m-dialog-action-tertiary",DialogActionTertiary);class DialogActions extends Group{constructor(){super(),this.align="center",this.gap="spacing-3",this.justify="flex-end"}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","actions")}}function styles$s(){return i$4`
		:host {
			overflow-y: auto;
			overscroll-behavior: contain;

			${typography("body-md")};
		}
	`}window.customElements.define("m-dialog-actions",DialogActions);class DialogBody extends s$5{connectedCallback(){super.connectedCallback(),this.setAttribute("slot","body")}render(){return x`<slot></slot>`}}DialogBody.styles=[styles$s()],window.customElements.define("m-dialog-body",DialogBody);class DialogClose extends CloseButton{constructor(){super(),this.size="large"}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","close")}}window.customElements.define("m-dialog-close",DialogClose);class DialogFooter extends s$5{connectedCallback(){super.connectedCallback(),this.setAttribute("slot","footer")}render(){return x`<slot></slot>`}}function styles$r(){return i$4`
		h1 {
			margin: 0;
			padding: 0;

			${typography("heading-md-bold")};
		}
	`}window.customElements.define("m-dialog-footer",DialogFooter);class DialogHeader extends Component{constructor(){super(),_DialogHeader_instances.add(this),_DialogHeader_context.set(this,void 0),__classPrivateFieldSet(this,_DialogHeader_context,new s$2(this,{context:dialogContext,subscribe:!0}),"f")}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","header")}render(){return x`
			<m-group gap="spacing-6" align="center">
				<m-group gap="spacing-1" align="center" style="flex-grow: 1;">
					${__classPrivateFieldGet(this,_DialogHeader_instances,"a",_DialogHeader_icon_get)}
					<h1><slot></slot></h1>
				</m-group>
				<slot name="close"></slot>
			</m-group>
		`}}function styles$q(){return i$4`
		:host {
			--margin: ${getToken("spacing-6")};
			--padding: ${getToken("spacing-6")};
			--gap: ${getToken("spacing-6")};
		}

		slot::slotted(*) {
			padding-inline: var(--padding);
			padding-block: calc(var(--gap) / 2);
		}

		:host([size='small']) dialog {
			max-width: ${toRem("416px")};
		}

		:host([size='medium']) dialog {
			max-width: 640px;
		}

		dialog {
			box-sizing: border-box;
			padding: calc(var(--padding) - (var(--gap) / 2)) 0;
			border: none;
			border-left: 1px solid ${getColor("color-border")};
			background-color: ${getColor("color-background-primary")};
			width: 100%;
			height: 100%;
			max-height: 100%;
			position: fixed;
			top: 0;
			right: 0;
			left: auto;
			margin: 0;

			${transition([{property:"max-width"}])};
		}

		dialog[open] {
			display: flex;
			flex-direction: column;
		}

		dialog::backdrop {
			background-color: ${getColor("color-background-secondary-inverted",.4)};
		}

		@media (prefers-reduced-motion: no-preference) {
			dialog[open] {
				animation: show-dialog 0.25s ease forwards;
			}

			dialog.is-hiding {
				animation: hide-dialog 0.25s ease forwards;
			}

			dialog.is-hiding {
				animation: hide-dialog 0.25s ease forwards;
			}

			dialog[open]::backdrop {
				animation: show-backdrop 0.25s ease forwards;
			}

			dialog.is-hiding::backdrop {
				animation: hide-backdrop 0.25s ease forwards;
			}
		}

		@keyframes show-dialog {
			from {
				opacity: 0;
				transform: translateX(250px);
			}
		}

		@keyframes hide-dialog {
			to {
				opacity: 0;
				transform: translateX(250px);
			}
		}

		@keyframes show-backdrop {
			from {
				opacity: 0;
			}
		}

		@keyframes hide-backdrop {
			to {
				opacity: 0;
			}
		}
	`}_DialogHeader_context=new WeakMap,_DialogHeader_instances=new WeakSet,_DialogHeader_icon_get=function(){const{value:t}=__classPrivateFieldGet(this,_DialogHeader_context,"f");let e,o;switch(t?.variant){case"danger":e="attention",o="color-danger-60";break;case"warning":e="alert-circle",o="color-warning-60";break;case"success":e="check",o="color-success-60";break;default:return A}return x`
			<m-icon name=${e} color=${o} size="24" aria-hidden="true"></m-icon>
		`},DialogHeader.styles=[styles$r()],window.customElements.define("m-dialog-header",DialogHeader),attachContextRoot();class Drawer extends Component{static get properties(){return{open:{type:Boolean,reflect:!0},size:{type:String,reflect:!0},icon:{type:String,reflect:!0}}}constructor(){super(),_Drawer_instances.add(this),this.open=!1,this.size="small"}render(){return x`
			<dialog @click=${__classPrivateFieldGet(this,_Drawer_instances,"m",_Drawer_handleClick)} @cancel=${__classPrivateFieldGet(this,_Drawer_instances,"m",_Drawer_handleCancel)}>
				<slot name="header"></slot>
				<slot name="body"></slot>
				<slot name="actions"></slot>
			</dialog>
		`}updated(t){super.updated(t),t.has("open")&&__classPrivateFieldGet(this,_Drawer_instances,"m",_Drawer_toggleVisibility).call(this,t.get("open"))}show(){this.open=!0}hide(){this.open=!1}}_Drawer_instances=new WeakSet,_Drawer_dialog_get=function(){return this.renderRoot?.querySelector("dialog")},_Drawer_toggleVisibility=async function(t){const e=__classPrivateFieldGet(this,_Drawer_instances,"a",_Drawer_dialog_get);e&&(!t&&this.open?(this.style.display="block",__classPrivateFieldGet(this,_Drawer_instances,"m",_Drawer_emitLifecycleEvent).call(this,"m-opening"),e.showModal(),await waitForAnimations_1(e),__classPrivateFieldGet(this,_Drawer_instances,"m",_Drawer_emitLifecycleEvent).call(this,"m-opened")):t&&!this.open?(__classPrivateFieldGet(this,_Drawer_instances,"m",_Drawer_emitLifecycleEvent).call(this,"m-closing"),e.classList.add("is-hiding"),await waitForAnimations_1(e),e.classList.remove("is-hiding"),e.close(),__classPrivateFieldGet(this,_Drawer_instances,"m",_Drawer_emitLifecycleEvent).call(this,"m-closed"),this.style.display="none"):null!=t||this.open||(this.style.display="none"))},_Drawer_emitLifecycleEvent=function(t){this.emit(t,{cancelable:!1,bubbles:!1})},_Drawer_emitCloseEvent=function(){this.open&&this.emit("m-close")},_Drawer_handleClick=function(t){const e=t.target instanceof HTMLDialogElement,o=__classPrivateFieldGet(this,_Drawer_instances,"a",_Drawer_dialog_get)?.getBoundingClientRect();if(e&&o){(t.clientY<o.top||t.clientY>o.bottom||t.clientX<o.left||t.clientX>o.right)&&(t.preventDefault(),t.stopPropagation(),__classPrivateFieldGet(this,_Drawer_instances,"m",_Drawer_emitCloseEvent).call(this))}},_Drawer_handleCancel=function(t){t.preventDefault(),__classPrivateFieldGet(this,_Drawer_instances,"m",_Drawer_emitCloseEvent).call(this)},Drawer.styles=[styles$q()],window.customElements.define("m-drawer",Drawer);const DRAWER_SIZES=["small","medium"];class DrawerActionPrimary extends Button{constructor(){super(),this.variant="primary"}}window.customElements.define("m-drawer-action-primary",DrawerActionPrimary);class DrawerActionSecondary extends Button{constructor(){super(),this.variant="secondary"}}window.customElements.define("m-drawer-action-secondary",DrawerActionSecondary);class DrawerActionTertiary extends Button{constructor(){super(),this.variant="tertiary"}}function styles$p(){return i$4`
		:host {
			margin-top: auto;
			margin-left: auto;
		}
	`}window.customElements.define("m-drawer-action-tertiary",DrawerActionTertiary);class DrawerActions extends Group{constructor(){super(),this.align="center",this.gap="spacing-3",this.justify="flex-end"}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","actions")}}function styles$o(){return i$4`
		:host {
			overflow-y: auto;
			overscroll-behavior: contain;

			${typography("body-md")};
		}
	`}DrawerActions.styles=[...Group.styles,styles$p()],window.customElements.define("m-drawer-actions",DrawerActions);class DrawerBody extends s$5{connectedCallback(){super.connectedCallback(),this.setAttribute("slot","body")}render(){return x`<slot></slot>`}}DrawerBody.styles=[styles$o()],window.customElements.define("m-drawer-body",DrawerBody);class DrawerClose extends CloseButton{constructor(){super(),this.size="large"}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","close")}}function styles$n(){return i$4`
		h1 {
			margin: 0;
			padding: 0;

			${typography("heading-md-bold")};
		}
	`}window.customElements.define("m-drawer-close",DrawerClose);class DrawerHeader extends Component{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="header"}render(){return x`
			<m-group gap="spacing-6" align="center">
				<m-group gap="spacing-1" align="center" style="flex-grow: 1;">
					<slot name="leading"></slot>
					<h1><slot></slot></h1>
				</m-group>
				<slot name="close"></slot>
			</m-group>
		`}}DrawerHeader.styles=[styles$n()],window.customElements.define("m-drawer-header",DrawerHeader);const sides=["top","right","bottom","left"],min=Math.min,max=Math.max,round=Math.round,floor=Math.floor,createCoords=t=>({x:t,y:t}),oppositeSideMap={left:"right",right:"left",bottom:"top",top:"bottom"},oppositeAlignmentMap={start:"end",end:"start"};function clamp$1(t,e,o){return max(t,min(e,o))}function evaluate(t,e){return"function"==typeof t?t(e):t}function getSide(t){return t.split("-")[0]}function getAlignment(t){return t.split("-")[1]}function getOppositeAxis(t){return"x"===t?"y":"x"}function getAxisLength(t){return"y"===t?"height":"width"}function getSideAxis(t){return["top","bottom"].includes(getSide(t))?"y":"x"}function getAlignmentAxis(t){return getOppositeAxis(getSideAxis(t))}function getAlignmentSides(t,e,o){void 0===o&&(o=!1);const i=getAlignment(t),r=getAlignmentAxis(t),n=getAxisLength(r);let s="x"===r?i===(o?"end":"start")?"right":"left":"start"===i?"bottom":"top";return e.reference[n]>e.floating[n]&&(s=getOppositePlacement(s)),[s,getOppositePlacement(s)]}function getExpandedPlacements(t){const e=getOppositePlacement(t);return[getOppositeAlignmentPlacement(t),e,getOppositeAlignmentPlacement(e)]}function getOppositeAlignmentPlacement(t){return t.replace(/start|end/g,(t=>oppositeAlignmentMap[t]))}function getSideList(t,e,o){const i=["left","right"],r=["right","left"],n=["top","bottom"],s=["bottom","top"];switch(t){case"top":case"bottom":return o?e?r:i:e?i:r;case"left":case"right":return e?n:s;default:return[]}}function getOppositeAxisPlacements(t,e,o,i){const r=getAlignment(t);let n=getSideList(getSide(t),"start"===o,i);return r&&(n=n.map((t=>t+"-"+r)),e&&(n=n.concat(n.map(getOppositeAlignmentPlacement)))),n}function getOppositePlacement(t){return t.replace(/left|right|bottom|top/g,(t=>oppositeSideMap[t]))}function expandPaddingObject(t){return{top:0,right:0,bottom:0,left:0,...t}}function getPaddingObject(t){return"number"!=typeof t?expandPaddingObject(t):{top:t,right:t,bottom:t,left:t}}function rectToClientRect(t){return{...t,top:t.y,left:t.x,right:t.x+t.width,bottom:t.y+t.height}}function computeCoordsFromPlacement(t,e,o){let{reference:i,floating:r}=t;const n=getSideAxis(e),s=getAlignmentAxis(e),a=getAxisLength(s),l=getSide(e),c="y"===n,d=i.x+i.width/2-r.width/2,h=i.y+i.height/2-r.height/2,u=i[a]/2-r[a]/2;let g;switch(l){case"top":g={x:d,y:i.y-r.height};break;case"bottom":g={x:d,y:i.y+i.height};break;case"right":g={x:i.x+i.width,y:h};break;case"left":g={x:i.x-r.width,y:h};break;default:g={x:i.x,y:i.y}}switch(getAlignment(e)){case"start":g[s]-=u*(o&&c?-1:1);break;case"end":g[s]+=u*(o&&c?-1:1)}return g}const computePosition$1=async(t,e,o)=>{const{placement:i="bottom",strategy:r="absolute",middleware:n=[],platform:s}=o,a=n.filter(Boolean),l=await(null==s.isRTL?void 0:s.isRTL(e));let c=await s.getElementRects({reference:t,floating:e,strategy:r}),{x:d,y:h}=computeCoordsFromPlacement(c,i,l),u=i,g={},p=0;for(let o=0;o<a.length;o++){const{name:n,fn:m}=a[o],{x:b,y:_,data:f,reset:y}=await m({x:d,y:h,initialPlacement:i,placement:u,strategy:r,middlewareData:g,rects:c,platform:s,elements:{reference:t,floating:e}});d=null!=b?b:d,h=null!=_?_:h,g={...g,[n]:{...g[n],...f}},y&&p<=50&&(p++,"object"==typeof y&&(y.placement&&(u=y.placement),y.rects&&(c=!0===y.rects?await s.getElementRects({reference:t,floating:e,strategy:r}):y.rects),({x:d,y:h}=computeCoordsFromPlacement(c,u,l))),o=-1)}return{x:d,y:h,placement:u,strategy:r,middlewareData:g}};async function detectOverflow(t,e){var o;void 0===e&&(e={});const{x:i,y:r,platform:n,rects:s,elements:a,strategy:l}=t,{boundary:c="clippingAncestors",rootBoundary:d="viewport",elementContext:h="floating",altBoundary:u=!1,padding:g=0}=evaluate(e,t),p=getPaddingObject(g),m=a[u?"floating"===h?"reference":"floating":h],b=rectToClientRect(await n.getClippingRect({element:null==(o=await(null==n.isElement?void 0:n.isElement(m)))||o?m:m.contextElement||await(null==n.getDocumentElement?void 0:n.getDocumentElement(a.floating)),boundary:c,rootBoundary:d,strategy:l})),_="floating"===h?{...s.floating,x:i,y:r}:s.reference,f=await(null==n.getOffsetParent?void 0:n.getOffsetParent(a.floating)),y=await(null==n.isElement?void 0:n.isElement(f))&&await(null==n.getScale?void 0:n.getScale(f))||{x:1,y:1},$=rectToClientRect(n.convertOffsetParentRelativeRectToViewportRelativeRect?await n.convertOffsetParentRelativeRectToViewportRelativeRect({elements:a,rect:_,offsetParent:f,strategy:l}):_);return{top:(b.top-$.top+p.top)/y.y,bottom:($.bottom-b.bottom+p.bottom)/y.y,left:(b.left-$.left+p.left)/y.x,right:($.right-b.right+p.right)/y.x}}const arrow$1=t=>({name:"arrow",options:t,async fn(e){const{x:o,y:i,placement:r,rects:n,platform:s,elements:a,middlewareData:l}=e,{element:c,padding:d=0}=evaluate(t,e)||{};if(null==c)return{};const h=getPaddingObject(d),u={x:o,y:i},g=getAlignmentAxis(r),p=getAxisLength(g),m=await s.getDimensions(c),b="y"===g,_=b?"top":"left",f=b?"bottom":"right",y=b?"clientHeight":"clientWidth",$=n.reference[p]+n.reference[g]-u[g]-n.floating[p],v=u[g]-n.reference[g],x=await(null==s.getOffsetParent?void 0:s.getOffsetParent(c));let w=x?x[y]:0;w&&await(null==s.isElement?void 0:s.isElement(x))||(w=a.floating[y]||n.floating[p]);const k=$/2-v/2,S=w/2-m[p]/2-1,C=min(h[_],S),T=min(h[f],S),P=C,F=w-m[p]-T,z=w/2-m[p]/2+k,B=clamp$1(P,z,F),A=!l.arrow&&null!=getAlignment(r)&&z!==B&&n.reference[p]/2-(z<P?C:T)-m[p]/2<0,E=A?z<P?z-P:z-F:0;return{[g]:u[g]+E,data:{[g]:B,centerOffset:z-B-E,...A&&{alignmentOffset:E}},reset:A}}}),flip$1=function(t){return void 0===t&&(t={}),{name:"flip",options:t,async fn(e){var o,i;const{placement:r,middlewareData:n,rects:s,initialPlacement:a,platform:l,elements:c}=e,{mainAxis:d=!0,crossAxis:h=!0,fallbackPlacements:u,fallbackStrategy:g="bestFit",fallbackAxisSideDirection:p="none",flipAlignment:m=!0,...b}=evaluate(t,e);if(null!=(o=n.arrow)&&o.alignmentOffset)return{};const _=getSide(r),f=getSide(a)===a,y=await(null==l.isRTL?void 0:l.isRTL(c.floating)),$=u||(f||!m?[getOppositePlacement(a)]:getExpandedPlacements(a));u||"none"===p||$.push(...getOppositeAxisPlacements(a,m,p,y));const v=[a,...$],x=await detectOverflow(e,b),w=[];let k=(null==(i=n.flip)?void 0:i.overflows)||[];if(d&&w.push(x[_]),h){const t=getAlignmentSides(r,s,y);w.push(x[t[0]],x[t[1]])}if(k=[...k,{placement:r,overflows:w}],!w.every((t=>t<=0))){var S,C;const t=((null==(S=n.flip)?void 0:S.index)||0)+1,e=v[t];if(e)return{data:{index:t,overflows:k},reset:{placement:e}};let o=null==(C=k.filter((t=>t.overflows[0]<=0)).sort(((t,e)=>t.overflows[1]-e.overflows[1]))[0])?void 0:C.placement;if(!o)switch(g){case"bestFit":{var T;const t=null==(T=k.map((t=>[t.placement,t.overflows.filter((t=>t>0)).reduce(((t,e)=>t+e),0)])).sort(((t,e)=>t[1]-e[1]))[0])?void 0:T[0];t&&(o=t);break}case"initialPlacement":o=a}if(r!==o)return{reset:{placement:o}}}return{}}}};function getSideOffsets(t,e){return{top:t.top-e.height,right:t.right-e.width,bottom:t.bottom-e.height,left:t.left-e.width}}function isAnySideFullyClipped(t){return sides.some((e=>t[e]>=0))}const hide$1=function(t){return void 0===t&&(t={}),{name:"hide",options:t,async fn(e){const{rects:o}=e,{strategy:i="referenceHidden",...r}=evaluate(t,e);switch(i){case"referenceHidden":{const t=getSideOffsets(await detectOverflow(e,{...r,elementContext:"reference"}),o.reference);return{data:{referenceHiddenOffsets:t,referenceHidden:isAnySideFullyClipped(t)}}}case"escaped":{const t=getSideOffsets(await detectOverflow(e,{...r,altBoundary:!0}),o.floating);return{data:{escapedOffsets:t,escaped:isAnySideFullyClipped(t)}}}default:return{}}}}},shift$1=function(t){return void 0===t&&(t={}),{name:"shift",options:t,async fn(e){const{x:o,y:i,placement:r}=e,{mainAxis:n=!0,crossAxis:s=!1,limiter:a={fn:t=>{let{x:e,y:o}=t;return{x:e,y:o}}},...l}=evaluate(t,e),c={x:o,y:i},d=await detectOverflow(e,l),h=getSideAxis(getSide(r)),u=getOppositeAxis(h);let g=c[u],p=c[h];if(n){const t="y"===u?"bottom":"right";g=clamp$1(g+d["y"===u?"top":"left"],g,g-d[t])}if(s){const t="y"===h?"bottom":"right";p=clamp$1(p+d["y"===h?"top":"left"],p,p-d[t])}const m=a.fn({...e,[u]:g,[h]:p});return{...m,data:{x:m.x-o,y:m.y-i}}}}};function getNodeName(t){return isNode(t)?(t.nodeName||"").toLowerCase():"#document"}function getWindow(t){var e;return(null==t||null==(e=t.ownerDocument)?void 0:e.defaultView)||window}function getDocumentElement(t){var e;return null==(e=(isNode(t)?t.ownerDocument:t.document)||window.document)?void 0:e.documentElement}function isNode(t){return t instanceof Node||t instanceof getWindow(t).Node}function isElement(t){return t instanceof Element||t instanceof getWindow(t).Element}function isHTMLElement(t){return t instanceof HTMLElement||t instanceof getWindow(t).HTMLElement}function isShadowRoot(t){return"undefined"!=typeof ShadowRoot&&(t instanceof ShadowRoot||t instanceof getWindow(t).ShadowRoot)}function isOverflowElement(t){const{overflow:e,overflowX:o,overflowY:i,display:r}=getComputedStyle$1(t);return/auto|scroll|overlay|hidden|clip/.test(e+i+o)&&!["inline","contents"].includes(r)}function isTableElement(t){return["table","td","th"].includes(getNodeName(t))}function isContainingBlock(t){const e=isWebKit(),o=getComputedStyle$1(t);return"none"!==o.transform||"none"!==o.perspective||!!o.containerType&&"normal"!==o.containerType||!e&&!!o.backdropFilter&&"none"!==o.backdropFilter||!e&&!!o.filter&&"none"!==o.filter||["transform","perspective","filter"].some((t=>(o.willChange||"").includes(t)))||["paint","layout","strict","content"].some((t=>(o.contain||"").includes(t)))}function getContainingBlock(t){let e=getParentNode(t);for(;isHTMLElement(e)&&!isLastTraversableNode(e);){if(isContainingBlock(e))return e;e=getParentNode(e)}return null}function isWebKit(){return!("undefined"==typeof CSS||!CSS.supports)&&CSS.supports("-webkit-backdrop-filter","none")}function isLastTraversableNode(t){return["html","body","#document"].includes(getNodeName(t))}function getComputedStyle$1(t){return getWindow(t).getComputedStyle(t)}function getNodeScroll(t){return isElement(t)?{scrollLeft:t.scrollLeft,scrollTop:t.scrollTop}:{scrollLeft:t.pageXOffset,scrollTop:t.pageYOffset}}function getParentNode(t){if("html"===getNodeName(t))return t;const e=t.assignedSlot||t.parentNode||isShadowRoot(t)&&t.host||getDocumentElement(t);return isShadowRoot(e)?e.host:e}function getNearestOverflowAncestor(t){const e=getParentNode(t);return isLastTraversableNode(e)?t.ownerDocument?t.ownerDocument.body:t.body:isHTMLElement(e)&&isOverflowElement(e)?e:getNearestOverflowAncestor(e)}function getOverflowAncestors(t,e,o){var i;void 0===e&&(e=[]),void 0===o&&(o=!0);const r=getNearestOverflowAncestor(t),n=r===(null==(i=t.ownerDocument)?void 0:i.body),s=getWindow(r);return n?e.concat(s,s.visualViewport||[],isOverflowElement(r)?r:[],s.frameElement&&o?getOverflowAncestors(s.frameElement):[]):e.concat(r,getOverflowAncestors(r,[],o))}function getCssDimensions(t){const e=getComputedStyle$1(t);let o=parseFloat(e.width)||0,i=parseFloat(e.height)||0;const r=isHTMLElement(t),n=r?t.offsetWidth:o,s=r?t.offsetHeight:i,a=round(o)!==n||round(i)!==s;return a&&(o=n,i=s),{width:o,height:i,$:a}}function unwrapElement(t){return isElement(t)?t:t.contextElement}function getScale(t){const e=unwrapElement(t);if(!isHTMLElement(e))return createCoords(1);const o=e.getBoundingClientRect(),{width:i,height:r,$:n}=getCssDimensions(e);let s=(n?round(o.width):o.width)/i,a=(n?round(o.height):o.height)/r;return s&&Number.isFinite(s)||(s=1),a&&Number.isFinite(a)||(a=1),{x:s,y:a}}const noOffsets=createCoords(0);function getVisualOffsets(t){const e=getWindow(t);return isWebKit()&&e.visualViewport?{x:e.visualViewport.offsetLeft,y:e.visualViewport.offsetTop}:noOffsets}function shouldAddVisualOffsets(t,e,o){return void 0===e&&(e=!1),!(!o||e&&o!==getWindow(t))&&e}function getBoundingClientRect(t,e,o,i){void 0===e&&(e=!1),void 0===o&&(o=!1);const r=t.getBoundingClientRect(),n=unwrapElement(t);let s=createCoords(1);e&&(i?isElement(i)&&(s=getScale(i)):s=getScale(t));const a=shouldAddVisualOffsets(n,o,i)?getVisualOffsets(n):createCoords(0);let l=(r.left+a.x)/s.x,c=(r.top+a.y)/s.y,d=r.width/s.x,h=r.height/s.y;if(n){const t=getWindow(n),e=i&&isElement(i)?getWindow(i):i;let o=t,r=o.frameElement;for(;r&&i&&e!==o;){const t=getScale(r),e=r.getBoundingClientRect(),i=getComputedStyle$1(r),n=e.left+(r.clientLeft+parseFloat(i.paddingLeft))*t.x,s=e.top+(r.clientTop+parseFloat(i.paddingTop))*t.y;l*=t.x,c*=t.y,d*=t.x,h*=t.y,l+=n,c+=s,o=getWindow(r),r=o.frameElement}}return rectToClientRect({width:d,height:h,x:l,y:c})}const topLayerSelectors=[":popover-open",":modal"];function isTopLayer(t){return topLayerSelectors.some((e=>{try{return t.matches(e)}catch(t){return!1}}))}function convertOffsetParentRelativeRectToViewportRelativeRect(t){let{elements:e,rect:o,offsetParent:i,strategy:r}=t;const n="fixed"===r,s=getDocumentElement(i),a=!!e&&isTopLayer(e.floating);if(i===s||a&&n)return o;let l={scrollLeft:0,scrollTop:0},c=createCoords(1);const d=createCoords(0),h=isHTMLElement(i);if((h||!h&&!n)&&(("body"!==getNodeName(i)||isOverflowElement(s))&&(l=getNodeScroll(i)),isHTMLElement(i))){const t=getBoundingClientRect(i);c=getScale(i),d.x=t.x+i.clientLeft,d.y=t.y+i.clientTop}return{width:o.width*c.x,height:o.height*c.y,x:o.x*c.x-l.scrollLeft*c.x+d.x,y:o.y*c.y-l.scrollTop*c.y+d.y}}function getClientRects(t){return Array.from(t.getClientRects())}function getWindowScrollBarX(t){return getBoundingClientRect(getDocumentElement(t)).left+getNodeScroll(t).scrollLeft}function getDocumentRect(t){const e=getDocumentElement(t),o=getNodeScroll(t),i=t.ownerDocument.body,r=max(e.scrollWidth,e.clientWidth,i.scrollWidth,i.clientWidth),n=max(e.scrollHeight,e.clientHeight,i.scrollHeight,i.clientHeight);let s=-o.scrollLeft+getWindowScrollBarX(t);const a=-o.scrollTop;return"rtl"===getComputedStyle$1(i).direction&&(s+=max(e.clientWidth,i.clientWidth)-r),{width:r,height:n,x:s,y:a}}function getViewportRect(t,e){const o=getWindow(t),i=getDocumentElement(t),r=o.visualViewport;let n=i.clientWidth,s=i.clientHeight,a=0,l=0;if(r){n=r.width,s=r.height;const t=isWebKit();(!t||t&&"fixed"===e)&&(a=r.offsetLeft,l=r.offsetTop)}return{width:n,height:s,x:a,y:l}}function getInnerBoundingClientRect(t,e){const o=getBoundingClientRect(t,!0,"fixed"===e),i=o.top+t.clientTop,r=o.left+t.clientLeft,n=isHTMLElement(t)?getScale(t):createCoords(1);return{width:t.clientWidth*n.x,height:t.clientHeight*n.y,x:r*n.x,y:i*n.y}}function getClientRectFromClippingAncestor(t,e,o){let i;if("viewport"===e)i=getViewportRect(t,o);else if("document"===e)i=getDocumentRect(getDocumentElement(t));else if(isElement(e))i=getInnerBoundingClientRect(e,o);else{const o=getVisualOffsets(t);i={...e,x:e.x-o.x,y:e.y-o.y}}return rectToClientRect(i)}function hasFixedPositionAncestor(t,e){const o=getParentNode(t);return!(o===e||!isElement(o)||isLastTraversableNode(o))&&("fixed"===getComputedStyle$1(o).position||hasFixedPositionAncestor(o,e))}function getClippingElementAncestors(t,e){const o=e.get(t);if(o)return o;let i=getOverflowAncestors(t,[],!1).filter((t=>isElement(t)&&"body"!==getNodeName(t))),r=null;const n="fixed"===getComputedStyle$1(t).position;let s=n?getParentNode(t):t;for(;isElement(s)&&!isLastTraversableNode(s);){const e=getComputedStyle$1(s),o=isContainingBlock(s);o||"fixed"!==e.position||(r=null);(n?!o&&!r:!o&&"static"===e.position&&!!r&&["absolute","fixed"].includes(r.position)||isOverflowElement(s)&&!o&&hasFixedPositionAncestor(t,s))?i=i.filter((t=>t!==s)):r=e,s=getParentNode(s)}return e.set(t,i),i}function getClippingRect(t){let{element:e,boundary:o,rootBoundary:i,strategy:r}=t;const n=[..."clippingAncestors"===o?getClippingElementAncestors(e,this._c):[].concat(o),i],s=n[0],a=n.reduce(((t,o)=>{const i=getClientRectFromClippingAncestor(e,o,r);return t.top=max(i.top,t.top),t.right=min(i.right,t.right),t.bottom=min(i.bottom,t.bottom),t.left=max(i.left,t.left),t}),getClientRectFromClippingAncestor(e,s,r));return{width:a.right-a.left,height:a.bottom-a.top,x:a.left,y:a.top}}function getDimensions(t){const{width:e,height:o}=getCssDimensions(t);return{width:e,height:o}}function getRectRelativeToOffsetParent(t,e,o){const i=isHTMLElement(e),r=getDocumentElement(e),n="fixed"===o,s=getBoundingClientRect(t,!0,n,e);let a={scrollLeft:0,scrollTop:0};const l=createCoords(0);if(i||!i&&!n)if(("body"!==getNodeName(e)||isOverflowElement(r))&&(a=getNodeScroll(e)),i){const t=getBoundingClientRect(e,!0,n,e);l.x=t.x+e.clientLeft,l.y=t.y+e.clientTop}else r&&(l.x=getWindowScrollBarX(r));return{x:s.left+a.scrollLeft-l.x,y:s.top+a.scrollTop-l.y,width:s.width,height:s.height}}function getTrueOffsetParent(t,e){return isHTMLElement(t)&&"fixed"!==getComputedStyle$1(t).position?e?e(t):t.offsetParent:null}function getOffsetParent(t,e){const o=getWindow(t);if(!isHTMLElement(t)||isTopLayer(t))return o;let i=getTrueOffsetParent(t,e);for(;i&&isTableElement(i)&&"static"===getComputedStyle$1(i).position;)i=getTrueOffsetParent(i,e);return i&&("html"===getNodeName(i)||"body"===getNodeName(i)&&"static"===getComputedStyle$1(i).position&&!isContainingBlock(i))?o:i||getContainingBlock(t)||o}const getElementRects=async function(t){const e=this.getOffsetParent||getOffsetParent,o=this.getDimensions;return{reference:getRectRelativeToOffsetParent(t.reference,await e(t.floating),t.strategy),floating:{x:0,y:0,...await o(t.floating)}}};function isRTL(t){return"rtl"===getComputedStyle$1(t).direction}const platform={convertOffsetParentRelativeRectToViewportRelativeRect,getDocumentElement,getClippingRect,getOffsetParent,getElementRects,getClientRects,getDimensions,getScale,isElement,isRTL};function observeMove(t,e){let o,i=null;const r=getDocumentElement(t);function n(){var t;clearTimeout(o),null==(t=i)||t.disconnect(),i=null}return function s(a,l){void 0===a&&(a=!1),void 0===l&&(l=1),n();const{left:c,top:d,width:h,height:u}=t.getBoundingClientRect();if(a||e(),!h||!u)return;const g={rootMargin:-floor(d)+"px "+-floor(r.clientWidth-(c+h))+"px "+-floor(r.clientHeight-(d+u))+"px "+-floor(c)+"px",threshold:max(0,min(1,l))||1};let p=!0;function m(t){const e=t[0].intersectionRatio;if(e!==l){if(!p)return s();e?s(!1,e):o=setTimeout((()=>{s(!1,1e-7)}),100)}p=!1}try{i=new IntersectionObserver(m,{...g,root:r.ownerDocument})}catch(t){i=new IntersectionObserver(m,g)}i.observe(t)}(!0),n}function autoUpdate(t,e,o,i){void 0===i&&(i={});const{ancestorScroll:r=!0,ancestorResize:n=!0,elementResize:s="function"==typeof ResizeObserver,layoutShift:a="function"==typeof IntersectionObserver,animationFrame:l=!1}=i,c=unwrapElement(t),d=r||n?[...c?getOverflowAncestors(c):[],...getOverflowAncestors(e)]:[];d.forEach((t=>{r&&t.addEventListener("scroll",o,{passive:!0}),n&&t.addEventListener("resize",o)}));const h=c&&a?observeMove(c,o):null;let u,g=-1,p=null;s&&(p=new ResizeObserver((t=>{let[i]=t;i&&i.target===c&&p&&(p.unobserve(e),cancelAnimationFrame(g),g=requestAnimationFrame((()=>{var t;null==(t=p)||t.observe(e)}))),o()})),c&&!l&&p.observe(c),p.observe(e));let m=l?getBoundingClientRect(t):null;return l&&function e(){const i=getBoundingClientRect(t);!m||i.x===m.x&&i.y===m.y&&i.width===m.width&&i.height===m.height||o();m=i,u=requestAnimationFrame(e)}(),o(),()=>{var t;d.forEach((t=>{r&&t.removeEventListener("scroll",o),n&&t.removeEventListener("resize",o)})),null==h||h(),null==(t=p)||t.disconnect(),p=null,l&&cancelAnimationFrame(u)}}const shift=shift$1,flip=flip$1,hide=hide$1,arrow=arrow$1,computePosition=(t,e,o)=>{const i=new Map,r={platform,...o},n={...r.platform,_c:i};return computePosition$1(t,e,{...r,platform:n})};function offsetParent(t){return offsetParentPolyfill(t)}function flatTreeParent(t){return t.assignedSlot?t.assignedSlot:t.parentNode instanceof ShadowRoot?t.parentNode.host:t.parentNode}function offsetParentPolyfill(t){for(let e=t;e;e=flatTreeParent(e))if(e instanceof Element&&"none"===getComputedStyle(e).display)return null;for(let e=flatTreeParent(t);e;e=flatTreeParent(e)){if(!(e instanceof Element))continue;const t=getComputedStyle(e);if("contents"!==t.display){if("static"!==t.position||"none"!==t.filter)return e;if("BODY"===e.tagName)return e}}return null}function supportsPopover(){return Object.hasOwn(HTMLElement.prototype,"popover")}function isPopover(t){return!!t&&(supportsPopover()&&t.matches("[popover]"))}function getPositionOffset(t,e,o){const i="var(--m-popover-arrow-size)";switch(e){case"top":case"left":return t?`-1 * ${i} - ${o}px`:`-1 * ${o}px`;case"bottom":case"right":return t?`${i} + ${o}px`:`${o}px`;default:return"0px"}}var _Popover_updateCleanup,_Popover_getArrowPosition;const POPOVER_PLACEMENT_VALUES=["top","left","right","bottom","top-start","top-end","bottom-start","bottom-end"];class Popover extends Component{static get properties(){return{position:{type:String,reflect:!0},placement:{type:String},open:{type:Boolean,reflect:!0},asPopover:{type:Boolean,attribute:"as-popover"}}}constructor(){super(),_Popover_updateCleanup.set(this,void 0),this.getFloatingOffset=()=>10,this.renderArrow=()=>x`<span id="arrow"></span>`,this.reposition=async t=>{if(null==this.floating||null==this.reference)return;const{x:e,y:o,placement:i,middlewareData:r}=await computePosition(this.reference,this.floating,{strategy:this.position??"fixed",placement:this.placement??"bottom-start",platform:{...platform,getOffsetParent:t=>platform.getOffsetParent(t,offsetParent)},middleware:[flip(),shift(),this.arrow?arrow({element:this.arrow,padding:10}):void 0,hide()]});if(r.hide?.referenceHidden)return void Object.assign(this.floating.style,{visibility:"hidden"});const[n]=i.split("-"),s=null!=this.arrow,a={top:{x:"0px",y:getPositionOffset(s,"top",this.getFloatingOffset())},bottom:{x:"0px",y:getPositionOffset(s,"bottom",this.getFloatingOffset())},right:{x:getPositionOffset(s,"right",this.getFloatingOffset()),y:"0px"},left:{x:getPositionOffset(s,"left",this.getFloatingOffset()),y:"0px"}};Object.assign(this.floating.style,{visibility:"visible",top:`calc(${o}px + ${a[n].y})`,left:`calc(${e}px + ${a[n].x})`}),null!=this.arrow&&r.arrow&&Object.assign(this.arrow.style,__classPrivateFieldGet(this,_Popover_getArrowPosition,"f").call(this,r.arrow,n)),this.emit("m-popover-reposition",{detail:{reason:t}})},_Popover_getArrowPosition.set(this,((t,e)=>{if(null==this.floating||null==this.reference||null==this.arrow||null==t)return{};const o={top:"bottom",right:"left",bottom:"top",left:"right"}[e],{x:i,y:r}=t;return{left:null!=i?`${i}px`:"",top:null!=r?`${r}px`:"",right:"",bottom:"",[o]:-this.arrow.offsetWidth/2+"px"}})),this.position="fixed",this.placement="top-end",this.open=!1,this.asPopover=!1}disconnectedCallback(){super.disconnectedCallback(),__classPrivateFieldGet(this,_Popover_updateCleanup,"f")?.call(this)}firstUpdated(){this.asPopover&&supportsPopover()&&this.floating&&this.floating.setAttribute("popover","manual"),this.open&&this.show()}updated(t){super.updated(t),this.open&&null!=t.get("placement")&&null!=this.placement&&this.reposition("placement")}get reference(){return this.getReferenceElement()}get floating(){return this.getFloatingElement()}get arrow(){return this.getArrowElement()}show(){this.open||(this.open=!0,this.reference&&this.floating&&(isPopover(this.floating)&&this.floating.showPopover(),__classPrivateFieldSet(this,_Popover_updateCleanup,autoUpdate(this.reference,this.floating,(()=>{this.reposition("auto")})),"f")))}hide(){this.open&&(this.open=!1,null!=this.floating&&isPopover(this.floating)&&this.floating.hidePopover(),__classPrivateFieldGet(this,_Popover_updateCleanup,"f")?.call(this))}toggle(){this.open?this.hide():this.show()}}_Popover_updateCleanup=new WeakMap,_Popover_getArrowPosition=new WeakMap;const DEFAULT_SELECTORS={referenceSelector:"slot[name='reference']::slotted(*),",floatingSelector:"slot[name='floating']::slotted(*)"};function styles$m(t=DEFAULT_SELECTORS){const{referenceSelector:e,floatingSelector:o}={...DEFAULT_SELECTORS,...t};return[i$4`
			:host {
				--m-popover-background-color: ${getColor("color-background-secondary-inverted")};
				--m-popover-border-radius: ${getToken("border-radius-m")};
				--m-popover-border-width: 0;
				--m-popover-border-style: none;
				--m-popover-overflow-x: hidden;
				--m-popover-overflow-y: visible;
				--m-popover-border-color: transparent;
				--m-popover-color: ${getColor("color-text-inverted")};
				--m-popover-elevation: ${getToken("elevation-2")};
				--m-popover-width: initial;
				--m-popover-min-width: initial;
				--m-popover-max-width: initial;
				--m-popover-z-index: 10;
				--m-popover-floating-spacing-x: ${getToken("spacing-4")};
				--m-popover-floating-spacing-y: ${getToken("spacing-2")};

				--m-popover-arrow-size: 12px;
				--m-popover-arrow-offset: calc(-1 * (var(--m-popover-arrow-size) / 2));

				position: relative;
			}

			${r$4(e)} {
				display: inline-flex;
			}

			${r$4(o)} {
				${transition([{property:"box-shadow"}])};
				${typography("body-md")};

				padding-inline: var(--m-popover-floating-spacing-x);
				padding-block: var(--m-popover-floating-spacing-y);
				margin: 0;

				display: none;

				box-sizing: border-box;
				inline-size: var(--m-popover-width);
				min-inline-size: var(--m-popover-min-width);
				max-inline-size: var(--m-popover-max-width);

				overflow-x: var(--m-popover-overflow-x);
				overflow-y: var(--m-popover-overflow-y);

				border-width: var(--m-popover-border-width);
				border-style: var(--m-popover-border-style);
				border-color: var(--m-popover-border-color);
				border-radius: var(--m-popover-border-radius);

				background-color: var(--m-popover-background-color);
				color: var(--m-popover-color);

				box-shadow: var(--m-popover-elevation);
				z-index: var(--m-popover-z-index);
			}

			:host([position='absolute']) ${r$4(o)} {
				position: absolute;
			}

			:host([position='fixed']) ${r$4(o)} {
				position: fixed;
			}

			:host([open]) ${r$4(o)}, :host([open]) #arrow {
				display: inline-block;
			}

			#arrow {
				display: none;
				position: absolute;
				inline-size: var(--m-popover-arrow-size);
				block-size: var(--m-popover-arrow-size);
				background-color: var(--m-popover-background-color);
				transform: rotate(45deg);

				pointer-events: none;
			}

			.-absolute {
				position: absolute;
			}

			.-fixed {
				position: fixed;
			}
		`]}var _BoundaryController_instances,_BoundaryController_subscribe,_BoundaryController_unsubscribe,_BoundaryController_handleEvent,_BoundaryController_handleBlurEvent,_FocusManagerController_instances,_FocusManagerController_focusElement,_FocusManagerController_focusIndex,_FocusManagerController_focusPosition,_FocusManagerController_getIndexOfQueried,_FocusManagerController_findQueriedById,_FocusManagerController_handleKeyPress,_FocusManagerController_clearBufferAfterDelay,_FocusManagerController_findMatchInRange,_KeyboardSupportController_handleKeyUp;class BoundaryController{constructor(t,e){_BoundaryController_instances.add(this),this.activate=()=>{this.active||(__classPrivateFieldGet(this,_BoundaryController_instances,"m",_BoundaryController_subscribe).call(this),this.active=!0)},this.deactivate=()=>{this.active&&(__classPrivateFieldGet(this,_BoundaryController_instances,"m",_BoundaryController_unsubscribe).call(this),this.active=!1)},_BoundaryController_handleEvent.set(this,(t=>{const e=isInsideElement(t,this.host);!e||t instanceof KeyboardEvent&&"Escape"===t.key?this.host.dispatchEvent(new CustomEvent("m-interact-out")):e&&this.host.dispatchEvent(new CustomEvent("m-interact-in"))})),_BoundaryController_handleBlurEvent.set(this,(t=>{isInsideElement(t,this.host)||this.host.dispatchEvent(new CustomEvent("m-interact-out"))})),this.host=t,this.active=Boolean(e??!1),this.host.addController(this)}hostConnected(){this.active?__classPrivateFieldGet(this,_BoundaryController_instances,"m",_BoundaryController_subscribe).call(this):__classPrivateFieldGet(this,_BoundaryController_instances,"m",_BoundaryController_unsubscribe).call(this)}hostDisconnected(){this.active&&__classPrivateFieldGet(this,_BoundaryController_instances,"m",_BoundaryController_unsubscribe).call(this)}}function isDisabled(t){return null!=t&&"object"==typeof t&&"disabled"in t&&!0===t.disabled}function isPrintableCharacter(t){return 1===t.length&&/\S/.test(t)}_BoundaryController_handleEvent=new WeakMap,_BoundaryController_handleBlurEvent=new WeakMap,_BoundaryController_instances=new WeakSet,_BoundaryController_subscribe=function(){document.addEventListener("mousedown",__classPrivateFieldGet(this,_BoundaryController_handleEvent,"f")),document.addEventListener("keyup",__classPrivateFieldGet(this,_BoundaryController_handleEvent,"f")),document.addEventListener("touchend",__classPrivateFieldGet(this,_BoundaryController_handleEvent,"f")),window.addEventListener("blur",__classPrivateFieldGet(this,_BoundaryController_handleBlurEvent,"f"),!0)},_BoundaryController_unsubscribe=function(){document.removeEventListener("mousedown",__classPrivateFieldGet(this,_BoundaryController_handleEvent,"f")),document.removeEventListener("keyup",__classPrivateFieldGet(this,_BoundaryController_handleEvent,"f")),document.removeEventListener("touchend",__classPrivateFieldGet(this,_BoundaryController_handleEvent,"f")),window.removeEventListener("blur",__classPrivateFieldGet(this,_BoundaryController_handleBlurEvent,"f"),!0)};class FocusManagerController{constructor(t,e){_FocusManagerController_instances.add(this),this.activeDescendant=null,_FocusManagerController_focusElement.set(this,(t=>{t&&!isDisabled(t)&&t.id&&(this.clear(),this.activeDescendant=t.id,this.getInteractiveElement(this.host).setAttribute("aria-activedescendant",t.id),t.classList.add("is-focused"),t.scrollIntoView({block:"start",inline:"nearest",behavior:"smooth"}))})),_FocusManagerController_focusIndex.set(this,(t=>{__classPrivateFieldGet(this,_FocusManagerController_focusElement,"f").call(this,this.queried.at(t))})),_FocusManagerController_focusPosition.set(this,(t=>{const e=__classPrivateFieldGet(this,_FocusManagerController_instances,"m",_FocusManagerController_getIndexOfQueried).call(this,this.focused);switch(t){case"first":__classPrivateFieldGet(this,_FocusManagerController_focusIndex,"f").call(this,0);break;case"last":__classPrivateFieldGet(this,_FocusManagerController_focusIndex,"f").call(this,this.queried.length-1);break;case"previous":{if(-1===e)return;const t=(e-1+this.queried.length)%this.queried.length;__classPrivateFieldGet(this,_FocusManagerController_focusIndex,"f").call(this,t);break}case"next":{if(-1===e)return;const t=(e+1)%this.queried.length;__classPrivateFieldGet(this,_FocusManagerController_focusIndex,"f").call(this,t);break}}})),_FocusManagerController_handleKeyPress.set(this,(t=>{const{key:e}=t;if(!isPrintableCharacter(e))return;const o=__classPrivateFieldGet(this,_FocusManagerController_instances,"m",_FocusManagerController_getIndexOfQueried).call(this,this.focused);this.quickSearchBuffer+=e,__classPrivateFieldGet(this,_FocusManagerController_clearBufferAfterDelay,"f").call(this);let i=__classPrivateFieldGet(this,_FocusManagerController_findMatchInRange,"f").call(this,o+1,this.queried.length);i||(i=__classPrivateFieldGet(this,_FocusManagerController_findMatchInRange,"f").call(this,0,o)),null!=i&&this.focus(i)})),_FocusManagerController_clearBufferAfterDelay.set(this,(()=>{this.quickSearchBufferTimeout&&(window.clearTimeout(this.quickSearchBufferTimeout),this.quickSearchBufferTimeout=null),this.quickSearchBufferTimeout=window.setTimeout((()=>{this.quickSearchBuffer="",this.quickSearchBufferTimeout=null}),500)})),_FocusManagerController_findMatchInRange.set(this,((t,e)=>{for(let o=t;o<e;o++){const t=this.queried[o].innerText.toLowerCase();if(t&&0===t.indexOf(this.quickSearchBuffer))return this.queried[o]}return null})),this.query=toArray$1(e.query).join(","),this.focusOnType=Boolean(e.focusOnType??!0),this.getInteractiveElement=e.getInteractiveElement??(()=>t),this.quickSearchBuffer="",(this.host=t).addController(this)}hostConnected(){this.focusOnType&&this.host.addEventListener("keyup",__classPrivateFieldGet(this,_FocusManagerController_handleKeyPress,"f"))}hostDisconnected(){this.host.removeEventListener("keyup",__classPrivateFieldGet(this,_FocusManagerController_handleKeyPress,"f"))}get queried(){return Array.from(this.host.querySelectorAll(this.query))}get focused(){return this.activeDescendant?__classPrivateFieldGet(this,_FocusManagerController_instances,"m",_FocusManagerController_findQueriedById).call(this,this.activeDescendant):null}focusNext(){this.focus("next")}focusPrevious(){this.focus("previous")}focusFirst(){this.focus(0)}focusLast(){this.focus(this.queried.length-1)}focus(t){"number"==typeof t?__classPrivateFieldGet(this,_FocusManagerController_focusIndex,"f").call(this,t):"string"==typeof t?__classPrivateFieldGet(this,_FocusManagerController_focusPosition,"f").call(this,t):__classPrivateFieldGet(this,_FocusManagerController_focusElement,"f").call(this,t)}clear(){this.getInteractiveElement(this.host).removeAttribute("aria-activedescendant");const t=this.focused;this.activeDescendant=null,t&&t.classList.remove("is-focused")}}function getShortcutKey(t){return[t.alt?"alt":"",t.ctrl?"ctrl":"",t.meta?"cmd":"",t.shift?"shift":"",t.key.toLowerCase()].filter(Boolean).join("+")}_FocusManagerController_focusElement=new WeakMap,_FocusManagerController_focusIndex=new WeakMap,_FocusManagerController_focusPosition=new WeakMap,_FocusManagerController_handleKeyPress=new WeakMap,_FocusManagerController_clearBufferAfterDelay=new WeakMap,_FocusManagerController_findMatchInRange=new WeakMap,_FocusManagerController_instances=new WeakSet,_FocusManagerController_getIndexOfQueried=function(t){return t?this.queried.indexOf(t):-1},_FocusManagerController_findQueriedById=function(t){return this.queried.find((e=>e.id===t))??null};class KeyboardSupportController{constructor(t,e,o){this.keymap=new Map,_KeyboardSupportController_handleKeyUp.set(this,(t=>{const e=getShortcutKey({key:t.key,meta:t.metaKey,shift:t.shiftKey,ctrl:t.ctrlKey,alt:t.altKey});if(this.keymap.has(e)){this.keymap.get(e)(t)}else;})),this.keymap=new Map(toArray$1(e).reduce(((t,{shortcut:e,handler:o})=>t.concat(toArray$1(e).map((t=>[getShortcutKey(t),o])))),[])),this.getEventTarget=o?.getEventTarget??(()=>t),(this.host=t).addController(this)}async hostConnected(){this.getEventTarget(this.host).addEventListener("keyup",__classPrivateFieldGet(this,_KeyboardSupportController_handleKeyUp,"f"))}hostDisconnected(){this.getEventTarget(this.host).removeEventListener("keyup",__classPrivateFieldGet(this,_KeyboardSupportController_handleKeyUp,"f"))}}_KeyboardSupportController_handleKeyUp=new WeakMap;const TRIGGER_SELECTOR='[aria-haspopup="true"]',MENU_SELECTOR='[role="menu"]',ITEM_SELECTOR='[role="menuitem"]';function dropdownStyles(){return[styles$m({referenceSelector:`::slotted(${TRIGGER_SELECTOR})`,floatingSelector:`::slotted(${MENU_SELECTOR})`}),i$4`
			:host {
				--m-popover-floating-spacing-x: ${getToken("spacing-2")};
				--m-popover-floating-spacing-y: ${getToken("spacing-2")};
				/* TODO: figure out a way to avoid layout shift when using narrow triggers */
				--m-popover-width: max-content;
				--m-popover-min-width: 16ch;

				display: inline-block;
			}

			::slotted(${r$4(MENU_SELECTOR)}) {
				--m-popover-background-color: ${getColor("color-background-primary")};

				outline: none;
			}

			:host([open]) ::slotted(${r$4(MENU_SELECTOR)}) {
				display: inline-flex;

				flex-direction: column;
			}
		`]}function triggerStyles(){return[i$4`
			:host {
				--m-dropdown-trigger-background-color: ${getColor("color-background-primary")};
				--m-dropdown-trigger-border-color: ${getColor("color-border")};
				--m-dropdown-trigger-border-radius: ${getToken("border-radius-s")};
				--m-dropdown-trigger-color: ${getColor("color-text-tertiary")};
				--m-dropdown-trigger-padding-x: ${getToken("spacing-2")};
				--m-dropdown-trigger-padding-y: ${getToken("spacing-2")};
				--m-dropdown-trigger-height: ${getToken("global-height-default")};

				${transition([{property:"color"},{property:"background-color"},{property:"border-color"}])};

				${typography("body-md")};

				cursor: pointer;
				position: relative;

				display: flex;
				align-items: center;
				justify-content: flex-start;
				overflow: hidden;

				block-size: var(--m-dropdown-trigger-height);
				inline-size: 100%;
				box-sizing: border-box;

				text-decoration: none;

				gap: ${getToken("spacing-1")};

				${px("var(--m-dropdown-trigger-padding-x)")};
				${py("var(--m-dropdown-trigger-padding-y)")};

				background-color: var(--m-dropdown-trigger-background-color);
				color: var(--m-dropdown-trigger-color);
				border: 1px solid var(--m-dropdown-trigger-border-color);

				border-radius: var(--m-dropdown-trigger-border-radius);

				outline: none;
			}

			:host(:not([disabled]):hover) {
				--m-dropdown-trigger-border-color: ${getColor("color-primary-60")};
			}

			:host(:not([disabled]):is(:focus, :focus-within, :focus-visible)) {
				--m-dropdown-trigger-border-color: ${getColor("color-primary-100")};
			}

			:host([disabled]) {
				--m-dropdown-trigger-background-color: ${getColor("color-background-tertiary")};
				--m-dropdown-trigger-color: ${getColor("color-text-placeholder")};

				cursor: default;
				pointer-events: none;
			}

			:host([disabled]) *,
			:host([disabled]) ::slotted(*) {
				pointer-events: none;
				user-select: none;
			}

			:host-context([size='small']) {
				--m-dropdown-trigger-border-color: ${getColor("color-border",0)};
				--m-dropdown-trigger-padding-y: ${getToken("spacing-1")};
				--m-dropdown-trigger-height: ${getToken("global-height-small")};
				--m-dropdown-trigger-background-color: transparent;
			}

			:host-context([size='small']:not([disabled]):hover) {
				--m-dropdown-trigger-border-color: ${getColor("color-border")};
			}

			:host-context([size='small'][disabled]) {
				--m-dropdown-trigger-color: ${getColor("color-text-disabled")};
			}

			:host-context([size='large']) {
				--m-dropdown-trigger-padding-y: ${getToken("spacing-3")};
				--m-dropdown-trigger-height: ${getToken("global-height-large")};
			}
		`,i$4`
			.indicator {
				--m-icon-size: 12px;
				--m-icon-color: ${getColor("color-text-placeholder")};

				${transition([{property:"transform"}])};

				margin: 0 0 0 auto;
			}

			:host([aria-expanded='true']) .indicator {
				transform: rotate(180deg);
			}

			:host-context([size='small'][disabled]) .indicator {
				--m-icon-color: ${getColor("color-text-disabled")};
			}
		`]}function itemStyles(){return[i$4`
			:host {
				--m-dropdown-item-background-color: ${getColor("color-background-primary")};
				--m-dropdown-item-color: ${getColor("color-text-secondary")};

				${transition([{property:"color"},{property:"background-color"}])};
				${typography("body-md")};

				block-size: 36px;

				cursor: pointer;
				position: relative;

				box-sizing: border-box;

				display: inline-flex;
				align-items: center;
				justify-content: flex-start;
				text-decoration: none;

				gap: ${getToken("spacing-2")};

				${px(getToken("spacing-1"))};
				${py(getToken("spacing-2"))};

				background-color: var(--m-dropdown-item-background-color);
				color: var(--m-dropdown-item-color);

				border: none;

				border-radius: ${getToken("border-radius-s")};
			}

			slot[name='leading']::slotted(*),
			slot[name='trailing']::slotted(*) {
				display: inline-flex;
				align-items: center;
				justify-content: center;

				${p(0)};
				${m(0)};
			}

			:host([destructive]) {
				--m-dropdown-item-color: ${getColor("color-text-error")};
			}

			:host(:not([disabled]):hover),
			:host(:is(:focus, :focus-within, :focus-visible, .is-focused)) {
				--m-dropdown-item-background-color: ${getColor("color-background-tertiary")};

				font-weight: ${getToken("font-weight-bold")};
				outline: none;
			}

			:host(:not([disabled]):is(:active, .is-active)) {
				--m-dropdown-item-background-color: ${getColor("color-background-highlight")};
			}

			:host([disabled]) {
				--m-dropdown-item-color: ${getColor("color-text-disabled")};

				pointer-events: none;
				user-select: none;

				cursor: default;
			}

			:host([disabled]) ::slotted(*) {
				pointer-events: none;
				user-select: none;
			}
		`]}var _Dropdown_controllers,_Dropdown_handleClick,_Dropdown_handleClickOutside;class Dropdown extends Popover{static get properties(){return{...Popover.properties,disabled:{type:Boolean,reflect:!0},size:{type:String,reflect:!0}}}constructor(){super(),_Dropdown_controllers.set(this,void 0),this.getFloatingOffset=()=>4,_Dropdown_handleClick.set(this,(t=>{const{target:e}=t;e&&(e.matches(ITEM_SELECTOR)&&(__classPrivateFieldGet(this,_Dropdown_controllers,"f").focus.focus(e),this.collapse()),e.matches(TRIGGER_SELECTOR)&&t.detail>0&&this.toggle())})),_Dropdown_handleClickOutside.set(this,(()=>{this.collapse()})),this.position="absolute",this.placement="bottom-end",this.disabled=!1,__classPrivateFieldSet(this,_Dropdown_controllers,{boundary:new BoundaryController(this),focus:new FocusManagerController(this,{query:ITEM_SELECTOR,getInteractiveElement:()=>this.getFloatingElement()}),keyboard:new KeyboardSupportController(this,[{shortcut:{key:"ArrowUp"},handler:t=>{const{target:e}=t;e&&!this.disabled&&(e.matches(TRIGGER_SELECTOR)?this.expand({position:"last"}):e.matches(MENU_SELECTOR)&&__classPrivateFieldGet(this,_Dropdown_controllers,"f").focus.focusPrevious())}},{shortcut:{key:"ArrowDown"},handler:t=>{const{target:e}=t;e&&!this.disabled&&(e.matches(TRIGGER_SELECTOR)?this.expand({position:"first"}):e.matches(MENU_SELECTOR)&&__classPrivateFieldGet(this,_Dropdown_controllers,"f").focus.focusNext())}},{shortcut:[{key:"Enter"},{key:" "}],handler:t=>{const{target:e}=t;if(e&&!this.disabled)if(e.matches(TRIGGER_SELECTOR))this.toggle({position:"first"});else if(e.matches(MENU_SELECTOR)){const t=__classPrivateFieldGet(this,_Dropdown_controllers,"f").focus.focused;if(t?.disabled)return;t.click()}}},{shortcut:[{key:"Tab"},{key:"Tab",shift:!0}],handler:t=>{const{target:e}=t;e&&e.matches(TRIGGER_SELECTOR)&&this.open&&__classPrivateFieldGet(this,_Dropdown_handleClickOutside,"f").call(this)}}])},"f"),this.addEventListener("click",__classPrivateFieldGet(this,_Dropdown_handleClick,"f")),this.addEventListener("m-interact-out",__classPrivateFieldGet(this,_Dropdown_handleClickOutside,"f"))}firstUpdated(){this.floating?.id&&this.reference?.setAttribute("aria-controls",this.floating.id),this.reference?.id&&this.floating?.setAttribute("aria-labelledby",this.reference.id),super.firstUpdated()}updated(t){super.updated(t),t.has("open")&&(this.open?this.reference?.setAttribute("aria-expanded","true"):this.reference?.removeAttribute("aria-expanded")),t.has("disabled")&&this.reference&&(this.reference.disabled=this.disabled)}getReferenceElement(){return this.querySelector(TRIGGER_SELECTOR)}getFloatingElement(){return this.querySelector(MENU_SELECTOR)}getArrowElement(){return null}render(){return x`<slot></slot>`}async expand(t){const{position:e="first"}=t||{};this.show(),await this.updateComplete,this.floating?.focus(),__classPrivateFieldGet(this,_Dropdown_controllers,"f").focus.focus(e),__classPrivateFieldGet(this,_Dropdown_controllers,"f").boundary.activate(),this.emit("m-expand")}async collapse(){this.hide(),await this.updateComplete,__classPrivateFieldGet(this,_Dropdown_controllers,"f").boundary.deactivate(),__classPrivateFieldGet(this,_Dropdown_controllers,"f").focus.clear(),this.reference?.focus(),this.emit("m-collapse")}toggle(t){this.open?this.collapse():this.expand(t)}}_Dropdown_controllers=new WeakMap,_Dropdown_handleClick=new WeakMap,_Dropdown_handleClickOutside=new WeakMap,Dropdown.styles=[dropdownStyles()],window.customElements.define("m-dropdown",Dropdown);let counter=0;function generateId(t="m"){counter+=1;const e=`${t}-${counter}`;return counter===Number.MAX_SAFE_INTEGER&&(counter=0),e}const WithIdElementMixin=(t,e="m")=>class extends t{connectedCallback(){super.connectedCallback(),this.hasAttribute("id")||(this.id=generateId(e))}};class DropdownTrigger extends(WithIdElementMixin(Component)){static get properties(){return{disabled:{type:Boolean,reflect:!0}}}constructor(){super(),this.disabled=!1}connectedCallback(){super.connectedCallback(),this.setAttribute("role","button"),this.setAttribute("tabindex","0"),this.setAttribute("aria-haspopup","true")}render(){return x`
			<slot name="leading"></slot>
			<slot></slot>
			<m-icon name="caret-down" class="indicator"></m-icon>
		`}}DropdownTrigger.styles=[triggerStyles()],window.customElements.define("m-dropdown-trigger",DropdownTrigger);class DropdownMenu extends(WithIdElementMixin(Component)){connectedCallback(){super.connectedCallback(),this.setAttribute("role","menu"),this.setAttribute("tabindex","-1")}render(){return x`<slot name="menu-item"></slot>`}}window.customElements.define("m-dropdown-menu",DropdownMenu);class DropdownItem extends(WithIdElementMixin(Component)){static get properties(){return{disabled:{type:Boolean,reflect:!0},destructive:{type:Boolean,reflect:!0}}}constructor(){super(),this.handleClick=t=>{this.disabled&&(t.stopPropagation(),t.preventDefault())},this.disabled=!1,this.destructive=!1,this.addEventListener("click",this.handleClick)}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","menu-item"),this.setAttribute("role","menuitem"),this.setAttribute("tabindex","-1")}updated(t){super.updated(t),t.has("disabled")&&(this.disabled?this.setAttribute("aria-disabled","true"):this.removeAttribute("aria-disabled"))}render(){return x`
			<slot name="leading"></slot>
			<slot></slot>
			<slot name="trailing"></slot>
		`}}DropdownItem.styles=[itemStyles()],window.customElements.define("m-dropdown-item",DropdownItem);const emptyStateContext=n$2(Symbol("empty-state"));function getActionSize(t){switch(t){case"panel":case"card":case"card-horizontal":return"small";default:return"default"}}var _EmptyStateAction_contextCallback,_EmptyStateHeader_contextCallback;class EmptyStateAction extends Button{constructor(){super(),_EmptyStateAction_contextCallback.set(this,(({variant:t})=>{this.size=getActionSize(t)})),this.type="button",this.variant="primary",this.context=new s$2(this,{context:emptyStateContext,callback:__classPrivateFieldGet(this,_EmptyStateAction_contextCallback,"f"),subscribe:!0})}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","action")}}_EmptyStateAction_contextCallback=new WeakMap,window.customElements.define("m-empty-state-action",EmptyStateAction);class EmptyStateHeader extends Text{constructor(){super(),_EmptyStateHeader_contextCallback.set(this,(t=>{switch(t.variant){case"panel":this.variant="body-md-bold";break;case"card":case"card-horizontal":this.variant="body-sm-bold";break;default:this.variant="heading-sm-bold"}})),this.variant="heading-sm-bold",this.context=new s$2(this,{context:emptyStateContext,callback:__classPrivateFieldGet(this,_EmptyStateHeader_contextCallback,"f"),subscribe:!0})}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","header")}}function styles$l(){return i$4`
		slot {
			display: block;
		}

		:host {
			max-width: 320px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: ${getToken("spacing-4")};
		}

		:host([variant|='card']) {
			gap: ${getToken("spacing-2")};
		}

		:host([variant='card-horizontal']) {
			flex-direction: row;
			max-width: 100%;
		}

		.empty-state-body {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			text-align: center;
			gap: ${getToken("spacing-2")};
		}

		/* Hide illustration when it isn't a supported element */
		slot[name='illustration']::slotted(
				:not(m-empty-state-illustration, img, svg)
			) {
			display: none;
		}

		/* Illustration Wrapper */

		.illustration-wrapper {
			overflow: hidden;
			max-width: 320px;
			max-height: 240px;
		}

		:host([variant='panel']) .illustration-wrapper {
			max-width: 160px;
			max-height: 120px;
		}

		:host([variant='card']) .illustration-wrapper {
			max-height: 36px;
			max-width: 36px;
		}

		:host([variant='card-horizontal']) .illustration-wrapper {
			max-height: 24px;
			max-width: 24px;
		}

		/* Illustration */

		slot[name='illustration'] img,
		slot[name='illustration']::slotted(:is(img, svg)) {
			display: block;
			object-fit: scale-down;
			max-width: 320px;
			max-height: 240px;
		}

		:host([variant='panel']) slot[name='illustration'] img,
		:host([variant='panel']) slot[name='illustration']::slotted(:is(img, svg)) {
			max-width: 160px;
			max-height: 120px;
		}

		:host([variant='card']) slot[name='illustration'] img,
		:host([variant='card']) slot[name='illustration']::slotted(:is(img, svg)) {
			max-width: 36px;
			max-height: 36px;
		}

		:host([variant='card-horizontal']) slot[name='illustration'] img,
		:host([variant='card-horizontal'])
			slot[name='illustration']::slotted(:is(img, svg)) {
			max-width: 24px;
			max-height: 24px;
		}

		/* Header */

		slot[name='header'] {
			${getColor("color-text-primary")};
			${typography("heading-sm-bold")};
		}

		:host([variant='panel']) slot[name='header'] {
			${typography("body-md-bold")};
		}

		:host([variant|='card']) slot[name='header'] {
			${typography("body-sm-bold")};
		}

		/* Message */

		slot[name='message'] {
			${getColor("color-text-secondary")};
			${typography("body-md")};
		}

		:host([variant='panel']) slot[name='message'] {
			${typography("body-sm")};
		}
	`}function illustrationStyles(){return i$4`
		m-empty-state > m-empty-state-illustration :is(img, svg) {
			display: block;
			object-fit: scale-down;
			max-width: 320px;
			max-height: 240px;
		}

		m-empty-state[variant='panel'] > m-empty-state-illustration :is(img, svg) {
			max-width: 160px;
			max-height: 120px;
		}

		m-empty-state[variant='card'] > m-empty-state-illustration :is(img, svg) {
			width: 36px;
			height: 36px;
		}

		m-empty-state[variant='card-horizontal']
			> m-empty-state-illustration
			:is(img, svg) {
			width: 24px;
			height: 24px;
		}
	`}_EmptyStateHeader_contextCallback=new WeakMap,window.customElements.define("m-empty-state-header",EmptyStateHeader);const style=document.createElement("style");style.textContent=illustrationStyles().cssText,document.head.appendChild(style);class EmptyStateIllustration extends s$5{createRenderRoot(){return this}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","illustration")}}var _EmptyStateMessage_contextCallback,_EmptyState_instances,_EmptyState_contextProvider,_EmptyState_handleClickAction;window.customElements.define("m-empty-state-illustration",EmptyStateIllustration);class EmptyStateMessage extends Text{constructor(){super(),_EmptyStateMessage_contextCallback.set(this,(t=>{if("panel"===t.variant)this.variant="body-sm";else this.variant="body-md"})),this.variant="body-md",this.context=new s$2(this,{context:emptyStateContext,callback:__classPrivateFieldGet(this,_EmptyStateMessage_contextCallback,"f"),subscribe:!0})}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","message")}}_EmptyStateMessage_contextCallback=new WeakMap,window.customElements.define("m-empty-state-message",EmptyStateMessage),attachContextRoot();class EmptyState extends Component{static get properties(){return{variant:{type:String,reflect:!0},illustration:{type:String,reflect:!0},header:{type:String,reflect:!0},message:{type:String,reflect:!0},action:{type:String,reflect:!0}}}constructor(){super(),_EmptyState_instances.add(this),_EmptyState_contextProvider.set(this,new i(this,{context:emptyStateContext,initialValue:{variant:void 0}})),this.variant="page"}updated(t){super.updated(t),t.has("variant")&&__classPrivateFieldGet(this,_EmptyState_contextProvider,"f").setValue({variant:this.variant??"page"})}render(){const t=this.illustration?n$4`<img role="presentation" src=${this.illustration} />`:A,e=this.variant?.startsWith("card")?n$4`<slot name="header">${this.header}</slot>`:n$4`
					<div class="empty-state-body">
						<slot name="header">${this.header}</slot>
						<slot name="message">${this.message}</slot>
					</div>
			  `,o=this.action?n$4`
					<m-button
						type="button"
						variant="primary"
						size=${getActionSize(this.variant)}
						@click=${__classPrivateFieldGet(this,_EmptyState_instances,"m",_EmptyState_handleClickAction)}
						>${this.action}</m-button
					>
			  `:A;return n$4`
			<div class="illustration-wrapper">
				<slot name="illustration">${t}</slot>
			</div>
			${e}
			<slot name="action">${o}</slot>
		`}}_EmptyState_contextProvider=new WeakMap,_EmptyState_instances=new WeakSet,_EmptyState_handleClickAction=function(t){t.preventDefault(),t.stopPropagation(),this.emit("m-action")},EmptyState.styles=[styles$l()],window.customElements.define("m-empty-state",EmptyState);const EMPTY_STATE_VARIANTS=["page","panel","card","card-horizontal"],fieldContext=n$2(Symbol("field"));function styles$k(){return[i$4`
			:host {
				--m-field-hint-color: ${getColor("color-text-tertiary")};
			}

			m-group {
				${px(getToken("spacing-2"))};
			}

			.-status-danger {
				--m-field-hint-color: ${getColor("color-danger-60")};
			}

			.hint {
				${typography("body-sm")};
				color: var(--m-field-hint-color);
			}
		`]}var _FieldHint_instances,_FieldHint_getStatus;class FieldHint extends Component{static get properties(){return{status:{type:String},slot:{type:String,reflect:!0}}}constructor(){super(),_FieldHint_instances.add(this),this.field=new s$2(this,{context:fieldContext,subscribe:!0}),this.slot="hint"}render(){const t={"-status-default":"default"===__classPrivateFieldGet(this,_FieldHint_instances,"m",_FieldHint_getStatus).call(this),"-status-danger":"danger"===__classPrivateFieldGet(this,_FieldHint_instances,"m",_FieldHint_getStatus).call(this)};return x` <m-group
			gap="spacing-0-5"
			align="center"
			class=${o$2(t)}
		>
			<slot name="leading"
				>${"danger"===__classPrivateFieldGet(this,_FieldHint_instances,"m",_FieldHint_getStatus).call(this)?x`<m-icon
							name="attention"
							size="10"
							color="color-danger-60"
					  ></m-icon>`:A}</slot
			>
			<span
				class=${o$2({hint:!0,...t})}
				><slot></slot>
			</span>
		</m-group>`}}function styles$j(){return[i$4`
			.label {
				${typography("body-md")};

				display: inline-flex;
				align-items: center;
				justify-content: flex-start;
				gap: ${getToken("spacing-0-5")};

				margin: 0;
				padding: 0;

				color: ${getColor("color-text-tertiary")};
			}

			.required {
				color: ${getColor("color-text-error")};
			}

			.-size-small {
				${typography("body-sm")};
			}
		`]}_FieldHint_instances=new WeakSet,_FieldHint_getStatus=function(){return this.status||this.field.value?.status},FieldHint.styles=[styles$k()],window.customElements.define("m-field-hint",FieldHint);class Label extends Component{static get properties(){return{required:{type:Boolean},size:{type:String},slot:{type:String,reflect:!0}}}requiredTemplate(){return this.isRequired()?x`<span class="required" aria-hidden="true"> *</span>`:A}labelClassList(){const t=this.getSize();return o$2({label:!0,"-size-small":"small"===t})}render(){return x`<label class=${this.labelClassList()}
			><slot></slot>${this.requiredTemplate()}</label
		>`}getSize(){return this.size}isRequired(){return Boolean(this.required)}}Label.styles=[styles$j()],window.customElements.define("m-label",Label);class FieldLabel extends Label{constructor(){super(...arguments),this.field=new s$2(this,{context:fieldContext,subscribe:!0})}connectedCallback(){super.connectedCallback(),this.setAttribute("slot","label")}isRequired(){return null!=this.required?this.required:Boolean(this.field.value?.required)}getSize(){return this.size??this.field.value?.size}}window.customElements.define("m-field-label",FieldLabel),attachContextRoot();class Field extends Component{static get properties(){return{label:{type:String},hint:{type:String},required:{type:Boolean},status:{type:String},size:{type:String},align:{type:String}}}constructor(){super(),this.provider=new i(this,fieldContext,{required:!1,size:"default",status:"default"}),this.required=!1,this.status="default",this.size="default",this.align="stretch"}update(t){super.update(t),(t.has("required")||t.has("status")||t.has("size"))&&this.provider.setValue({required:this.required,status:this.status,size:this.size})}render(){return x`<m-stack gap="spacing-1" align="${l$1(this.align)}">
			<slot name="label"
				>${this.label?x`<m-field-label>${this.label}</m-field-label>`:A}</slot
			>

			<slot></slot>

			<slot name="hint">
				${this.hint?x`<m-field-hint>${this.hint}</m-field-hint>`:A}
			</slot>
		</m-stack>`}}window.customElements.define("m-field",Field);const FIELD_STATUSES=["default","danger"];function styles$i(){return i$4`
		:host {
			--m-header-background-color: ${getColor("color-background-primary")};

			display: block;
		}

		.m-header {
			display: flex;
			flex-wrap: wrap;
			background-color: var(--m-header-background-color);
			padding: ${getToken("spacing-6")};
			gap: ${getToken("spacing-4")};
			align-items: center;
		}

		@media screen and (max-width: 1025px) {
			.m-header {
				padding: ${getToken("spacing-4")};
			}
		}
	`}function headerTitleStyles(){return i$4`
		:host {
			display: block;
			${typography("heading-lg-bold")};
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			max-width: 400px;
		}
		@media screen and (max-width: 1025px) {
			:host {
				${typography("heading-md-bold")};
			}
		}
	`}function headerActionStyles(){return i$4`
		:host {
			display: flex;
			gap: ${getToken("spacing-4")};
		}
	`}function headerContentStyles(){return i$4`
		:host {
			display: flex;
			gap: ${getToken("spacing-4")};
			align-items: center;
			flex-grow: 100;
		}
	`}function subHeaderStyles(){return i$4`
		:host {
			--m-subheader-background-color: var(
				--m-header-background-color,
				${getColor("color-background-primary")}
			);

			display: block;
		}
		.content {
			padding: ${getToken("spacing-6")};
			background-color: var(--m-subheader-background-color);
		}
	`}class Header extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="page-header"}render(){return x`
			<div class="m-header">
				<slot name="back-button"></slot>
				<slot name="content"></slot>
				<slot name="actions"></slot>
			</div>
			<slot name="sub-header"></slot>
		`}}Header.styles=[styles$i()],window.customElements.define("m-header",Header);class HeaderActions extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="actions"}render(){return n$4`<slot></slot>`}}HeaderActions.styles=[headerActionStyles()],window.customElements.define("m-header-actions",HeaderActions);class HeaderContent extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="content"}render(){return n$4`<slot name="title"></slot> <slot></slot>`}}HeaderContent.styles=[headerContentStyles()],window.customElements.define("m-header-content",HeaderContent);class HeaderTitle extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="title"}render(){return n$4`<slot></slot>`}}HeaderTitle.styles=[headerTitleStyles()],window.customElements.define("m-header-title",HeaderTitle);class SubHeader extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="sub-header"}render(){return n$4` <m-divider></m-divider>
			<div class="content">
				<slot></slot>
			</div>`}}SubHeader.styles=[subHeaderStyles()],window.customElements.define("m-sub-header",SubHeader);const defaultLabeledValueLabelProps={color:"color-text-tertiary",variant:"body-sm"};class LabeledValueLabel extends Text{static get properties(){return{...super.properties,role:{type:String,reflect:!0}}}constructor(){super(),this.color=defaultLabeledValueLabelProps.color,this.variant=defaultLabeledValueLabelProps.variant}connectedCallback(){super.connectedCallback(),this.setAttribute("role","term"),this.setAttribute("slot","label")}update(t){!t.has("color")||void 0!==this.color&&null!==this.color||(this.color=defaultLabeledValueLabelProps.color),!t.has("variant")||void 0!==this.variant&&null!==this.variant||(this.variant=defaultLabeledValueLabelProps.variant),super.update(t)}}window.customElements.define("m-labeled-value-label",LabeledValueLabel);class LabeledValueValue extends Text{connectedCallback(){super.connectedCallback(),this.setAttribute("role","definition"),this.setAttribute("slot","value")}}window.customElements.define("m-labeled-value-value",LabeledValueValue);const defaultLabeledValueProps={gap:"spacing-2",justify:"flex-start"};class LabeledValue extends s$5{constructor(){super(),this.inline=!1,this.gap=defaultLabeledValueProps.gap,this.justify=defaultLabeledValueProps.justify}static get properties(){return{inline:{type:Boolean},label:{type:String},value:{type:String},gap:{type:String},align:{type:String},justify:{type:String},fallbackValue:{type:String,attribute:"fallback-value"},labelVariant:{type:String,attribute:"label-variant"},labelColor:{type:String,attribute:"label-color"},valueVariant:{type:String,attribute:"value-variant"},valueColor:{type:String,attribute:"value-color"}}}getFallback(){return x`<slot name="fallback">${this.fallbackValue??"-"}</slot>`}getLabel(){return x`<slot name="label"
			><m-labeled-value-label
				variant=${this.getLabelVariant()}
				color=${l$1(this.labelColor)}
				>${this.label}</m-labeled-value-label
			></slot
		>`}getValue(){return x`<slot name="value"
			><m-labeled-value-value
				variant=${l$1(this.valueVariant)}
				color=${l$1(this.valueColor)}
				>${this.value??this.getFallback()}</m-labeled-value-value
			></slot
		>`}getLabelVariant(){return this.labelVariant?this.labelVariant:this.inline?"body-md":"body-sm"}get wrapperAlign(){return this.align?this.align:this.inline?"center":"flex-start"}bodyTemplate(){return x`${this.getLabel()} ${this.getValue()}`}render(){return this.inline?x`<m-group
				gap="${l$1(this.gap)}"
				align="${this.wrapperAlign}"
				justify="${l$1(this.justify)}"
				>${this.bodyTemplate()}</m-group
			>`:x`<m-stack
			gap="${l$1(this.gap)}"
			align="${this.wrapperAlign}"
			justify="${l$1(this.justify)}"
			>${this.bodyTemplate()}</m-stack
		>`}}function styles$h(){return i$4`
		.m-link {
			color: ${getColor("color-text-link")};
		}

		.m-link.-small {
			${typography("body-sm-bold-underline")};
		}

		.m-link.-default {
			${typography("body-md-bold-underline")};
		}

		.m-link.-large {
			${typography("heading-md-bold")};
			text-decoration: none;
		}

		@media (prefers-reduced-motion: no-preference) {
			.m-link {
				${transition({property:"color",duration:"250ms"})}
			}
		}

		${on(".m-link").not.disabled.hover},
		${on(".m-link").not.disabled.active},
		${on(".m-link").not.disabled.visited.hover} {
			color: ${getColor("color-primary-100")};
		}

		${on(".m-link").not.disabled.not.active.focus} {
			border-radius: ${getToken("border-radius-s")};
			outline: 1px solid ${getColor("color-primary-60")};
			outline-offset: 4px;
			text-decoration: none;
		}

		${on(".m-link").not.disabled.not.focus.visited} {
			color: ${getColor("color-accent-60")};
		}

		${on(".m-link").disabled} {
			color: ${getColor("color-primary-20")};
		}
	`}var _Link_instances,_Link_disabled_get,_Link_href_get,_Link_rel_get,_Link_handleClick;window.customElements.define("m-labeled-value",LabeledValue);const UNSAFE_URL=/^javascript:/i;class Link extends Component{static get properties(){return{href:{type:String,reflect:!0},target:{type:String,reflect:!0},rel:{type:String,reflect:!0},download:{type:String,reflect:!0},ping:{type:String,reflect:!0},referrerpolicy:{type:String,reflect:!0},size:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0}}}constructor(){super(),_Link_instances.add(this),this.size="default"}render(){return x`
			<a
				class=${o$2({"m-link":!0,"-small":"small"===this.size,"-default":"default"===this.size,"-large":"large"===this.size,"is-disabled":__classPrivateFieldGet(this,_Link_instances,"a",_Link_disabled_get)})}
				href=${l$1(__classPrivateFieldGet(this,_Link_instances,"a",_Link_href_get))}
				target=${l$1(this.target)}
				rel=${l$1(__classPrivateFieldGet(this,_Link_instances,"a",_Link_rel_get))}
				download=${l$1(this.download)}
				ping=${l$1(this.ping)}
				referrerpolicy=${l$1(this.referrerpolicy)}
				@click=${__classPrivateFieldGet(this,_Link_instances,"m",_Link_handleClick)}
				><slot></slot
			></a>
		`}}function styles$g(){return i$4`
		:host {
			display: block;
			box-sizing: border-box;
			width: 100%;
		}

		slot[name='page-header']::slotted(*) {
			border-bottom: ${getToken("border-thin")} solid ${getColor("color-border")};
		}
	`}_Link_instances=new WeakSet,_Link_disabled_get=function(){return this.disabled||!this.href||UNSAFE_URL.test(this.href.trim())},_Link_href_get=function(){return __classPrivateFieldGet(this,_Link_instances,"a",_Link_disabled_get)?void 0:this.href},_Link_rel_get=function(){let t=this.rel;if("_blank"===this.target){const e=new Set((this.rel??"").split(/\s+/).filter(Boolean));this.referrerpolicy?.trim()||e.add("noreferrer"),e.has("opener")||e.add("noopener"),t=Array.from(e).join(" ")}return t},_Link_handleClick=function(t){if(__classPrivateFieldGet(this,_Link_instances,"a",_Link_disabled_get))return t.preventDefault(),t.stopPropagation(),!1},Link.styles=[styles$h()],window.customElements.define("m-link",Link);class PageContent extends s$5{render(){return x`
			<slot name="page-header"></slot>
			<slot name="page-body"></slot>
		`}}function styles$f(){return i$4`
		:host {
			width: 100%;
		}

		.actions m-button {
			--m-button-base-size: 1rem;
		}

		.icon {
			--m-icon-color: ${getColor("color-text-tertiary")};
		}

		[disabled] .icon {
			--m-icon-color: ${getColor("color-text-disabled")};
		}
	`}PageContent.styles=[styles$g()],window.customElements.define("m-page-content",PageContent);const FIST_PAGE=0,DEFAULT_PAGE_SIZE=100;class Pagination extends Component{static get properties(){return{count:{type:Number},page:{type:Number},pageSize:{type:Number,attribute:"page-size"},disabled:{type:Boolean}}}constructor(){super(),this.goToPrev=()=>{this.hasPrev()&&(this.setPage(this.getPage()-1),this.handleChange())},this.page=0,this.pageSize=100,this.disabled=!1,this.count=0}getPage(){return Math.min(Math.max(this.page,0),this.lastPage)}setPage(t){this.page=t}getPageSize(){return Math.max(1,this.pageSize)}get totalPages(){return Math.ceil(this.count/this.getPageSize())}get lastPage(){return this.totalPages-1}get pageLabel(){return`${this.getPage()+1}`}hasPrev(){return this.getPage()>0}hasNext(){return this.getPage()<this.lastPage}goToNext(){this.hasNext()&&(this.setPage(this.getPage()+1),this.handleChange())}goToLast(){this.hasNext()&&(this.setPage(this.lastPage),this.handleChange())}goToFist(){this.hasPrev()&&(this.setPage(0),this.handleChange())}handleChange(){this.emit("m-change",{detail:{page:this.getPage(),pageSize:this.getPageSize()}})}isPrevDisabled(){return this.disabled||!this.hasPrev()}isNextDisabled(){return this.disabled||!this.hasNext()}renderActions(){return x`
			<m-group gap="spacing-4" align="center" class="actions">
				<m-button
					title="go to the first page"
					variant="icon-secondary"
					size="small"
					class="m-pagination-first"
					@click=${this.goToFist}
					?disabled=${this.isPrevDisabled()}
				>
					<m-icon
						aria-label="go to the first page"
						name="double-caret-left"
						class="icon"
					></m-icon>
				</m-button>
				<m-button
					title="go to the previous page"
					variant="icon-secondary"
					size="small"
					class="m-pagination-prev"
					@click=${this.goToPrev}
					?disabled=${this.isPrevDisabled()}
				>
					<m-icon
						aria-label="go to the previous page"
						name="caret-left"
						class="icon"
					></m-icon>
				</m-button>

				<m-group gap="spacing-2" align="center">
					<m-text color="color-text-tertiary">${this.pageLabel}</m-text>
					<m-text color="color-text-tertiary">of</m-text>
					<m-text color="color-text-tertiary">${this.totalPages}</m-text>
				</m-group>

				<m-button
					title="go to the next page"
					variant="icon-secondary"
					size="small"
					class="m-pagination-next"
					@click=${this.goToNext}
					?disabled=${this.isNextDisabled()}
				>
					<m-icon
						aria-label="go to the next page"
						name="caret-right"
						class="icon"
					></m-icon>
				</m-button>
				<m-button
					title="go to the last page"
					variant="icon-secondary"
					size="small"
					class="m-pagination-last"
					@click=${this.goToLast}
					?disabled=${this.isNextDisabled()}
				>
					<m-icon
						aria-label="go to the last page"
						name="double-caret-right"
						class="icon"
					></m-icon>
				</m-button>
			</m-group>
		`}render(){return x`
			<m-box
				background-color="color-background-primary"
				border-width="border-thin"
				border-color="color-divider"
				border-radius="border-none"
				class="m-pagination"
			>
				<m-group justify="space-between" align="center">
					<m-text color="color-text-tertiary">${this.count} items</m-text>
					${this.renderActions()}
				</m-group>
			</m-box>
		`}}function clamp(t,e,o){return Math.min(Math.max(e,t),o)}function styles$e(){return i$4`
		.bar {
			display: flex;
			flex-grow: 0;
			flex-shrink: 1;
			align-items: center;
			justify-content: center;

			position: relative;
			overflow: hidden;

			width: 100%;
			height: ${toRem("8px")};

			border-radius: ${getToken("border-radius-s")};
			background-color: ${getColor("color-background-tertiary")};
		}

		.progress {
			position: absolute;
			top: 0;
			left: 0;

			${transition([{property:"width"},{property:"background"}])};

			height: ${toRem("8px")};

			border-radius: ${getToken("border-radius-s")};

			background: var(--m-progress-bar-progress-background);
		}

		.-default {
			--m-progress-bar-progress-background: linear-gradient(
				45deg,
				${getColor("color-brand-accent-1")} 22%,
				${getColor("color-brand-accent-2")} 88%
			);
		}

		.-success {
			--m-progress-bar-progress-background: ${getColor("color-success-60")};
		}

		.-warning {
			--m-progress-bar-progress-background: ${getColor("color-warning-60")};
		}

		.-danger {
			--m-progress-bar-progress-background: ${getColor("color-danger-60")};
		}
	`}var _ProgressBar_instances,_ProgressBar_safeMaxValue_get,_ProgressBar_safeValue_get;Pagination.styles=[styles$f()],window.customElements.define("m-pagination",Pagination);const DEFAULT_VARIANT="default",DEFAULT_MAX=100,DEFAULT_MIN=0,DEFAULT_VALUE=0;class ProgressBar extends s$5{static get properties(){return{variant:{type:String,reflect:!0},value:{type:Number,reflect:!0},max:{type:Number,reflect:!0}}}constructor(){super(),_ProgressBar_instances.add(this),this.variant="default",this.value=0,this.max=100}connectedCallback(){super.connectedCallback(),this.setAttribute("role","progressbar"),this.setAttribute("aria-valuemin","0")}updated(){this.setAttribute("aria-valuenow",String(this.value)),this.setAttribute("aria-valuemax",String(this.max))}get percentage(){return 100*__classPrivateFieldGet(this,_ProgressBar_instances,"a",_ProgressBar_safeValue_get)/__classPrivateFieldGet(this,_ProgressBar_instances,"a",_ProgressBar_safeMaxValue_get)}get currentVariant(){return this.variant}render(){return x`
			<div class="bar">
				<span
					class=${o$2({progress:!0,"-default":"default"===this.currentVariant,"-success":"success"===this.currentVariant,"-warning":"warning"===this.currentVariant,"-danger":"danger"===this.currentVariant})}
					style=${o$1({width:`${this.percentage}%`})}
				></span>
			</div>
		`}}_ProgressBar_instances=new WeakSet,_ProgressBar_safeMaxValue_get=function(){return this.max<=0?100:this.max},_ProgressBar_safeValue_get=function(){return clamp(this.value,0,__classPrivateFieldGet(this,_ProgressBar_instances,"a",_ProgressBar_safeMaxValue_get))},ProgressBar.styles=[styles$e()],window.customElements.define("m-progress-bar",ProgressBar);class ProgressBarCountdown extends ProgressBar{get currentVariant(){return this.percentage>=66?"success":this.percentage>=33?"warning":"danger"}}window.customElements.define("m-progress-bar-countdown",ProgressBarCountdown);const RADIO_EVENT="m-check";function styles$d(){return i$4`
		:host {
			--m-radio-border-color: ${getColor("color-border")};
			--m-radio-dot-check-color: ${getColor("color-primary-60")};
			--m-radio-size: 14px;
			--m-radio-background-color: white;
			--m-radio-border-width: ${getToken("border-thin")};
			--m-radio-label-color: ${getColor("color-text-tertiary")};
			--m-radio-outline-color: ${getColor("color-primary-60")};
			--m-radio-outline-offset: 2px;
		}

		.radio-button {
			${typography("body-md")};
			color: var(--m-radio-label-color);

			border: none;
			background: none;

			height: ${getToken("global-height-small")};
			display: inline-flex;
			gap: ${getToken("spacing-1")};
			align-items: center;
			border-radius: ${getToken("border-radius-s")};
			${transition({property:"color"})};
		}

		${on(".radio-button").not.disabled.focus} {
			outline: 1px solid var(--m-radio-outline-color);
			outline-offset: var(--m-radio-outline-offset);
		}

		.radio-button .radio-input {
			width: var(--m-radio-size);
			height: var(--m-radio-size);
			background-color: var(--m-radio-background-color);
			border-color: var(--m-radio-border-color);
			border-width: var(--m-radio-border-width);
			border-style: solid;
			border-radius: 50%;
			position: relative;
			display: inline-flex;

			${transition({property:"border-color"})};
		}

		.radio-button .radio-input::before {
			content: '';
			width: 0;
			height: 0;
			border-radius: 50%;
			transform: translate(-50%, -50%);
			top: 50%;
			left: 50%;
			display: block;
			position: absolute;
			${transition([{property:"background-color"},{property:"height",duration:"120ms"},{property:"width",duration:"120ms"}])};
		}

		.radio-button[aria-checked='true'] .radio-input::before {
			width: 10px;
			height: 10px;
		}

		${on(".radio-button").disabled} {
			cursor: default;
			--m-radio-label-color: ${getColor("color-neutral-40")};
			--m-radio-background-color: ${getColor("color-background-tertiary")};
		}

		${on('.radio-button[aria-checked="true"]',".radio-input").disabled} {
			--m-radio-border-color: ${getColor("color-border")};
		}

		${on(".radio-button",".radio-input::before").disabled} {
			--m-radio-dot-check-color: ${getColor("color-neutral-40")};
		}

		.radio-button .radio-input::before {
			background-color: var(--m-radio-dot-check-color);
		}

		.radio-button[aria-checked='true'] .radio-input {
			--m-radio-dot-check-color: ${getColor("color-primary-60")};
			--m-radio-border-color: ${getColor("color-primary-60")};
		}

		.radio-button .radio-input {
			--m-radio-border-color: ${getColor("color-border")};
		}

		${on(".radio-button").not.disabled.hover} .radio-input {
			--m-radio-border-color: ${getColor("color-primary-100")};
			--m-radio-dot-check-color: ${getColor("color-primary-100")};
		}

		${on(".radio-button").not.disabled.hover} {
			--m-radio-label-color: ${getColor("color-text-primary")};
		}

		${on(".radio-button","*").disabled} {
			pointer-events: none;
		}
	`}var _Radio_instances,_Radio_button_get,_Radio_handleClick,_Radio_setDisabled,_Radio_setChecked;class Radio extends s$5{static get properties(){return{value:{type:String},disabled:{type:Boolean,reflect:!0},checked:{type:Boolean,reflect:!0}}}constructor(){super(),_Radio_instances.add(this),_Radio_handleClick.set(this,(t=>{if(this.disabled)return t.preventDefault(),void t.stopPropagation();const e={detail:{value:this.value,type:"select"},bubbles:!0,composed:!1};this.dispatchEvent(new CustomEvent("m-check",e))})),_Radio_setDisabled.set(this,(()=>{this.setAttribute("aria-disabled",String(this.disabled??!1))})),_Radio_setChecked.set(this,(()=>{this.setAttribute("aria-checked",String(this.checked??!1))})),this.disabled=!1,this.checked=!1}connectedCallback(){super.connectedCallback(),this.setAttribute("role","radio"),this.addEventListener("click",__classPrivateFieldGet(this,_Radio_handleClick,"f"))}updated(t){super.updated(t),t.has("disabled")&&__classPrivateFieldGet(this,_Radio_setDisabled,"f").call(this),t.has("checked")&&__classPrivateFieldGet(this,_Radio_setChecked,"f").call(this)}render(){return x`
			<button
				type="button"
				class="radio-button"
				role="radio"
				?disabled=${this.disabled}
				aria-checked=${this.checked}
			>
				<span class="radio-input"></span>
				<slot name="leading"></slot>
				<slot></slot>
			</button>
		`}focus(t){__classPrivateFieldGet(this,_Radio_instances,"a",_Radio_button_get)?.focus(t)}}_Radio_handleClick=new WeakMap,_Radio_setDisabled=new WeakMap,_Radio_setChecked=new WeakMap,_Radio_instances=new WeakSet,_Radio_button_get=function(){return this.renderRoot?.querySelector("button")??null},Radio.styles=[styles$d()],window.customElements.define("m-radio",Radio);var _default,selection={};Object.defineProperty(selection,"i",{value:!0});var e$1=toArray;const t$1=(t,e)=>{const o=e$1(t);if(0===o.length)return e;const i=new Set;return i.add(String(o.at(-1))),i},n$1=(t,e)=>{const o=e$1(t);if(0===o.length)return e;const i=new Set(e);for(const t of o)i.add(String(t));return i},r$1={type:"single",init:t=>t$1(t,new Set),select:t$1,unselect(t,e){const o=e$1(t);if(0===o.length||0===e.size)return e;const i=new Set(e);for(const t of o)i.delete(String(t));return i},toggle(t,e){const o=e$1(t);if(0===o.length)return e;const i=new Set;for(const t of o){const o=String(t);e.has(o)||(i.clear(),i.add(o))}return i},reset:t=>t??new Set,value(t){if(null==t||0===t.size)return null;const[e]=Array.from(t);return e}},s={type:"single-strict",init:t=>t$1(t,new Set),select:t$1,unselect(t,e){const o=e$1(t);if(0===o.length||0===e.size)return e;const i=new Set(e);for(let t=0;t<o.length&&e.size>1;t++)i.delete(String(o[t]));return i},toggle(t,e){const o=e$1(t);if(0===o.length)return e;const i=new Set(e);for(const t of o){const o=String(t);e.has(o)||(i.clear(),i.add(o))}return i},reset:t=>t??new Set,value(t){if(null==t||0===t.size)return null;const[e]=Array.from(t);return e}},l={type:"multiple",init:t=>n$1(t,new Set),select:n$1,unselect(t,e){const o=e$1(t);if(0===o.length||0===e.size)return e;const i=new Set(e);for(const t of o)i.delete(String(t));return i},toggle(t,e){const o=e$1(t);if(0===o.length)return e;const i=new Set(e);for(const t of o){const o=String(t);e.has(o)?i.delete(o):i.add(o)}return i},reset:t=>t??new Set,value:t=>null==t||0===t.size?null:Array.from(t)};var _SelectionController_instances,_SelectionController_handleSelectionEvent,_SelectionController_publish,_RadioGroup_selectionController,_RadioGroup_defaultSlot,_RadioGroup_getDefaultChecked,_RadioGroup_getButtons,_RadioGroup_setButtonChecked,_RadioGroup_setButtonDisabled;selection.SELECTION_TYPES=["single","single-strict","multiple"],_default=selection.default=function(t){const{type:e="multiple"}=t;return"single"===e?r$1:"single-strict"===e?s:l};class SelectionController{constructor(t,e,o){_SelectionController_instances.add(this),this.disabled=!1,this.event="m-select",_SelectionController_handleSelectionEvent.set(this,(t=>{if(this.disabled)return;if(null==this.type)return;const{detail:{type:e,value:o}}=t;switch(e){case"select":this.select(toArray$1(o));break;case"unselect":this.unselect(toArray$1(o));break;case"toggle":this.toggle(toArray$1(o))}})),this.init=t=>{this.host.selection=this.strategy.init(t)},this.select=t=>{this.host.selection=this.strategy.select(t,this.host.selection),__classPrivateFieldGet(this,_SelectionController_instances,"m",_SelectionController_publish).call(this)},this.unselect=t=>{this.host.selection=this.strategy.unselect(t,this.host.selection),__classPrivateFieldGet(this,_SelectionController_instances,"m",_SelectionController_publish).call(this)},this.toggle=t=>{this.host.selection=this.strategy.toggle(t,this.host.selection),__classPrivateFieldGet(this,_SelectionController_instances,"m",_SelectionController_publish).call(this)},this.subscribe=()=>{this.host.addEventListener(this.event,__classPrivateFieldGet(this,_SelectionController_handleSelectionEvent,"f"))},this.unsubscribe=()=>{this.host.removeEventListener(this.event,__classPrivateFieldGet(this,_SelectionController_handleSelectionEvent,"f"))},this.host=t,this.type=e,this.event=o,this.strategy=_default({type:e}),this.host.addController(this)}hostConnected(){this.subscribe()}hostDisconnected(){this.unsubscribe()}hostUpdate(){null!=this.host.type&&this.host.type!==this.type&&(this.unsubscribe(),this.host.removeController(this))}}function styles$c(){return i$4`
		.radio-group {
			display: flex;
			gap: ${getToken("spacing-2")};
		}
		.radio-group.-vertical {
			flex-direction: column;
		}
		.radio-group.-horizontal {
			flex-direction: row;
		}
	`}_SelectionController_handleSelectionEvent=new WeakMap,_SelectionController_instances=new WeakSet,_SelectionController_publish=function(){const t={detail:{type:this.type,value:this.strategy.value(this.host.selection)},bubbles:!0,composed:!1};this.host.dispatchEvent(new CustomEvent("m-change",t))};class RadioGroup extends s$5{static get properties(){return{value:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0},selection:{state:!0},orientation:{type:String}}}constructor(){super(),_RadioGroup_selectionController.set(this,null),_RadioGroup_defaultSlot.set(this,null),_RadioGroup_getDefaultChecked.set(this,(()=>{const t=__classPrivateFieldGet(this,_RadioGroup_getButtons,"f").call(this);return t[0]?.value})),_RadioGroup_getButtons.set(this,(()=>{__classPrivateFieldGet(this,_RadioGroup_defaultSlot,"f")||__classPrivateFieldSet(this,_RadioGroup_defaultSlot,this.shadowRoot&&this.shadowRoot.querySelector("slot"),"f");return[...__classPrivateFieldGet(this,_RadioGroup_defaultSlot,"f")?.assignedElements({flatten:!0})??[]].filter((t=>"m-radio"===t.tagName.toLowerCase()))})),_RadioGroup_setButtonChecked.set(this,(t=>{t.checked=this.selection.has(t.value)})),_RadioGroup_setButtonDisabled.set(this,(t=>{t.disabled=this.disabled})),this.disabled=!1,this.selection=new Set,this.value="",this.orientation="vertical",this.type="single-strict"}connectedCallback(){super.connectedCallback(),this.setAttribute("role","radio-group"),__classPrivateFieldSet(this,_RadioGroup_selectionController,new SelectionController(this,this.type,"m-check"),"f")}update(t){super.update(t),t.has("value")&&__classPrivateFieldGet(this,_RadioGroup_selectionController,"f")&&__classPrivateFieldGet(this,_RadioGroup_selectionController,"f").init(toArray$1(this.value||__classPrivateFieldGet(this,_RadioGroup_getDefaultChecked,"f").call(this))),t.has("selection")&&([this.value]=this.selection)}updated(t){super.updated(t),t.has("selection")&&__classPrivateFieldGet(this,_RadioGroup_getButtons,"f").call(this).forEach((t=>{__classPrivateFieldGet(this,_RadioGroup_setButtonChecked,"f").call(this,t)})),t.has("disabled")&&__classPrivateFieldGet(this,_RadioGroup_getButtons,"f").call(this).forEach((t=>{__classPrivateFieldGet(this,_RadioGroup_setButtonDisabled,"f").call(this,t)}))}render(){return x`
			<div
				class=${o$2({"radio-group":!0,"-vertical":"vertical"===this.orientation,"-horizontal":"horizontal"===this.orientation})}
			>
				<slot></slot>
			</div>
		`}}function styles$b(){return i$4`
		:host {
			display: block;
		}
	`}function sectionTitleStyles(){return i$4`
		:host {
			color: ${getColor("color-text-primary")};
			display: block;
		}

		slot[name='leading']::slotted(*) {
			display: inline-flex;
			flex-flow: row nowrap;
			align-items: center;
			justify-content: center;
			pointer-events: none;
			margin-inline-end: ${getToken("spacing-1")};
		}

		.title {
			height: 100%;
			width: 100%;
		}

		.-size-small {
			${typography("heading-sm")};
			margin: 0 0 ${getToken("spacing-1")} 0;
		}
		.-size-default {
			${typography("heading-md")};
			margin: 0 0 ${getToken("spacing-2")} 0;
		}
		.-size-large {
			${typography("heading-lg-bold")};
			margin: 0 0 ${getToken("spacing-2")} 0;
		}
	`}_RadioGroup_selectionController=new WeakMap,_RadioGroup_defaultSlot=new WeakMap,_RadioGroup_getDefaultChecked=new WeakMap,_RadioGroup_getButtons=new WeakMap,_RadioGroup_setButtonChecked=new WeakMap,_RadioGroup_setButtonDisabled=new WeakMap,RadioGroup.styles=[styles$c()],window.customElements.define("m-radio-group",RadioGroup);class Section extends s$5{render(){return x`
			<slot name="title"></slot>
			<m-divider></m-divider>
			<slot></slot>
		`}}Section.styles=[styles$b()],window.customElements.define("m-section",Section);const allowedTags=["h1","h2","h3","h4","h5","h6","p","span"];class SectionTitle extends(PolymorphicTagMixin({superClass:s$5,allowedTags,fallbackTag:"span"})){static get properties(){return{slot:{type:String,reflect:!0},size:{type:String}}}constructor(){super(),this.slot="title",this.size="default",this.as="span"}render(){return n$4`<${this.tag} class=${o$2({title:!0,"-size-small":"small"===this.size,"-size-default":"default"===this.size,"-size-large":"large"===this.size})}>
			<slot name="leading"></slot>
			<slot></slot>
		</${this.tag}>`}}function styles$a(){return i$4`
		:host {
			inline-size: var(--m-spinner-size);
			block-size: var(--m-spinner-size);
		}

		:host svg {
			height: 100%;
			width: 100%;
			animation: rotate 1.5s linear infinite;
		}

		@keyframes rotate {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(359deg);
			}
		}
	`}SectionTitle.styles=[sectionTitleStyles()],window.customElements.define("m-section-title",SectionTitle);const DEFAULT_SIZE$1=48;class SpinnerWheel extends s$5{static get properties(){return{size:{type:String}}}update(t){super.update(t),t.has("size")&&null!=this.size&&this.style.setProperty("--m-spinner-size",`${parseInt(String(this.size),10)||48}px`)}render(){return b`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill="#CADBDD" fill-rule="evenodd" d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Zm0-10c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14Z" clip-rule="evenodd"/><path fill="url(#a)" d="M24 43.068c0 2.724-2.231 4.983-4.898 4.427a23.999 23.999 0 0 1 0-46.99C21.77-.051 24 2.208 24 4.932c0 2.723-2.273 4.852-4.833 5.783a14.135 14.135 0 0 0-5.163 23.28 14.135 14.135 0 0 0 5.163 3.29c2.56.93 4.833 3.06 4.833 5.783Z"/><defs><linearGradient id="a" x1="9.608" x2="44.189" y1="42.161" y2="7.59" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/></linearGradient></defs></svg>`}}function stepsStyles(){return[i$4`
			:host {
				--m-steps-circle-size: 24px;

				display: flex;
				flex-direction: column;
				box-sizing: border-box;
				gap: ${getToken("spacing-10")};

				width: 100%;
			}

			::slotted(m-step) {
				flex: 1;
			}

			.steps-container {
				display: flex;
				flex-flow: row nowrap;
				justify-content: center;
				align-items: center;

				gap: ${getToken("spacing-10")};
			}
		`]}function stepStyles(){return[i$4`
			:host {
				--m-steps-circle-margin-inline-end: 8px;

				position: relative;
				display: inline-flex;
				flex-direction: column;
				align-items: center;

				gap: ${getToken("spacing-4")};
			}

			:host(:is(:focus, :focus-within, :focus-visible)) {
				outline: none;
			}

			.circle {
				${typography("number-md")};
				${transition([{property:"background-color"}])};

				display: flex;
				align-items: center;
				justify-content: center;

				inline-size: var(--m-steps-circle-size);
				block-size: var(--m-steps-circle-size);
				line-height: var(--m-steps-circle-size);

				border-radius: 50%;

				background-color: ${getColor("color-neutral-40")};
				color: ${getColor("color-text-inverted")};
			}

			.label {
				${typography("body-md")};

				display: flex;
				align-items: center;
				justify-content: center;

				color: ${getColor("color-primary-60")};
			}

			:host(:not(:last-of-type))::after,
			:host(:not(:first-of-type))::before {
				${transition([{property:"background-color"}])};

				content: '';
				position: absolute;
				display: inline-block;

				block-size: 2px;
				inline-size: 100%;
				background-color: ${getColor("color-neutral-40")};

				top: calc(var(--m-steps-circle-size) / 2);
			}

			:host::after {
				/* half width of the container + half circle + distance between bar and circle */
				left: calc(
					50% + var(--m-steps-circle-size) / 2 +
						var(--m-steps-circle-margin-inline-end)
				);
			}

			:host::before {
				right: calc(
					50% + var(--m-steps-circle-size) / 2 +
						var(--m-steps-circle-margin-inline-end)
				);
			}

			:host([completed])::after {
				background-color: ${getColor("color-primary-60")};
				color: ${getColor("color-text-inverted")};
			}

			:host(:is([completed], [aria-current='step']))::before {
				background-color: ${getColor("color-primary-60")};
				color: ${getColor("color-text-inverted")};
			}

			m-icon[name='check'] {
				display: none;
			}

			:host([completed]:not([aria-current='step'])) m-icon[name='check'] {
				--m-icon-color: ${getColor("color-text-inverted")};

				display: inline-flex;
			}

			:host(:is([aria-current='step'], [completed])) .circle {
				background-color: ${getColor("color-primary-60")};
			}

			:host([aria-current='step']) .label {
				${typography("body-md-bold")};
			}

			:host(:is([aria-current='step'], :not([completed]))) .label {
				display: inline-flex;
			}
		`]}var _Steps_instances,_Steps_stepSequence,_Steps_getDefaultActive,_Steps_queryStep,_Steps_handleSlotChange,_Steps_findStepIndex,_Steps_onNextStep,_Steps_onPreviousStep,_Steps_onNavigateStep,_Steps_onCompleteStep,_Switch_instances,_Switch_controllers,_Switch_toggle,_Switch_handleClick;SpinnerWheel.styles=[styles$a()],window.customElements.define("m-spinner-wheel",SpinnerWheel);class Steps extends Component{constructor(){super(...arguments),_Steps_instances.add(this),_Steps_stepSequence.set(this,[]),_Steps_getDefaultActive.set(this,(()=>this.querySelector("m-step")?.name)),_Steps_queryStep.set(this,(t=>t?this.querySelector(`[name="${t}"]`):null)),_Steps_handleSlotChange.set(this,(()=>{const t=Array.from(this.querySelectorAll("m-step"));__classPrivateFieldSet(this,_Steps_stepSequence,[],"f"),t.forEach(((t,e)=>{__classPrivateFieldGet(this,_Steps_stepSequence,"f").push(t.name),t.setAttribute("order",String(e+1))})),this.requestUpdate()})),_Steps_onNextStep.set(this,(()=>{const t=__classPrivateFieldGet(this,_Steps_instances,"m",_Steps_findStepIndex).call(this,this.activeStep);if(-1===t||t>=__classPrivateFieldGet(this,_Steps_stepSequence,"f").length-1)return;const e=t+1;this.activeStep=__classPrivateFieldGet(this,_Steps_stepSequence,"f")[e],this.emit("m-change",{detail:{active:this.activeStep}})})),_Steps_onPreviousStep.set(this,(()=>{const t=__classPrivateFieldGet(this,_Steps_instances,"m",_Steps_findStepIndex).call(this,this.activeStep);if(t<=0)return;const e=t-1;this.activeStep=__classPrivateFieldGet(this,_Steps_stepSequence,"f")[e],this.emit("m-change",{detail:{active:this.activeStep}})})),_Steps_onNavigateStep.set(this,(t=>{const{detail:e}=t;-1!==__classPrivateFieldGet(this,_Steps_instances,"m",_Steps_findStepIndex).call(this,e)&&e!==this.activeStep&&(this.activeStep=e,this.emit("m-change",{detail:{active:e}}))})),_Steps_onCompleteStep.set(this,(()=>{const t=__classPrivateFieldGet(this,_Steps_queryStep,"f").call(this,this.activeStep);t&&!0!==t.completed&&(t.completed=!0,this.emit("m-change",{detail:{completed:this.activeStep}}))}))}static get properties(){return{activeStep:{type:String,attribute:"active-step",reflect:!0}}}connectedCallback(){super.connectedCallback(),this.addEventListener("m-next",__classPrivateFieldGet(this,_Steps_onNextStep,"f")),this.addEventListener("m-previous",__classPrivateFieldGet(this,_Steps_onPreviousStep,"f")),this.addEventListener("m-navigate",__classPrivateFieldGet(this,_Steps_onNavigateStep,"f")),this.addEventListener("m-complete",__classPrivateFieldGet(this,_Steps_onCompleteStep,"f"))}disconnectedCallback(){super.disconnectedCallback(),this.removeEventListener("m-next",__classPrivateFieldGet(this,_Steps_onNextStep,"f")),this.removeEventListener("m-previous",__classPrivateFieldGet(this,_Steps_onPreviousStep,"f")),this.removeEventListener("m-navigate",__classPrivateFieldGet(this,_Steps_onNavigateStep,"f")),this.removeEventListener("m-complete",__classPrivateFieldGet(this,_Steps_onCompleteStep,"f"))}update(t){super.update(t);const e=__classPrivateFieldGet(this,_Steps_queryStep,"f").call(this,t.get("activeStep"));e&&e.removeAttribute("aria-current"),this.activeStep=this.activeStep??__classPrivateFieldGet(this,_Steps_getDefaultActive,"f").call(this);const o=__classPrivateFieldGet(this,_Steps_queryStep,"f").call(this,this.activeStep);o&&(o.setAttribute("tabindex","0"),o.setAttribute("aria-current","step"))}render(){return x`<div class="steps-container">
				<slot name="step" @slotchange=${__classPrivateFieldGet(this,_Steps_handleSlotChange,"f")}></slot>
			</div>
			<div class="content-container"><slot></slot></div>`}}_Steps_stepSequence=new WeakMap,_Steps_getDefaultActive=new WeakMap,_Steps_queryStep=new WeakMap,_Steps_handleSlotChange=new WeakMap,_Steps_onNextStep=new WeakMap,_Steps_onPreviousStep=new WeakMap,_Steps_onNavigateStep=new WeakMap,_Steps_onCompleteStep=new WeakMap,_Steps_instances=new WeakSet,_Steps_findStepIndex=function(t){return t?__classPrivateFieldGet(this,_Steps_stepSequence,"f").findIndex((e=>e===t)):-1},Steps.styles=[stepsStyles()],window.customElements.define("m-steps",Steps);class Step extends s$5{static get properties(){return{name:{type:String,reflect:!0},order:{type:String},completed:{type:Boolean,reflect:!0},"aria-current":{type:Boolean}}}connectedCallback(){super.connectedCallback(),this.slot="step"}render(){const t="step"===this.getAttribute("aria-current");return x`
			<span class="circle">
				${this.completed&&!t?A:this.order}
				<m-icon name="check" size="12"></m-icon>
			</span>
			<span class="label">
				<slot></slot>
			</span>
		`}}function styles$9(){return[i$4`
			:host {
				--m-switch-height: ${getToken("global-height-small")};
				--m-switch-background-color: ${getColor("color-neutral-40")};
				--m-switch-outline-color: ${getColor("color-primary-60")};
				--m-switch-outline-offset: 2px;
				--m-switch-thumb-width: 32px;
				--m-switch-thumb-height: 16px;
				--m-switch-circle-distance: 2px;
				--m-switch-circle-size: calc(
					var(--m-switch-thumb-height) - 2 * var(--m-switch-circle-distance)
				);

				${typography("body-md")};

				cursor: pointer;

				display: inline-flex;
				gap: ${getToken("spacing-2")};
				align-items: center;

				box-sizing: border-box;
				block-size: var(--m-switch-height);

				color: ${getColor("color-text-tertiary")};
				outline: none;
			}

			:host([size='large']) {
				--m-switch-height: ${getToken("global-height-large")};
				--m-switch-thumb-width: 40px;
				--m-switch-thumb-height: 20px;
			}

			:host([disabled]) {
				pointer-events: none;
				user-select: none;

				cursor: default;
			}

			:host([aria-checked='true']) .switch {
				--m-switch-background-color: ${getColor("color-primary-60")};
			}

			:host(:hover) .switch {
				--m-switch-background-color: ${getColor("color-neutral-60")};
			}

			:host([aria-checked='true']:hover) .switch {
				--m-switch-background-color: ${getColor("color-primary-100")};
			}

			:host([disabled]) ::slotted(*) {
				pointer-events: none;
				user-select: none;
			}

			:host([disabled]) .switch {
				--m-switch-background-color: ${getColor("color-primary-20")};
			}

			:host(:is(:focus, :focus-within, :focus-visible, .is-focused)) .switch {
				outline: 1px solid var(--m-switch-outline-color);
				outline-offset: var(--m-switch-outline-offset);
			}

			.switch {
				${transition([{property:"background-color"}])};

				background-color: var(--m-switch-background-color);
				border-radius: calc(0.5 * var(--m-switch-thumb-height));

				box-sizing: border-box;
				block-size: var(--m-switch-thumb-height);
				inline-size: var(--m-switch-thumb-width);

				position: relative;
			}

			.switch::after {
				${transition([{property:"left"}])};

				content: '';
				display: block;
				position: absolute;

				block-size: var(--m-switch-circle-size);
				inline-size: var(--m-switch-circle-size);
				border-radius: 50%;

				background-color: ${getColor("color-background-primary")};
				left: var(--m-switch-circle-distance);
				top: var(--m-switch-circle-distance);
			}

			:host([aria-checked='true']) .switch::after {
				left: calc(
					100% - var(--m-switch-circle-size) - var(--m-switch-circle-distance)
				);
			}
		`]}Step.styles=[stepStyles()],window.customElements.define("m-step",Step);class Switch extends Component{static get properties(){return{name:{type:String,reflect:!0},disabled:{type:Boolean,reflect:!0},checked:{type:Boolean,reflect:!0},size:{type:String,reflect:!0}}}constructor(){super(),_Switch_instances.add(this),_Switch_controllers.set(this,void 0),_Switch_handleClick.set(this,(t=>{if(this.disabled)return t.stopPropagation(),void t.preventDefault();__classPrivateFieldGet(this,_Switch_instances,"m",_Switch_toggle).call(this)})),this.checked=!1,this.disabled=!1,__classPrivateFieldSet(this,_Switch_controllers,{keyboard:new KeyboardSupportController(this,{shortcut:[{key:" "},{key:"Enter"}],handler:t=>{t.stopPropagation(),__classPrivateFieldGet(this,_Switch_instances,"m",_Switch_toggle).call(this)}})},"f")}connectedCallback(){super.connectedCallback(),this.setAttribute("role","switch"),this.addEventListener("click",__classPrivateFieldGet(this,_Switch_handleClick,"f"))}disconnectedCallback(){super.disconnectedCallback(),this.removeEventListener("click",__classPrivateFieldGet(this,_Switch_handleClick,"f"))}updated(t){super.updated(t),t.has("checked")&&this.setAttribute("aria-checked",String(this.checked??!1)),t.has("disabled")&&(this.disabled?this.removeAttribute("tabindex"):this.setAttribute("tabindex","0"))}render(){return x`
			<span class="switch"></span>
			<slot></slot>
		`}}function tableStyles(){return i$4`
		:host {
			--m-table-cell-height: 52px;

			display: block;
			width: 100%;
			border-collapse: separate;
			border-style: solid;
			border-radius: ${getToken("border-radius-s")};
			border-width: ${getToken("border-thin")};
			border-color: ${getColor("color-border")};
			background-color: ${getColor("color-background-secondary")};
			overflow: hidden;
		}

		.table {
			display: table;
		}
	`}function tableToolbarStyles(){return i$4`
		:host {
			padding: ${getToken("spacing-4")};
			background-color: ${getColor("color-background-primary")};
		}
	`}function tableHeadStyles(){return i$4`
		:host {
			--m-table-cell-height: 44px;

			display: table-header-group;
		}

		slot[name='table-row']::slotted(*) {
			${typography("table-header-sm")};
			color: ${getColor("color-text-tertiary")};
		}
	`}function tableBodyStyles(){return i$4`
		:host {
			display: table-row-group;
		}

		slot[name='table-row']::slotted(*) {
			background-color: ${getColor("color-background-primary")};
			color: ${getColor("color-text-primary")};
		}

		slot[name='table-row']::slotted(*:hover) {
			background-color: ${getColor("color-background-tertiary")};
		}

		:host-context([size='small']) {
			--m-table-cell-height: 32px;
			${typography("body-sm")};
		}

		:host-context([size='default']) {
			--m-table-cell-height: 52px;
			${typography("body-md")};
		}

		:host-context([size='large']) {
			--m-table-cell-height: 86px;
			${typography("body-md")};
		}
	`}function tableFootStyles(){return i$4`
		:host {
			--m-table-cell-height: 44px;

			display: table-footer-group;
		}

		slot[name='table-row']::slotted(*) {
			${typography("table-header-sm")};
			color: ${getColor("color-text-tertiary")};
		}
	`}function tableRowStyles(){return i$4`
		:host {
			display: table-row;
		}
	`}function tableCellStyles(){return i$4`
		:host {
			--m-table-cell-text-align: left;

			display: table-cell;
			box-sizing: border-box;
			height: var(--m-table-cell-height);
			padding-inline-start: ${getToken("spacing-4")};
			padding-inline-end: ${getToken("spacing-4")};
			vertical-align: middle;
			text-align: var(--m-table-cell-text-align);

			border-top-style: solid;
			border-top-width: ${getToken("border-thin")};
			border-top-color: ${getColor("color-divider")};
		}
	`}_Switch_controllers=new WeakMap,_Switch_handleClick=new WeakMap,_Switch_instances=new WeakSet,_Switch_toggle=function(){this.checked=!this.checked,this.emit("m-change",{detail:{name:this.name,checked:this.checked}})},Switch.styles=[styles$9()],window.customElements.define("m-switch",Switch);const defaultTableProps={size:"default"};class Table extends s$5{static get properties(){return{role:{type:String,reflect:!0},size:{type:String,reflect:!0}}}constructor(){super(),this.role="table",this.size=defaultTableProps.size}render(){return x`
			<m-stack gap="none">
				<slot name="table-toolbar"></slot>
				<div class="table">
					<slot name="table-head"></slot>
					<slot name="table-body"></slot>
					<slot name="table-foot"></slot>
				</div>
			</m-stack>
		`}}Table.styles=[tableStyles()],window.customElements.define("m-table",Table);class TableHead extends s$5{static get properties(){return{slot:{type:String,reflect:!0},role:{type:String,reflect:!0}}}constructor(){super(),this.slot="table-head",this.role="rowgroup"}render(){return x`<slot name="table-row"></slot>`}}TableHead.styles=[tableHeadStyles()],window.customElements.define("m-table-head",TableHead);class TableBody extends s$5{static get properties(){return{slot:{type:String,reflect:!0},role:{type:String,reflect:!0}}}constructor(){super(),this.slot="table-body",this.role="rowgroup"}render(){return x`<slot name="table-row"></slot>`}}TableBody.styles=[tableBodyStyles()],window.customElements.define("m-table-body",TableBody);class TableFoot extends s$5{static get properties(){return{slot:{type:String,reflect:!0},role:{type:String,reflect:!0}}}constructor(){super(),this.slot="table-foot",this.role="rowgroup"}render(){return x`<slot name="table-row"></slot>`}}TableFoot.styles=[tableFootStyles()],window.customElements.define("m-table-foot",TableFoot);class TableRow extends s$5{static get properties(){return{slot:{type:String,reflect:!0},role:{type:String,reflect:!0}}}constructor(){super(),this.slot="table-row",this.role="row"}render(){return x`<slot name="table-cell"></slot>`}}TableRow.styles=[tableRowStyles()],window.customElements.define("m-table-row",TableRow);class TableToolbar extends s$5{static get properties(){return{slot:{type:String,reflect:!0}}}constructor(){super(),this.slot="table-toolbar"}render(){return x`<slot></slot>`}}TableToolbar.styles=[tableToolbarStyles()],window.customElements.define("m-table-toolbar",TableToolbar);const defaultTableCellProps={alignment:"left"};class TableCell extends s$5{static get properties(){return{slot:{type:String,reflect:!0},role:{type:String,reflect:!0},alignment:{type:String}}}constructor(){super(),this.slot="table-cell",this.alignment=defaultTableCellProps.alignment}firstUpdated(){const t=null!=this.closest("m-table-head");this.role=t?"columnheader":"cell"}update(t){super.update(t),t.has("alignment")&&this.style.setProperty("--m-table-cell-text-align",this.alignment??defaultTableCellProps.alignment)}render(){return x`<slot></slot>`}}TableCell.styles=[tableCellStyles()],window.customElements.define("m-table-cell",TableCell);const tabsContext=n$2(Symbol("tabs")),TAB_SELECT_EVENT="m-select-tab";function styles$8(){return i$4`
		:host {
			--m-tabs-border-width: ${getToken("border-thin")};
			--m-tabs-border-color: ${getColor("color-divider")};
		}

		.tablist {
			display: flex;
			flex-direction: row;
			gap: 1px;
			border-bottom-style: solid;
			border-bottom-width: var(--m-tabs-border-width);
			border-bottom-color: var(--m-tabs-border-color);
		}
	`}var _Tabs_selectionController,_Tabs_defaultSlot,_Tabs_onSelectionChange,_Tabs_getDefaultSelected,_Tabs_getTabs,_Tab_instances,_Tab_button_get,_Tab_handleClick,_Tab_getContentDirection,_Tab_isSelected,_Tab_isDisabled,_a,_b,_TabPanel_isSelected,_TabPanel_isLazy;class Tabs extends Component{static get properties(){return{activeTab:{type:String,attribute:"active-tab",reflect:!0},disabled:{type:Boolean,reflect:!0},lazy:{type:Boolean},selection:{state:!0},tabContentDirection:{type:String,attribute:"tab-content-direction"}}}constructor(){super(),_Tabs_selectionController.set(this,null),_Tabs_defaultSlot.set(this,null),this.provider=new i(this,tabsContext,{tabContentDirection:"horizontal",disabled:!1,lazy:!1,selection:new Set("")}),_Tabs_onSelectionChange.set(this,(t=>{t.stopPropagation();const[e]=Array.from(this.selection),o={detail:{value:String(e)}};this.emit("m-tab-change",o)})),_Tabs_getDefaultSelected.set(this,(()=>{const t=__classPrivateFieldGet(this,_Tabs_getTabs,"f").call(this);return t[0]?.name})),_Tabs_getTabs.set(this,(()=>{__classPrivateFieldGet(this,_Tabs_defaultSlot,"f")||__classPrivateFieldSet(this,_Tabs_defaultSlot,this.shadowRoot&&this.shadowRoot.querySelector("slot"),"f");return[...__classPrivateFieldGet(this,_Tabs_defaultSlot,"f")?.assignedElements({flatten:!0})??[]].filter((t=>"m-tab"===t.tagName.toLowerCase()))})),this.activeTab="",this.tabContentDirection="horizontal",this.disabled=!1,this.lazy=!1,this.type="single-strict",this.selection=new Set}connectedCallback(){super.connectedCallback(),__classPrivateFieldSet(this,_Tabs_selectionController,new SelectionController(this,this.type,"m-select-tab"),"f"),this.addEventListener("m-change",__classPrivateFieldGet(this,_Tabs_onSelectionChange,"f"))}update(t){super.update(t),t.has("activeTab")&&__classPrivateFieldGet(this,_Tabs_selectionController,"f")&&__classPrivateFieldGet(this,_Tabs_selectionController,"f").init(toArray$1(this.activeTab||__classPrivateFieldGet(this,_Tabs_getDefaultSelected,"f").call(this)));const[e]=Array.from(this.selection);!t.has("selection")||this.activeTab&&e===this.activeTab||(this.activeTab=e),(t.has("tabContentDirection")||t.has("disabled")||t.has("lazy")||t.has("selection"))&&this.provider.setValue({tabContentDirection:this.tabContentDirection,disabled:this.disabled,lazy:this.lazy,selection:this.selection})}render(){return x`
			<div class="tablist" role="tablist"><slot name="tab"></slot></div>
			<slot></slot>
		`}}function styles$7(){return i$4`
		:host {
			--m-tab-border-width: ${getToken("border-thin")};
			--m-tab-border-color: ${getColor("color-divider")};
			--m-tab-border-radius: ${getToken("border-radius-s")};
			--m-tab-background-color: none;
			--m-tab-label-color: ${getColor("color-text-tertiary")};
			--m-tab-leading-color: ${getColor("color-text-tertiary")};

			--m-tab-outline-color: ${getColor("color-primary-60")};

			--m-tab-padding-x: ${getToken("spacing-6")};
			--m-tab-height: ${getToken("spacing-12")};
		}

		.tab {
			cursor: pointer;
			position: relative;
			padding-bottom: 1px;
			bottom: -1px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			gap: ${getToken("spacing-3")};
			height: var(--m-tab-height);
			padding-inline: var(--m-tab-padding-x);

			${typography("body-md")};
			color: var(--m-tab-label-color);

			background-color: var(--m-tab-background-color);
			border: none;
			border-bottom-style: solid;
			border-bottom-width: var(--m-tab-border-width);
			border-bottom-color: var(--m-tab-border-color);
			border-top-left-radius: var(--m-tab-border-radius);
			border-top-right-radius: var(--m-tab-border-radius);

			@media (prefers-reduced-motion: no-preference) {
				${transition([{property:"background-color"},{property:"border-color"},{property:"color"}])};
			}
		}
		.tab.-vertical {
			flex-direction: column;
			--m-tab-height: ${getToken("spacing-20")};
		}
		.tab.-horizontal {
			flex-direction: row;
		}

		slot[name='leading']::slotted(*) {
			display: contents;
			color: var(--m-tab-leading-color);
		}

		${on(".tab").not.disabled.hover} {
			--m-tab-background-color: ${getColor("color-background-tertiary")};
		}

		${on(".tab").not.disabled.focus} {
			outline: 1px solid var(--m-tab-outline-color);
		}

		.tab[aria-selected='true'] {
			--m-tab-border-width: ${getToken("border-medium")};
			--m-tab-border-color: ${getColor("color-primary-60")};
			--m-tab-label-color: ${getColor("color-text-secondary")};
			--m-tab-leading-color: ${getColor("color-primary-60")};
			padding-bottom: 0;
		}

		${on(".tab").disabled} {
			cursor: default;
			--m-tab-label-color: ${getColor("color-text-disabled")};
			--m-tab-leading-color: ${getColor("color-text-disabled")};
			--m-tab-border-color: ${getColor("color-divider")};
		}

		${on(".tab","*").disabled} {
			pointer-events: none;
		}
	`}_Tabs_selectionController=new WeakMap,_Tabs_defaultSlot=new WeakMap,_Tabs_onSelectionChange=new WeakMap,_Tabs_getDefaultSelected=new WeakMap,_Tabs_getTabs=new WeakMap,Tabs.styles=[styles$8()],window.customElements.define("m-tabs",Tabs);class Tab extends Component{static get properties(){return{name:{type:String},disabled:{type:Boolean,reflect:!0},slot:{type:String,reflect:!0}}}constructor(){super(),_Tab_instances.add(this),this.tabs=new s$2(this,{context:tabsContext,subscribe:!0}),_Tab_handleClick.set(this,(t=>{if(this.disabled)return t.preventDefault(),void t.stopPropagation();const e={detail:{value:this.name,type:"select"},bubbles:!0,composed:!1};this.emit("m-select-tab",e)})),_Tab_getContentDirection.set(this,(()=>this.tabs.value?.tabContentDirection)),_Tab_isSelected.set(this,(()=>Boolean(this.tabs.value?.selection.has(this.name)))),_Tab_isDisabled.set(this,(()=>this.disabled||Boolean(this.tabs.value?.disabled))),this.disabled=!1}connectedCallback(){super.connectedCallback(),this.id=`${this.name}-tab`,this.setAttribute("slot","tab"),this.setAttribute("role","tab"),this.setAttribute("aria-controls",`${this.name}-panel`),this.setAttribute("aria-selected","false"),this.addEventListener("click",__classPrivateFieldGet(this,_Tab_handleClick,"f"))}updated(t){super.updated(t),__classPrivateFieldGet(this,_Tab_isSelected,"f").call(this)?this.setAttribute("aria-selected","true"):this.setAttribute("aria-selected","false"),t.has("name")&&(this.id=`${this.name}-tab`,this.setAttribute("aria-controls",`${this.name}-panel`)),t.has("disabled")&&this.setAttribute("aria-disabled",String(this.disabled??!1))}render(){return x`
			<button
				type="button"
				class=${o$2({tab:!0,"-vertical":"vertical"===__classPrivateFieldGet(this,_Tab_getContentDirection,"f").call(this),"-horizontal":"horizontal"===__classPrivateFieldGet(this,_Tab_getContentDirection,"f").call(this)})}
				?disabled=${__classPrivateFieldGet(this,_Tab_isDisabled,"f").call(this)}
				aria-selected=${__classPrivateFieldGet(this,_Tab_isSelected,"f").call(this)}
			>
				<slot name="leading"></slot>
				<slot></slot>
			</button>
		`}focus(t){__classPrivateFieldGet(this,_Tab_instances,"a",_Tab_button_get)?.focus(t)}}function styles$6(){return i$4`
		:host {
			--m-tab-panel-display: none;

			display: var(--m-tab-panel-display);
		}
	`}_Tab_handleClick=new WeakMap,_Tab_getContentDirection=new WeakMap,_Tab_isSelected=new WeakMap,_Tab_isDisabled=new WeakMap,_Tab_instances=new WeakSet,_Tab_button_get=function(){return this.renderRoot?.querySelector("button")??null},Tab.styles=[styles$7()],window.customElements.define("m-tab",Tab);class TabPanel extends(_b=Box){static get properties(){return{...super.properties,forTab:{type:String,attribute:"for-tab"},lazy:{type:Boolean}}}constructor(){super(),this.tabs=new s$2(this,{context:tabsContext,subscribe:!0}),_TabPanel_isSelected.set(this,(()=>Boolean(this.tabs.value?.selection.has(this.forTab)))),_TabPanel_isLazy.set(this,(()=>this.lazy||Boolean(this.tabs.value?.lazy))),this.lazy=!1,this.padding="none",this.paddingY="spacing-8"}connectedCallback(){super.connectedCallback(),this.id=`${this.forTab}-panel`,this.setAttribute("role","tabpanel"),this.setAttribute("aria-labelledby",`${this.forTab}-tab`)}updated(t){super.updated(t),__classPrivateFieldGet(this,_TabPanel_isSelected,"f").call(this)?(this.style.setProperty("--m-tab-panel-display","block"),this.removeAttribute("aria-hidden")):(this.style.setProperty("--m-tab-panel-display","none"),this.setAttribute("aria-hidden","true")),t.has("forTab")&&(this.id=`${this.forTab}-panel`,this.setAttribute("aria-labelledby",`${this.forTab}-tab`))}render(){return __classPrivateFieldGet(this,_TabPanel_isLazy,"f").call(this)&&!__classPrivateFieldGet(this,_TabPanel_isSelected,"f").call(this)?x``:x`<slot></slot>`}}function tagStyles(){return[skeleton.styles(),i$4`
			:host {
				--m-tag-skeleton-width: 100px;

				display: contents;
			}
			.tag {
				display: inline-block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				box-sizing: border-box;
				max-width: 200px;
				border-radius: 100px;
				line-height: ${getToken("line-height-1")};
				cursor: default;
			}

			.tag slot[name='leading']::slotted(*) {
				margin-inline-end: ${getToken("spacing-1")};
				vertical-align: middle;
			}

			.-size-small {
				${typography("chips-sm")};
				padding: ${getToken("spacing-1")} ${getToken("spacing-2")};
				block-size: ${toRem("18px")};
			}
			.-size-default {
				${typography("chips-md")};
				padding: ${getToken("spacing-2")} ${getToken("spacing-3")};
				block-size: ${getToken("global-height-small")};
			}
			.-size-large {
				${typography("button-lg")};
				padding: ${getToken("spacing-3")} ${getToken("spacing-4")};
				block-size: ${getToken("global-height-default")};
			}

			.-success {
				color: ${getColor("color-success-60")};
				background: ${getColor("color-success-20")};
			}
			.-neutral {
				color: ${getColor("color-text-tertiary")};
				background: ${getColor("color-background-tertiary")};
			}
			.-warning {
				color: ${getColor("color-warning-100")};
				background: ${getColor("color-warning-20")};
			}
			.-danger {
				color: ${getColor("color-danger-60")};
				background: ${getColor("color-danger-20")};
			}

			.-is-skeleton {
				${skeleton()};
				width: var(--m-tag-skeleton-width);
			}
		`]}_a=TabPanel,_TabPanel_isSelected=new WeakMap,_TabPanel_isLazy=new WeakMap,TabPanel.styles=[...Reflect.get(_b,"styles",_a),styles$6()],window.customElements.define("m-tab-panel",TabPanel);class Tag extends s$5{static get properties(){return{variant:{type:String},size:{type:String},isSkeleton:{type:Boolean,attribute:"is-skeleton"}}}constructor(){super(),this.variant="neutral",this.size="default",this.isSkeleton=!1}render(){return x`
			<span
				class=${o$2({tag:!0,"-success":"success"===this.variant,"-neutral":"neutral"===this.variant,"-warning":"warning"===this.variant,"-danger":"danger"===this.variant,"-is-skeleton":this.isSkeleton,"-size-small":"small"===this.size,"-size-default":"default"===this.size,"-size-large":"large"===this.size})}
			>
				${this.isSkeleton?x``:x`<slot name="leading"></slot>`}
				<slot></slot>
			</span>
		`}}Tag.styles=[tagStyles()],window.customElements.define("m-tag",Tag);var e=new Map;function t(t){var o=e.get(t);o&&o.destroy()}function o(t){var o=e.get(t);o&&o.update()}var r=null;"undefined"==typeof window?((r=function(t){return t}).destroy=function(t){return t},r.update=function(t){return t}):((r=function(t,o){return t&&Array.prototype.forEach.call(t.length?t:[t],(function(t){return function(t){if(t&&t.nodeName&&"TEXTAREA"===t.nodeName&&!e.has(t)){var o,i=null,r=window.getComputedStyle(t),n=(o=t.value,function(){a({testForHeightReduction:""===o||!t.value.startsWith(o),restoreTextAlign:null}),o=t.value}),s=function(o){t.removeEventListener("autosize:destroy",s),t.removeEventListener("autosize:update",l),t.removeEventListener("input",n),window.removeEventListener("resize",l),Object.keys(o).forEach((function(e){return t.style[e]=o[e]})),e.delete(t)}.bind(t,{height:t.style.height,resize:t.style.resize,textAlign:t.style.textAlign,overflowY:t.style.overflowY,overflowX:t.style.overflowX,wordWrap:t.style.wordWrap});t.addEventListener("autosize:destroy",s),t.addEventListener("autosize:update",l),t.addEventListener("input",n),window.addEventListener("resize",l),t.style.overflowX="hidden",t.style.wordWrap="break-word",e.set(t,{destroy:s,update:l}),l()}function a(e){var o,n,s=e.restoreTextAlign,l=void 0===s?null:s,c=e.testForHeightReduction,d=void 0===c||c,h=r.overflowY;if(0!==t.scrollHeight&&("vertical"===r.resize?t.style.resize="none":"both"===r.resize&&(t.style.resize="horizontal"),d&&(o=function(t){for(var e=[];t&&t.parentNode&&t.parentNode instanceof Element;)t.parentNode.scrollTop&&e.push([t.parentNode,t.parentNode.scrollTop]),t=t.parentNode;return function(){return e.forEach((function(t){var e=t[0],o=t[1];e.style.scrollBehavior="auto",e.scrollTop=o,e.style.scrollBehavior=null}))}}(t),t.style.height=""),n="content-box"===r.boxSizing?t.scrollHeight-(parseFloat(r.paddingTop)+parseFloat(r.paddingBottom)):t.scrollHeight+parseFloat(r.borderTopWidth)+parseFloat(r.borderBottomWidth),"none"!==r.maxHeight&&n>parseFloat(r.maxHeight)?("hidden"===r.overflowY&&(t.style.overflow="scroll"),n=parseFloat(r.maxHeight)):"hidden"!==r.overflowY&&(t.style.overflow="hidden"),t.style.height=n+"px",l&&(t.style.textAlign=l),o&&o(),i!==n&&(t.dispatchEvent(new Event("autosize:resized",{bubbles:!0})),i=n),h!==r.overflow&&!l)){var u=r.textAlign;"hidden"===r.overflow&&(t.style.textAlign="start"===u?"end":"start"),a({restoreTextAlign:u,testForHeightReduction:!0})}}function l(){a({testForHeightReduction:!0,restoreTextAlign:null})}}(t)})),t}).destroy=function(e){return e&&Array.prototype.forEach.call(e.length?e:[e],t),e},r.update=function(t){return t&&Array.prototype.forEach.call(t.length?t:[t],o),t});var _TextArea_handleInput,_TextArea_updateStatusClass,_TextField_instances,_TextField_isClearVisible,_TextField_updateStatusClass,_TextField_handleInput,_TextField_handleClear,n=r;function styles$5(){return i$4`
		:host {
			--m-text-area-background-color: ${getColor("color-background-primary")};
			--m-text-area-border-color: ${getColor("color-border")};
			--m-text-area-min-height: 135px;
			--m-text-area-placeholder-color: ${getColor("color-text-placeholder")};
			--m-text-area-color: ${getColor("color-text-primary")};

			${typography("body-md")};
			${transition([{property:"background-color"},{property:"border-color"}])};

			display: inline-flex;
			align-items: center;
			justify-content: start;
			gap: ${getToken("spacing-2")};

			overflow: hidden;

			position: relative;
			box-sizing: border-box;
			width: 100%;
			min-block-size: var(--m-text-area-min-height);

			background-color: var(--m-text-area-background-color);
			border-radius: ${getToken("border-radius-s")};
			border: 1px solid var(--m-text-area-border-color);

			${p(getToken("spacing-2"))};
		}

		:host([resize='none']:not([autosize])) textarea {
			resize: none;
		}

		:host([resize='both']:not([autosize])) textarea {
			resize: both;
		}

		:host([resize='horizontal']:not([autosize])) textarea {
			resize: horizontal;
		}

		:host([resize='vertical']:not([autosize])) textarea {
			resize: vertical;
		}

		:host([resize='block']:not([autosize])) textarea {
			resize: block;
		}

		:host([resize='inline']:not([autosize])) textarea {
			resize: inline;
		}

		:host([status='danger']) {
			--m-text-area-border-color: ${getColor("color-danger-60")};
		}

		:host([disabled]) {
			--m-text-area-background-color: ${getColor("color-background-tertiary")};

			cursor: default;
		}

		:host([disabled]) * {
			pointer-events: none;
		}

		:host(:not([disabled]):hover) {
			--m-text-area-border-color: ${getColor("color-primary-60")};
		}

		:host(:not([disabled]):is(:focus, :focus-visible, :focus-within)) {
			--m-text-area-border-color: ${getColor("color-primary-100")};
		}

		${on("textarea").not.disabled.active},
		${on("textarea").not.disabled.focus} {
			-webkit-appearance: none;
			background: none;
			border: none;
			outline: none;
		}

		textarea {
			${typography("body-md")};

			border: none;
			outline: none;
			flex: 1;
			min-width: 0;
			min-block-size: var(--m-text-area-min-height);

			padding: 0;

			background-color: var(--m-text-area-background-color);
			color: var(--m-text-area-color);

			scrollbar-width: thin;
			scrollbar-color: ${getColor("color-border")}
				${getColor("color-background-tertiary")};

			outline: none;
		}

		textarea::placeholder {
			color: var(--m-text-area-placeholder-color);
		}

		textarea::-webkit-scrollbar {
			width: 8px;
			border-radius: ${getToken("border-radius-m")};
		}

		textarea::-webkit-scrollbar-track {
			background: ${getColor("color-background-tertiary")};
			border-radius: ${getToken("border-radius-m")};
		}

		textarea::-webkit-scrollbar-thumb {
			background-color: ${getColor("color-border")};
			border-radius: ${getToken("border-radius-m")};
			background-clip: padding-box;
		}
	`}class TextArea extends Component{static get properties(){return{autosize:{type:Boolean},autocomplete:{type:Boolean},autofocus:{type:Boolean},cols:{type:Number},dirname:{type:String},disabled:{type:Boolean,reflect:!0},maxLength:{type:Number,reflect:!0,attribute:"max-length"},minLength:{type:Number,reflect:!0,attribute:"min-length"},name:{type:String},placeholder:{type:String},readOnly:{type:Boolean,reflect:!0,attribute:"read-only"},resize:{type:String,reflect:!0},rows:{type:Number},spellcheck:{type:Boolean,reflect:!0,attribute:"spell-check"},value:{type:String},wrap:{type:String},status:{type:String,reflect:!0}}}constructor(){super(),this.textAreaElement=null,this.field=new s$2(this,{context:fieldContext,subscribe:!0,callback:()=>{__classPrivateFieldGet(this,_TextArea_updateStatusClass,"f").call(this)}}),_TextArea_handleInput.set(this,(t=>{this.value=t.target.value,this.reemit(t)})),_TextArea_updateStatusClass.set(this,(()=>{const t=this.status||this.field.value?.status;this.classList.remove("-status-default","-status-danger"),this.classList.add(`-status-${t}`)})),this.cols=40,this.disabled=!1,this.placeholder=void 0,this.resize="vertical",this.rows=6,this.value=void 0}connectedCallback(){super.connectedCallback(),this.setAttribute("role","textbox")}update(t){super.update(t),t.has("status")&&__classPrivateFieldGet(this,_TextArea_updateStatusClass,"f").call(this)}updated(t){super.updated(t),t.has("autosize")&&(this.autosize?n(this.textarea):n.destroy(this.textarea))}render(){return x`<textarea
			name="${l$1(this.name)}"
			autocomplete=${l$1(this.autocomplete)}
			?autofocus=${this.autofocus}
			dirname="${l$1(this.dirname)}"
			cols="${l$1(this.cols)}"
			rows="${l$1(this.rows)}"
			aria-disabled=${this.disabled?"true":"false"}
			?disabled="${this.disabled}"
			?readonly=${this.readOnly}
			maxlength=${l$1(null!=this.maxLength&&this.maxLength>-1?this.maxLength:void 0)}
			minlength=${l$1(null!=this.minLength&&this.minLength>-1?this.minLength:void 0)}
			placeholder="${l$1(this.placeholder)}"
			@change=${this.reemit}
			@input=${__classPrivateFieldGet(this,_TextArea_handleInput,"f")}
			spellcheck=${l$1(this.spellcheck)}
			wrap=${l$1(this.wrap)}
		>
${this.value}</textarea
		>`}get textarea(){return null==this.textAreaElement&&(this.textAreaElement=this.renderRoot?.querySelector("textArea")??null),this.textAreaElement}focus(){this.textarea?.focus()}}function styles$4(){return i$4`
		:host {
			--m-text-field-background-color: ${getColor("color-background-primary")};
			--m-text-field-border-color: ${getColor("color-border")};
			--m-text-field-height: ${getToken("global-height-default")};
			--m-text-field-padding-y: ${getToken("spacing-2")};
			--m-text-field-placeholder-color: ${getColor("color-text-placeholder")};
			--m-text-field-color: ${getColor("color-text-primary")};

			${typography("body-md")};
			${transition([{property:"background-color"},{property:"border-color"}])};

			display: inline-flex;
			align-items: center;
			justify-content: start;
			gap: ${getToken("spacing-2")};

			position: relative;
			box-sizing: border-box;
			width: 100%;
			block-size: var(--m-text-field-height);

			${px(getToken("spacing-2"))};

			background-color: var(--m-text-field-background-color);
			border-radius: ${getToken("border-radius-s")};
			border: 1px solid var(--m-text-field-border-color);
		}

		:host([size='small']) {
			--m-text-field-height: ${getToken("global-height-small")};
			--m-text-field-padding-y: 0;
		}

		:host([size='small']),
		:host([size='small']) input {
			${typography("body-sm")};
		}

		:host([size='large']) {
			--m-text-field-height: ${getToken("global-height-large")};
			--m-text-field-padding-y: ${getToken("spacing-3")};
		}

		:host(.-status-danger) {
			--m-text-field-border-color: ${getColor("color-danger-60")};
		}

		:host([disabled]) {
			--m-text-field-background-color: ${getColor("color-background-tertiary")};

			cursor: default;
		}

		:host([disabled]) * {
			pointer-events: none;
		}

		slot[name='leading']::slotted(*),
		slot[name='trailing']::slotted(*) {
			display: inline-flex;
			flex: 0 0 auto;
			align-items: center;
			cursor: default;
		}

		:host(:not([disabled]):hover) {
			--m-text-field-border-color: ${getColor("color-primary-60")};
		}

		:host(:not([disabled]):is(:focus, :focus-visible, :focus-within)) {
			--m-text-field-border-color: ${getColor("color-primary-100")};
		}

		${on("input").not.disabled.active},
		${on("input").not.disabled.focus} {
			-webkit-appearance: none;
			background: none;
			border: none;
			outline: none;
		}

		input {
			${typography("body-md")};

			align-self: stretch;
			border: none;
			outline: none;
			flex: 1;
			min-width: 0;

			${px(0)};
			padding-block: var(--m-text-field-padding-y);

			background-color: var(--m-text-field-background-color);
			color: var(--m-text-field-color);
		}

		input::placeholder {
			color: var(--m-text-field-placeholder-color);
		}

		.clear {
			visibility: hidden;
		}

		.clear.is-visible {
			visibility: visible;
		}
	`}_TextArea_handleInput=new WeakMap,_TextArea_updateStatusClass=new WeakMap,TextArea.styles=[styles$5()],window.customElements.define("m-text-area",TextArea);class TextField extends Component{static get properties(){return{clearable:{type:Boolean},disabled:{type:Boolean,reflect:!0},inputMode:{type:String,attribute:"input-mode"},max:{type:String},maxLength:{type:Number,reflect:!0,attribute:"max-length"},min:{type:String},minLength:{type:Number,reflect:!0,attribute:"min-length"},name:{type:String},pattern:{type:String},placeholder:{type:String},readOnly:{type:Boolean,reflect:!0,attribute:"read-only"},size:{type:String,reflect:!0},status:{type:String,reflect:!0},step:{type:String},type:{type:String},value:{type:String}}}constructor(){super(),_TextField_instances.add(this),this.inputElement=null,this.field=new s$2(this,{context:fieldContext,subscribe:!0,callback:()=>{__classPrivateFieldGet(this,_TextField_updateStatusClass,"f").call(this)}}),_TextField_updateStatusClass.set(this,(()=>{const t=this.status||this.field.value?.status||"default";this.classList.remove("-status-default","-status-danger"),this.classList.add(`-status-${t}`)})),_TextField_handleInput.set(this,(t=>{this.value=t.target.value,this.reemit(t)})),_TextField_handleClear.set(this,(t=>{t.stopPropagation(),this.clear()})),this.clearable=!1,this.disabled=!1,this.placeholder=void 0,this.size="default",this.type="text",this.value=void 0,this.max=""}connectedCallback(){super.connectedCallback(),this.setAttribute("role","textbox")}update(t){super.update(t),t.has("status")&&__classPrivateFieldGet(this,_TextField_updateStatusClass,"f").call(this)}render(){return x`
			<slot name="leading"></slot>
			<input
				?disabled="${this.disabled}"
				?readonly=${this.readOnly}
				@change=${this.reemit}
				@input=${__classPrivateFieldGet(this,_TextField_handleInput,"f")}
				aria-disabled=${this.disabled?"true":"false"}
				autocomplete=${l$1(this.autocomplete)}
				id="${l$1(this.id)}"
				inputmode=${l$1(this.inputMode)}
				max=${this.max||A}
				maxlength=${l$1(null!=this.maxLength&&this.maxLength>-1?this.maxLength:void 0)}
				min=${this.min||A}
				minlength=${l$1(null!=this.minLength&&this.minLength>-1?this.minLength:void 0)}
				name="${l$1(this.name)}"
				pattern=${l$1(this.pattern)}
				placeholder="${l$1(this.placeholder)}"
				step=${this.step||A}
				type="${l$1(this.type)}"
				value="${l$1(this.value)}"
			/>
			${this.clearable?x`<m-close-button
						class=${o$2({clear:!0,"is-visible":__classPrivateFieldGet(this,_TextField_instances,"m",_TextField_isClearVisible).call(this)})}
						controls="${l$1(this.id)}"
						@m-close=${__classPrivateFieldGet(this,_TextField_handleClear,"f")}
						label="Clear input"
				  ></m-close-button>`:A}
			<slot name="trailing"></slot>
		`}get input(){return null==this.inputElement&&(this.inputElement=this.renderRoot?.querySelector("input")??null),this.inputElement}clear(){this.value="",this.input&&(this.input.value=""),this.emit("m-clear"),this.focus()}focus(){this.input?.focus()}}function timelineStyles(){return i$4`
		::slotted(*) {
			width: 100%;
		}

		:host {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: flex-start;

			gap: ${getToken("spacing-4")};
		}
	`}function timelineItemStyles(){return i$4`
		::slotted(:not(m-timeline-item-icon)) {
			width: 100%;
		}

		:host {
			--m-timeline-item-circle-size: 22px;
			--m-timeline-item-inner-circle-distance: 3px;

			--m-timeline-item-background-color: ${getColor("color-neutral-40")};
			--m-timeline-item-min-height: ${getToken("global-height-large")};

			--m-timeline-item-content-gap: ${getToken("spacing-6")};

			position: relative;
			display: flex;
			flex-direction: row nowrap;
			align-items: flex-start;

			box-sizing: border-box;
			min-height: var(--m-timeline-item-min-height);

			gap: ${getToken("spacing-6")};

			padding: 0;
			margin: 0;
		}

		.side {
			display: flex;
			flex-direction: column;
			gap: ${getToken("spacing-4")};

			align-self: stretch;
			align-items: center;
		}

		.track {
			${transition([{property:"background-color"}])};

			display: inline-block;

			inline-size: 2px;
			block-size: 100%;

			background-color: ${getColor("color-border")};
		}

		.content {
			${typography("body-md")};

			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			gap: var(--m-timeline-item-content-gap);

			flex: 1;

			padding: 0 0 ${getToken("spacing-6")} 0;
			padding-block-end: ${getToken("spacing-6")};
		}

		.content.-divider {
			border-bottom: 1px solid ${getColor("color-border")};
		}

		.circle {
			${typography("number-md")};
			${transition([{property:"background-color"}])};

			display: flex;
			align-items: center;
			justify-content: center;

			flex: 0 0 var(--m-timeline-item-circle-size);

			box-sizing: border-box;
			inline-size: var(--m-timeline-item-circle-size);
			block-size: var(--m-timeline-item-circle-size);

			border-radius: 50%;

			background-color: var(--m-timeline-item-background-color);
			color: var(--m-timeline-item-background-color);
		}

		.check,
		.dot,
		.exclamation {
			display: none;
		}

		.dot {
			--size: calc(
				var(--m-timeline-item-circle-size) - 2 *
					var(--m-timeline-item-inner-circle-distance)
			);

			inline-size: var(--size);
			block-size: var(--size);
			box-sizing: border-box;

			border-radius: 50%;
			border: var(--m-timeline-item-inner-circle-distance) solid
				${getColor("color-text-inverted")};
			background-color: ${getColor("color-primary-60")};
		}

		.exclamation {
			${typography("body-md-bold")};
			line-height: var(--m-timeline-item-circle-size);
			color: ${getColor("color-text-inverted")};
		}

		:host(:is(:focus, :focus-within, :focus-visible)) {
			outline: none;
		}

		:host(:is([completed], [active])) {
			--m-timeline-item-background-color: ${getColor("color-primary-60")};
		}

		:host([variant='warning']:not([active], [active])) {
			--m-timeline-item-background-color: ${getColor("color-warning-60")};
		}

		:host([completed]:not([active])) .check {
			display: inline-flex;
		}

		:host([completed]:not([active])) .track {
			background-color: ${getColor("color-primary-60")};
		}

		:host([active]) .dot {
			display: inline-flex;
		}

		:host([variant='warning']:not([active], [active])) .exclamation {
			display: inline-flex;
		}
	`}function timelineExpandableItemStyles(){return i$4`
		.m-timeline-item-header-trigger {
			display: flex;
			margin: 0;
			padding: 0;
			cursor: pointer;
			width: 100%;
			outline: none;
			border: none;
			align-items: center;
			background-color: transparent;
		}

		.m-timeline-item-header-trigger[aria-expanded='true'] m-icon {
			transform: rotate(180deg);
		}

		.m-timeline-item-body-section {
			height: auto;
			width: 100%;
			overflow: hidden;
		}

		@media (prefers-reduced-motion: no-preference) {
			m-icon {
				${transition([{property:"transform"}])};
			}

			.content {
				${transition([{property:"gap"}])};
			}

			.m-timeline-item-body-section {
				${transition([{property:"height"},{property:"visibility"}])};
				will-change: height;
			}
		}
	`}function timelineItemHeaderStyles(){return i$4`
		:host {
			--m-timeline-item-header-align: baseline;

			display: flex;
			flex-direction: row;
			align-items: var(--m-timeline-item-header-align);
			justify-content: flex-start;

			gap: ${getToken("spacing-2")};

			box-sizing: border-box;
		}
	`}function timelineBodyStyles(){return i$4`
		:host {
			display: block;

			box-sizing: border-box;
		}
	`}function timelineFooterStyles(){return i$4`
		:host {
			display: block;

			box-sizing: border-box;
		}
	`}function timelineIconStyles(){return i$4`
		:host {
			display: flex;
			box-sizing: border-box;
		}
	`}_TextField_updateStatusClass=new WeakMap,_TextField_handleInput=new WeakMap,_TextField_handleClear=new WeakMap,_TextField_instances=new WeakSet,_TextField_isClearVisible=function(){const t=this.value||"";return!this.disabled&&t.length>0},TextField.styles=[styles$4()],window.customElements.define("m-text-field",TextField);class Timeline extends Component{update(t){if(super.update(t),null!=this.activeEntry){let t=!0;for(const e of this.entries)e.active?t=!1:(e.completed=t,e.active=!1)}}render(){return x`<slot name="item"></slot>`}get entries(){return Array.from(this.querySelectorAll("m-timeline-item"))}get activeEntry(){return this.querySelector("m-timeline-item[active]")}}Timeline.styles=[timelineStyles()],window.customElements.define("m-timeline",Timeline);const timelineItemContext=n$2(Symbol("timeline-item"));var _TimelineExpandableItem_instances,_TimelineExpandableItem_contextProvider,_TimelineExpandableItem_timelineItemHeaderTrigger_get,_TimelineExpandableItem_timelineItemBodySection_get,_TimelineExpandableItem_timelineItemBody_get,_TimelineExpandableItem_handleExpand,_TimelineExpandableItem_toggle,_TimelineExpandableItem_handleTransition,_TimelineItem_contextProvider,_TimelineItemHeaderTitle_context,_TimelineItemHeaderTitle_updateTextStyle;attachContextRoot();class TimelineExpandableItem extends Component{constructor(){super(...arguments),_TimelineExpandableItem_instances.add(this),_TimelineExpandableItem_contextProvider.set(this,new i(this,{context:timelineItemContext,initialValue:{variant:"neutral",completed:!1,active:!1}})),_TimelineExpandableItem_handleTransition.set(this,(()=>{this.expanded&&(__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBodySection_get).style.height="auto")}))}static get properties(){return{completed:{type:Boolean,reflect:!0},active:{type:Boolean,reflect:!0},variant:{type:String,reflect:!0},expanded:{type:Boolean,reflect:!0}}}connectedCallback(){super.connectedCallback(),this.slot="item",this.variant=this.variant??"neutral",this.active=this.active??!1,this.completed=this.completed??!1,this.divider=this.divider??!1,this.expanded=this.expanded??!1,this.resizeObserver=new ResizeObserver((t=>{this.bodyHeight=t[0].target.scrollHeight}))}firstUpdated(){__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBody_get).style.transition="visibility 0.35s",__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBody_get).setAttribute("role","region"),this.resizeObserver.observe(__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBodySection_get)),__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBodySection_get).addEventListener("transitionend",__classPrivateFieldGet(this,_TimelineExpandableItem_handleTransition,"f"))}update(t){super.update(t),t.has("active")&&(this.active?(this.setAttribute("tabindex","0"),this.setAttribute("aria-active","step"),this.closest("m-timeline")?.requestUpdate()):(this.removeAttribute("tabindex"),this.removeAttribute("aria-active"))),t.has("expanded")&&__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"m",_TimelineExpandableItem_handleExpand).call(this)}updated(t){super.updated(t),(t.has("active")||t.has("completed")||t.has("variant"))&&__classPrivateFieldGet(this,_TimelineExpandableItem_contextProvider,"f").setValue({variant:this.variant??"neutral",completed:Boolean(this.completed),active:Boolean(this.active)})}disconnectedCallback(){super.disconnectedCallback(),__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBodySection_get).removeEventListener("transitionend",__classPrivateFieldGet(this,_TimelineExpandableItem_handleTransition,"f")),this.resizeObserver.disconnect()}render(){return x`
			<div class="side">
				<span aria-hidden="true" class="circle">
					<slot name="item-icon">
						<span class="dot"></span>
						<span class="exclamation">!</span>
						<m-icon
							class="check"
							name="check"
							size="12"
							color="color-text-inverted"
						></m-icon>
					</slot>
				</span>
				<span class="track"></span>
			</div>
			<div
				class="${o$2({content:!0,"-divider":Boolean(this.divider)})}"
			>
				<button
					class="m-timeline-item-header-trigger"
					@click="${__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"m",_TimelineExpandableItem_toggle)}"
					tabindex="0"
					type="button"
				>
					<slot name="item-header"></slot>
					<m-icon name="caret-down"></m-icon>
				</button>
				<section class="m-timeline-item-body-section">
					<slot name="item-body"></slot>
				</section>
				<slot name="item-footer"></slot>
			</div>
		`}}_TimelineExpandableItem_contextProvider=new WeakMap,_TimelineExpandableItem_handleTransition=new WeakMap,_TimelineExpandableItem_instances=new WeakSet,_TimelineExpandableItem_timelineItemHeaderTrigger_get=function(){return this.renderRoot.querySelector(".m-timeline-item-header-trigger")},_TimelineExpandableItem_timelineItemBodySection_get=function(){return this.renderRoot.querySelector(".m-timeline-item-body-section")},_TimelineExpandableItem_timelineItemBody_get=function(){return this.querySelector("m-timeline-item-body")},_TimelineExpandableItem_handleExpand=function(){__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemHeaderTrigger_get).setAttribute("aria-expanded",`${this.expanded}`),__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBodySection_get).style.height=`${this.bodyHeight}px`,this.expanded?(__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBody_get).style.visibility="visible",this.style.setProperty("--m-timeline-item-content-gap",toSpacingCSSValue("spacing-6"))):setTimeout((()=>{__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBodySection_get).style.height="0px",__classPrivateFieldGet(this,_TimelineExpandableItem_instances,"a",_TimelineExpandableItem_timelineItemBody_get).style.visibility="hidden",this.style.setProperty("--m-timeline-item-content-gap",toSpacingCSSValue("none"))}))},_TimelineExpandableItem_toggle=function(){this.expanded=!this.expanded,this.emit("m-toggle",{detail:{name:"timeline-item-expanded",value:this.expanded}})},TimelineExpandableItem.styles=[timelineItemStyles(),timelineExpandableItemStyles()],window.customElements.define("m-timeline-expandable-item",TimelineExpandableItem),attachContextRoot();class TimelineItem extends s$5{constructor(){super(...arguments),_TimelineItem_contextProvider.set(this,new i(this,{context:timelineItemContext,initialValue:{variant:"neutral",completed:!1,active:!1}}))}static get properties(){return{completed:{type:Boolean,reflect:!0},active:{type:Boolean,reflect:!0},divider:{type:Boolean,reflect:!0},variant:{type:String,reflect:!0}}}connectedCallback(){super.connectedCallback(),this.slot="item",this.variant=this.variant??"neutral",this.active=this.active??!1,this.completed=this.completed??!1,this.divider=this.divider??!1}update(t){super.update(t),t.has("active")&&(this.active?(this.setAttribute("tabindex","0"),this.setAttribute("aria-active","step"),this.closest("m-timeline")?.requestUpdate()):(this.removeAttribute("tabindex"),this.removeAttribute("aria-active")))}updated(t){super.updated(t),(t.has("active")||t.has("completed")||t.has("variant"))&&__classPrivateFieldGet(this,_TimelineItem_contextProvider,"f").setValue({variant:this.variant??"neutral",completed:Boolean(this.completed),active:Boolean(this.active)})}render(){return x`
			<div class="side">
				<span aria-hidden="true" class="circle">
					<slot name="item-icon">
						<span class="dot"></span>
						<span class="exclamation">!</span>
						<m-icon
							class="check"
							name="check"
							size="12"
							color="color-text-inverted"
						></m-icon>
					</slot>
				</span>
				<span class="track"></span>
			</div>
			<div
				class="${o$2({content:!0,"-divider":Boolean(this.divider)})}"
			>
				<slot name="item-header"></slot>
				<slot name="item-body"></slot>
				<slot name="item-footer"></slot>
			</div>
		`}}_TimelineItem_contextProvider=new WeakMap,TimelineItem.styles=[timelineItemStyles()],window.customElements.define("m-timeline-item",TimelineItem);class TimelineItemBody extends s$5{connectedCallback(){super.connectedCallback(),this.slot="item-body",this.classList.add("m-timeline-item-body")}render(){return x`<slot></slot>`}}TimelineItemBody.styles=[timelineBodyStyles()],window.customElements.define("m-timeline-item-body",TimelineItemBody);class TimelineItemFooter extends s$5{connectedCallback(){super.connectedCallback(),this.slot="item-footer"}render(){return x`<slot></slot>`}}TimelineItemFooter.styles=[timelineFooterStyles()],window.customElements.define("m-timeline-item-footer",TimelineItemFooter);class TimelineItemHeader extends s$5{static get properties(){return{align:{type:String}}}connectedCallback(){super.connectedCallback(),this.slot="item-header"}update(t){super.update(t),t.has("align")&&this.style.setProperty("--m-timeline-item-header-align",this.align??"baseline")}render(){return x`
			<slot name="item-header-title"></slot>
			<slot name="item-header-subtitle"></slot>
			<slot></slot>
		`}}TimelineItemHeader.styles=[timelineItemHeaderStyles()],window.customElements.define("m-timeline-item-header",TimelineItemHeader);class TimelineItemHeaderSubtitle extends Text{connectedCallback(){super.connectedCallback(),this.slot="item-header-subtitle",this.variant="body-sm",this.color="color-text-tertiary"}}window.customElements.define("m-timeline-item-header-subtitle",TimelineItemHeaderSubtitle);class TimelineItemHeaderTitle extends Text{constructor(){super(),_TimelineItemHeaderTitle_context.set(this,void 0),_TimelineItemHeaderTitle_updateTextStyle.set(this,(()=>{const{value:t}=__classPrivateFieldGet(this,_TimelineItemHeaderTitle_context,"f");t&&(t.completed?(this.color="color-text-tertiary",this.variant="heading-sm"):t.active?(this.color="color-primary-60",this.variant="heading-sm-bold"):"warning"===t.variant?(this.color="color-warning-100",this.variant="heading-sm"):(this.color="color-text-secondary",this.variant="heading-sm"))})),__classPrivateFieldSet(this,_TimelineItemHeaderTitle_context,new s$2(this,{context:timelineItemContext,subscribe:!0,callback:__classPrivateFieldGet(this,_TimelineItemHeaderTitle_updateTextStyle,"f")}),"f")}connectedCallback(){super.connectedCallback(),this.slot="item-header-title",this.variant="heading-sm",this.color="color-text-tertiary"}}_TimelineItemHeaderTitle_context=new WeakMap,_TimelineItemHeaderTitle_updateTextStyle=new WeakMap,window.customElements.define("m-timeline-item-header-title",TimelineItemHeaderTitle);class TimelineItemIcon extends s$5{connectedCallback(){super.connectedCallback(),this.slot="item-icon"}render(){return x`<slot></slot>`}}TimelineItemIcon.styles=[timelineIconStyles()],window.customElements.define("m-timeline-item-icon",TimelineItemIcon);const TOGGLE_EVENT="m-toggle";function styles$3(){return[i$4`
			.toggle-group {
				inline-size: max-content;

				border: 1px solid ${getColor("color-border")};
				padding: ${getToken("spacing-1")};

				border-radius: ${getToken("border-radius-s")};
				box-sizing: border-box;

				block-size: ${getToken("global-height-default")};
			}

			.toggle-group.-small {
				block-size: ${getToken("global-height-small")};
			}

			.toggle-group.-small ::slotted(m-toggle) {
				--m-toggle-base-size: 18px;
				--m-toggle-font-size: ${getToken("font-size-2")};
				--m-toggle-icon-size: 10px;
			}

			.toggle-group.-show-check ::slotted(m-toggle[aria-checked='true']) {
				--m-toggle-icon-display: inline-flex;
			}
		`]}var _ToggleGroup_selectionController,_ToggleGroup_defaultSlot,_ToggleGroup_getToggles,_ToggleGroup_setToggleRole,_ToggleGroup_setToggleChecked,_ToggleGroup_setToggleDisabled,_Toggle_instances,_Toggle_button_get,_Toggle_handleClick,_Toggle_setDisabled,_Toggle_setChecked,_Tooltip_hoverTimeout,_Tooltip_focusTimeout,_Tooltip_handleFocus,_Tooltip_handleBlur,_Tooltip_handleClick,_Tooltip_handleKeyDown,_Tooltip_handleMouseOver,_Tooltip_handleMouseOut,_Tooltip_hasTrigger;class ToggleGroup extends s$5{static get properties(){return{disabled:{type:Boolean},role:{type:String,reflect:!0},showCheck:{type:Boolean,attribute:"show-check"},size:{type:String,reflect:!0},type:{type:String},value:{},selection:{state:!0}}}constructor(){super(),_ToggleGroup_selectionController.set(this,null),_ToggleGroup_defaultSlot.set(this,null),_ToggleGroup_getToggles.set(this,(()=>{__classPrivateFieldGet(this,_ToggleGroup_defaultSlot,"f")||__classPrivateFieldSet(this,_ToggleGroup_defaultSlot,this.shadowRoot&&this.shadowRoot.querySelector("slot"),"f");return[...__classPrivateFieldGet(this,_ToggleGroup_defaultSlot,"f")?.assignedElements({flatten:!0})??[]].filter((t=>"m-toggle"===t.tagName.toLowerCase()))})),_ToggleGroup_setToggleRole.set(this,(t=>{t.setAttribute("role",["single","single-strict"].includes(this.type)?"radio":"checkbox")})),_ToggleGroup_setToggleChecked.set(this,(t=>{t.checked=this.selection.has(t.value)})),_ToggleGroup_setToggleDisabled.set(this,(t=>{t.disabled=this.disabled})),this.showCheck=!1,this.size="default",this.type="single",this.selection=new Set}update(t){super.update(t),(null!=t.get("type")&&null!=this.type||null==__classPrivateFieldGet(this,_ToggleGroup_selectionController,"f"))&&(__classPrivateFieldSet(this,_ToggleGroup_selectionController,new SelectionController(this,this.type,"m-toggle"),"f"),__classPrivateFieldGet(this,_ToggleGroup_selectionController,"f").init(toArray$1(this.value)),this.role=["single","single-strict"].includes(this.type)?"radiogroup":"group"),t.has("value")&&__classPrivateFieldGet(this,_ToggleGroup_selectionController,"f").init(toArray$1(this.value))}updated(t){super.updated(t),t.has("selection")&&__classPrivateFieldGet(this,_ToggleGroup_getToggles,"f").call(this).forEach((t=>{__classPrivateFieldGet(this,_ToggleGroup_setToggleChecked,"f").call(this,t)})),t.has("disabled")&&__classPrivateFieldGet(this,_ToggleGroup_getToggles,"f").call(this).forEach((t=>{__classPrivateFieldGet(this,_ToggleGroup_setToggleDisabled,"f").call(this,t)})),t.has("role")&&__classPrivateFieldGet(this,_ToggleGroup_getToggles,"f").call(this).forEach((t=>{__classPrivateFieldGet(this,_ToggleGroup_setToggleRole,"f").call(this,t)}))}render(){return x`
			<m-group
				class=${o$2({"toggle-group":!0,"-single":"single"===this.type,"-single-strict":"single-strict"===this.type,"-multiple":"multiple"===this.type,"-small":"small"===this.size,"-show-check":this.showCheck})}
				gap="spacing-1"
			>
				<slot></slot>
			</m-group>
		`}}function styles$2(){return[styles$F(),i$4`
			:host {
				/*
				 * These custom properties are here because they are meant to be
				 * overriden via toggle-group styles.
				 */
				--m-toggle-base-size: 30px;
				--m-toggle-font-size: ${getToken("font-size-3")};
				--m-toggle-icon-size: 12px;
				--m-toggle-icon-display: none;

				--m-button-border-color: transparent;
				--m-button-color: ${getColor("color-primary-100")};
				--m-button-padding-x: ${getToken("spacing-2")};
				--m-button-padding-y: 0;

				--m-button-base-size: var(--m-toggle-base-size);
				--m-button-font-size: var(--m-toggle-font-size);
			}

			${on([".toggle"]).disabled} {
				--m-button-color: ${getColor("color-text-disabled")};
			}

			[aria-checked='true'] {
				--m-button-background-color: ${getColor("color-primary-20")};
			}

			${on(".toggle").not.disabled.hover} {
				--m-button-background-color: ${getColor("color-background-tertiary")};
				--m-button-border-color: ${getColor("color-background-tertiary")};
				--m-button-color: ${getColor("color-primary-100")};
			}

			.check-icon {
				--m-icon-size: var(--m-toggle-icon-size);
				--m-icon-color: var(--m-button-color);

				display: var(--m-toggle-icon-display);
			}
		`]}_ToggleGroup_selectionController=new WeakMap,_ToggleGroup_defaultSlot=new WeakMap,_ToggleGroup_getToggles=new WeakMap,_ToggleGroup_setToggleRole=new WeakMap,_ToggleGroup_setToggleChecked=new WeakMap,_ToggleGroup_setToggleDisabled=new WeakMap,ToggleGroup.styles=[styles$3()],window.customElements.define("m-toggle-group",ToggleGroup);class Toggle extends s$5{static get properties(){return{checked:{type:Boolean},disabled:{type:Boolean,reflect:!0},role:{type:String,reflect:!0},value:{type:String,reflect:!0}}}constructor(){super(),_Toggle_instances.add(this),_Toggle_handleClick.set(this,(()=>{if(this.disabled)return;this.checked=!this.checked;const t={detail:{value:this.value,type:"toggle"},bubbles:!0,composed:!1};this.dispatchEvent(new CustomEvent("m-toggle",t))})),_Toggle_setDisabled.set(this,(()=>{this.setAttribute("aria-disabled",String(this.disabled??!1))})),_Toggle_setChecked.set(this,(()=>{this.setAttribute("aria-checked",String(this.checked??!1))})),this.disabled=!1,this.checked=!1}connectedCallback(){super.connectedCallback(),this.addEventListener("click",__classPrivateFieldGet(this,_Toggle_handleClick,"f"))}disconnectedCallback(){super.disconnectedCallback(),this.removeEventListener("click",__classPrivateFieldGet(this,_Toggle_handleClick,"f"))}updated(t){super.updated(t),t.has("disabled")&&__classPrivateFieldGet(this,_Toggle_setDisabled,"f").call(this),t.has("checked")&&__classPrivateFieldGet(this,_Toggle_setChecked,"f").call(this)}render(){return x`
			<button
				type="button"
				class=${o$2({button:!0,toggle:!0})}
				role="${this.role}"
				aria-checked="${this.checked}"
				?disabled="${this.disabled}"
			>
				<slot name="leading" slot="leading">
					<m-icon name="check" class="check-icon"></m-icon>
				</slot>

				<slot></slot>
			</button>
		`}focus(t){__classPrivateFieldGet(this,_Toggle_instances,"a",_Toggle_button_get)?.focus(t)}}function trim(t){return t.trim()}function convertTriggerFromAttribute(t){return t?String(t).split(/[\s,]+/).map(trim).filter(Boolean):["hover"]}function styles$1(){return[styles$m({floatingSelector:"#floating"}),i$4`
			:host {
				--m-popover-width: max-content;
				--m-popover-min-width: 80px;
				--m-popover-max-width: 80ch;
				--m-popover-overflow-x: visible;

				display: inline-flex;
				align-items: center;
			}
		`]}_Toggle_handleClick=new WeakMap,_Toggle_setDisabled=new WeakMap,_Toggle_setChecked=new WeakMap,_Toggle_instances=new WeakSet,_Toggle_button_get=function(){return this.renderRoot?.querySelector("button")??null},Toggle.styles=[styles$2()],window.customElements.define("m-toggle",Toggle);class Tooltip extends Popover{static get properties(){return{...Popover.properties,trigger:{type:String,converter:{fromAttribute:convertTriggerFromAttribute}}}}constructor(){super(),_Tooltip_hoverTimeout.set(this,void 0),_Tooltip_focusTimeout.set(this,void 0),_Tooltip_handleFocus.set(this,(()=>{__classPrivateFieldGet(this,_Tooltip_hasTrigger,"f").call(this,"focus")&&(clearTimeout(__classPrivateFieldGet(this,_Tooltip_focusTimeout,"f")),__classPrivateFieldSet(this,_Tooltip_focusTimeout,window.setTimeout((()=>this.show()),450),"f"))})),_Tooltip_handleBlur.set(this,(()=>{__classPrivateFieldGet(this,_Tooltip_hasTrigger,"f").call(this,"focus")&&(clearTimeout(__classPrivateFieldGet(this,_Tooltip_focusTimeout,"f")),__classPrivateFieldSet(this,_Tooltip_focusTimeout,window.setTimeout((()=>this.hide()),450),"f"))})),_Tooltip_handleClick.set(this,(()=>{__classPrivateFieldGet(this,_Tooltip_hasTrigger,"f").call(this,"click")&&this.toggle()})),_Tooltip_handleKeyDown.set(this,(t=>{this.open&&"Escape"===t.key&&(t.stopPropagation(),this.hide())})),_Tooltip_handleMouseOver.set(this,(()=>{__classPrivateFieldGet(this,_Tooltip_hasTrigger,"f").call(this,"hover")&&(clearTimeout(__classPrivateFieldGet(this,_Tooltip_hoverTimeout,"f")),__classPrivateFieldSet(this,_Tooltip_hoverTimeout,window.setTimeout((()=>this.show()),450),"f"))})),_Tooltip_handleMouseOut.set(this,(()=>{__classPrivateFieldGet(this,_Tooltip_hasTrigger,"f").call(this,"hover")&&(clearTimeout(__classPrivateFieldGet(this,_Tooltip_hoverTimeout,"f")),__classPrivateFieldSet(this,_Tooltip_hoverTimeout,window.setTimeout((()=>this.hide()),450),"f"))})),_Tooltip_hasTrigger.set(this,(t=>this.trigger.includes(t))),this.position="fixed",this.placement="top-start",this.trigger=["hover","focus"]}connectedCallback(){super.connectedCallback(),this.addEventListener("blur",__classPrivateFieldGet(this,_Tooltip_handleBlur,"f"),!0),this.addEventListener("click",__classPrivateFieldGet(this,_Tooltip_handleClick,"f")),this.addEventListener("focus",__classPrivateFieldGet(this,_Tooltip_handleFocus,"f"),!0),this.addEventListener("keydown",__classPrivateFieldGet(this,_Tooltip_handleKeyDown,"f")),this.addEventListener("mouseout",__classPrivateFieldGet(this,_Tooltip_handleMouseOut,"f")),this.addEventListener("mouseover",__classPrivateFieldGet(this,_Tooltip_handleMouseOver,"f"))}disconnectedCallback(){super.disconnectedCallback(),this.removeEventListener("blur",__classPrivateFieldGet(this,_Tooltip_handleBlur,"f"),!0),this.removeEventListener("focus",__classPrivateFieldGet(this,_Tooltip_handleFocus,"f"),!0),this.removeEventListener("click",__classPrivateFieldGet(this,_Tooltip_handleClick,"f")),this.removeEventListener("keydown",__classPrivateFieldGet(this,_Tooltip_handleKeyDown,"f")),this.removeEventListener("mouseover",__classPrivateFieldGet(this,_Tooltip_handleMouseOver,"f")),this.removeEventListener("mouseout",__classPrivateFieldGet(this,_Tooltip_handleMouseOut,"f"))}getReferenceElement(){const t=this.shadowRoot.querySelector('slot[name="reference"]'),[e]=t.assignedElements({flatten:!0});return e}getFloatingElement(){return this.shadowRoot.querySelector("#floating")}getArrowElement(){return this.shadowRoot.querySelector("#arrow")}render(){return x`
			<slot name="reference" aria-describedby="floating"></slot>
			<div
				id="floating"
				role="tooltip"
				aria-live=${this.open?"polite":"off"}
			>
				${this.renderArrow()}
				<slot name="floating" aria-hidden="true"></slot>
			</div>
		`}}_Tooltip_hoverTimeout=new WeakMap,_Tooltip_focusTimeout=new WeakMap,_Tooltip_handleFocus=new WeakMap,_Tooltip_handleBlur=new WeakMap,_Tooltip_handleClick=new WeakMap,_Tooltip_handleKeyDown=new WeakMap,_Tooltip_handleMouseOver=new WeakMap,_Tooltip_handleMouseOut=new WeakMap,_Tooltip_hasTrigger=new WeakMap,Tooltip.styles=[styles$1()],window.customElements.define("m-tooltip",Tooltip);const TOOLTIP_PLACEMENT_VALUES=POPOVER_PLACEMENT_VALUES;function styles(){return i$4`
		:host {
			inline-size: var(--m-logo-size);
			block-size: var(--m-logo-size);
			display: block;
		}

		:host linearGradient {
			transform-origin: center;
		}
	`}var _LogoLoader_instances,_LogoLoader_getSize;const DEFAULT_SIZE="48";class LogoLoader extends s$5{constructor(){super(...arguments),_LogoLoader_instances.add(this)}static get properties(){return{size:{type:String,reflect:!0}}}connectedCallback(){super.connectedCallback(),this.style.setProperty("--m-logo-size",__classPrivateFieldGet(this,_LogoLoader_instances,"m",_LogoLoader_getSize).call(this))}update(t){super.update(t),t.has("size")&&this.style.setProperty("--m-logo-size",__classPrivateFieldGet(this,_LogoLoader_instances,"m",_LogoLoader_getSize).call(this))}render(){return b`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 49 48"><g opacity=".7"><mask id="a" width="49" height="16" x="0" y="32" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M32.1364 48H.5l15.1072-15.2727H48.5L33.4266 47.317c-.3323.3324-.818.683-1.2902.683Z"/></mask><g mask="url(#a)"><path fill="url(#b)" d="M-10.4091-10.9091h69.8182v69.8182h-69.8182z"/></g></g><mask id="c" width="32" height="17" x="17" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M17.9546 16.3636V0H48.5L33.2273 16.3636H17.9546Z"/></mask><g mask="url(#c)"><path fill="url(#d)" d="M-10.4091-10.9091h69.8182v69.8182h-69.8182z"/></g><g opacity=".7"><mask id="e" width="16" height="31" x="33" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M48.5 30.5455H33.2273V16.3637L48.5 0v30.5455Z"/></mask><g mask="url(#e)"><path fill="url(#f)" d="M-10.4091-10.9091h69.8182v69.8182h-69.8182z"/></g></g><mask id="g" width="16" height="48" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M15.7727 0v32.7273L.5 48V16.94c0-.4722.18803-.9226.52036-1.2571L15.7727 0Z"/></mask><g mask="url(#g)"><path fill="url(#h)" d="M-10.4091-10.9091h69.8182v69.8182h-69.8182z"/></g><defs><linearGradient id="b" x1="3.56649" x2="53.8665" y1="50.4164" y2=".131295" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/><animateTransform attributeName="gradientTransform" dur="0.8s" repeatCount="indefinite" type="rotate" values="0; 360"/></linearGradient><linearGradient id="d" x1="3.56649" x2="53.8665" y1="50.4164" y2=".131295" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/><animateTransform attributeName="gradientTransform" dur="0.8s" repeatCount="indefinite" type="rotate" values="0; 360"/></linearGradient><linearGradient id="f" x1="3.56649" x2="53.8665" y1="50.4164" y2=".131295" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/><animateTransform attributeName="gradientTransform" dur="0.8s" repeatCount="indefinite" type="rotate" values="0; 360"/></linearGradient><linearGradient id="h" x1="3.56649" x2="53.8665" y1="50.4164" y2=".131295" gradientUnits="userSpaceOnUse"><stop offset=".1" stop-color="#00D7D7"/><stop offset="1" stop-color="#84F11E"/><animateTransform attributeName="gradientTransform" dur="0.8s" repeatCount="indefinite" type="rotate" values="0; 360"/></linearGradient></defs></svg>`}}_LogoLoader_instances=new WeakSet,_LogoLoader_getSize=function(){const t=parseInt(this.size??"48",10);return Number.isNaN(t)?"48px":`${t||"48"}px`},LogoLoader.styles=[styles()],window.customElements.define("m-logo-loader",LogoLoader);export{EmptyStateHeader as $,Accordion as A,BackButton as B,Card as C,Dialog as D,DialogActionPrimary as E,DialogActionSecondary as F,DialogActionTertiary as G,DialogActions as H,DialogBody as I,DialogClose as J,DialogFooter as K,DialogHeader as L,Divider as M,Drawer as N,DRAWER_SIZES as O,DrawerActionPrimary as P,DrawerActionSecondary as Q,DrawerActionTertiary as R,DrawerActions as S,DrawerBody as T,DrawerClose as U,DrawerHeader as V,Dropdown as W,DropdownTrigger as X,DropdownMenu as Y,DropdownItem as Z,EmptyStateAction as _,AccordionTitle as a,TextField as a$,EmptyStateIllustration as a0,EmptyStateMessage as a1,EmptyState as a2,EMPTY_STATE_VARIANTS as a3,Field as a4,FieldHint as a5,FieldLabel as a6,FIELD_STATUSES as a7,Header as a8,HeaderActions as a9,PageContent as aA,Pagination as aB,ProgressBar as aC,ProgressBarCountdown as aD,Radio as aE,RadioGroup as aF,Section as aG,SectionTitle as aH,SpinnerWheel as aI,Steps as aJ,Step as aK,Switch as aL,Table as aM,defaultTableProps as aN,TableHead as aO,TableBody as aP,TableFoot as aQ,TableRow as aR,TableToolbar as aS,TableCell as aT,defaultTableCellProps as aU,Tabs as aV,Tab as aW,TabPanel as aX,Tag as aY,Text as aZ,TextArea as a_,HeaderContent as aa,HeaderTitle as ab,SubHeader as ac,Label as ad,defaultLabeledValueProps as ae,LabeledValue as af,LabeledValueLabel as ag,LabeledValueValue as ah,ALIGN_ITEMS_VALUES as ai,JUSTIFY_CONTENT_VALUES as aj,Box as ak,defaultBoxProps as al,Group as am,defaultGroupProps as an,Stack as ao,defaultStackProps as ap,Grid as aq,defaultGridProps as ar,Sidebar as as,defaultSidebarProps as at,Switcher as au,defaultSwitcherProps as av,Container as aw,Row as ax,Column as ay,Link as az,b,Timeline as b0,TimelineExpandableItem as b1,TimelineItem as b2,TimelineItemBody as b3,TimelineItemFooter as b4,TimelineItemHeader as b5,TimelineItemHeaderSubtitle as b6,TimelineItemHeaderTitle as b7,TimelineItemIcon as b8,ToggleGroup as b9,Toggle as ba,Tooltip as bb,TOOLTIP_PLACEMENT_VALUES as bc,LogoLoader as bd,AccordionContent as c,Badge as d,BannerActionPrimary as e,BannerActionSecondary as f,BannerActions as g,BannerDescription as h,BannerIcon as i,BannerTitle as j,Banner as k,Body as l,Button as m,CardBody as n,CardSubtitle as o,CardTitle as p,CardDivider as q,CardFooter as r,CardActionPrimary as s,typographyVariants as t,CardActionSecondary as u,CardActionTertiary as v,Checkbox as w,CloseButton as x,DIALOG_SIZES as y,DIALOG_VARIANTS as z};
//# sourceMappingURL=index-eJ-u2Xkz.js.map
